const dictionary = {
	'Customer information not found': 'Informações do cliente não encontradas',
	'Account subscription expired, renew to continue.': 'A assinatura da conta expirou, renove para continuar.',
	'Account subscription cancelled, renew to continue.': 'Assinatura da conta cancelada, renove para continuar.',

	Warning: 'Atenção',
	'View video': 'Consultar vídeo',
	Yes: 'Sim',
	No: 'Não',
	'Frequency and load': 'Frequência e carga',
	'Movement frequency': 'Frequência do movimento',
	'Select the maximum number of times the movement is performed per activity and workday':
		'Selecione a quantidade máxima de vezes que o movimento é realizado por atividade e dia de trabalho',
	Men: 'Homens',
	Women: 'Mulheres',
	'Load transport in pairs?': 'Transporte de carga em pares?',
	'Load inclination?': 'Há inclinação de carga?',
	'Effective load weight': 'Peso efetivo da carga',
	'Effective load weight tooltip':
		'O peso efetivo da carga corresponde ao esforço físico realmente exercido. Ao inclinar uma caixa, 50% do peso é aplicado; ao transportar em duplas, 60% afeta cada pessoa.',
	'Load handling conditions': 'Condições de manuseio de carga',
	'Load handled with both hands symmetrically': 'A carga é manuseada com ambas as mãos e de forma simétrica',
	'Load handled temporarily with one hand or asymmetrically with unequal weight distribution':
		'A carga é manuseada temporariamente com uma das mãos e/ou de forma assimétrica, com distribuição desigual do peso entre as duas mãos',
	'Load handled predominantly with one hand or has unstable center of balance':
		'A carga é manuseada predominantemente com uma das mãos ou possui centro de equilíbrio instável',
	'Partial result': 'Resultado parcial',
	Posture: 'Postura',
	'Body posture': 'Postura corporal',
	'Body posture tooltip':
		'O movimento pode ocorrer em ambas as direções; as posturas podem indicar início ou término da operação. Quando houver várias posturas na mesma opção, todas representam a mesma condição.',
	'Select the option that represents the posture at the start and end of the operation':
		'Selecione a opção que representa as posturas de início e término da operação',
	'Additional factors': 'Fatores adicionais',
	'Occasional identifiable trunk twisting and/or lateral bending':
		'Torção e/ou inclinação lateral ocasional do tronco identificável',
	'Frequent or constant identifiable trunk twisting and/or lateral bending':
		'Torção e/ou inclinação lateral frequente ou constante do tronco identificável',
	'Load center and/or hands occasionally away from the body':
		'Centro de carga e/ou mãos ocasionalmente afastados do corpo',
	'Load center and/or hands frequently or constantly away from the body':
		'Centro de carga e/ou mãos frequentemente ou constantemente afastados do corpo',
	'Arms occasionally elevated, with hands between elbow and shoulder level':
		'Braços ocasionalmente elevados, com as mãos entre o nível do cotovelo e do ombro',
	'Arms frequently or constantly elevated, with hands between elbow and shoulder level':
		'Braços frequentemente ou constantemente elevados, com as mãos entre o nível do cotovelo e do ombro',
	'Hands occasionally above shoulder height': 'Mãos ocasionalmente acima da altura dos ombros',
	'Hands frequently or constantly above shoulder height':
		'Mãos frequentemente ou constantemente acima da altura dos ombros',

	// KIM-LHC Work Condition
	'Work Condition': 'Condições de trabalho',
	'Unfavorable work conditions': 'Condições de trabalho desfavoráveis',
	'Hand/arm position and movements': 'Posição e movimentos das mãos/braços',
	'Occasionally at the limit of range of motion': 'Ocasionalmente no limite da amplitude de movimento',
	'Frequently/constantly at the limit of range of motion':
		'Frequentemente/constantemente no limite da amplitude de movimento',
	'Force transfer/application': 'Transferência/aplicação de força',
	Restricted: 'Restrita',
	'Loads difficult to hold / greater holding force required / absence of molded handles / use of work gloves':
		'Cargas difíceis de segurar / maior força de sustentação necessária / ausência de pegadores moldados / uso de luvas de trabalho',
	'Considerably hindered': 'Consideravelmente dificultada',
	'Loads almost impossible to hold / slippery, soft or sharp edges surfaces / absence or inadequacy of grips / use of work gloves':
		'Cargas quase impossíveis de segurar / superfícies escorregadias, macias ou com bordas cortantes / ausência ou inadequação de pegadores / uso de luvas de trabalho',
	'Adverse environmental conditions': 'Condições ambientais adversas',
	'Unfavorable climatic conditions and/or physical loads caused by heat, wind, cold or humidity':
		'Condições climáticas desfavoráveis e/ou cargas físicas causadas por calor, vento, frio ou umidade',
	'Spatial conditions': 'Condições espaciais',
	'Work area less than 1.5 m², moderately dirty floor and slightly uneven floor, slight slope up to 5°, slightly restricted stability, load must be positioned with precision':
		'Área de trabalho menor que 1,5 m², piso moderadamente sujo e levemente irregular, inclinação leve de até 5°, estabilidade ligeiramente restrita, carga deve ser posicionada com precisão',
	Unfavorable: 'Desfavoráveis',
	'Significantly restricted freedom of movement or insufficient space for movement, work in confined spaces, very dirty, uneven or roughly paved floor, steps/holes, steep slope of 5–10°, restricted stability, load must be positioned with great precision':
		'Liberdade de movimento significativamente restrita ou espaço insuficiente para movimentação, trabalho em espaços confinados, piso muito sujo, irregular ou grosseiramente calçado, degraus/buracos, inclinação acentuada de 5–10°, estabilidade restrita, carga deve ser posicionada com muita precisão',
	Clothing: 'Roupas',
	'Additional physical effort due to heavy clothing or equipment that restricts movement (such as, heavy rain protection clothing, full protective clothing, breathing equipment, tool belts or similar)':
		'Esforço físico adicional devido a roupas ou equipamentos que dificultam os movimentos (por exemplo, ao usar capas de chuva pesadas, roupas de proteção integral, equipamentos de proteção respiratória, cintos de ferramentas ou similares)',
	'Holding/carrying': 'Segurar/carregar',
	Difficulty: 'Dificuldade',
	'The load must be held for more than 5 to 10 seconds or carried to a distance of more than 2 m to 5 m':
		'A carga precisa ser mantida por mais de 5 até 10 segundos ou transportada por uma distância de mais de 2 m até 5 m',
	'Significant difficulty': 'Dificuldade significativa',
	'The load must be held for more than 10 seconds or carried to a distance of more than 5 m':
		'A carga precisa ser mantida por mais de 10 segundos ou transportada por uma distância superior a 5 m',
	'Hand/arm position and movements occasional': 'Posição e movimentos de mão/braço ocasionais',
	'Hand/arm position and movements frequent': 'Posição e movimentos de mão/braço frequentes',
	'Force transfer/application restricted': 'Transferência/aplicação de força restrita',
	'Force transfer/application considerably hindered':
		'Transferência/aplicação de força consideravelmente prejudicada',
	'Adverse environmental conditions unfavorable climatic': 'Condições ambientais adversas com clima desfavorável',
	'Spatial conditions restricted': 'Condições espaciais restritas',
	'Spatial conditions unfavorable': 'Condições espaciais desfavoráveis',
	Clothes: 'Vestuário',
	'Hold/carry difficulty': 'Dificuldade para segurar/carregar',
	'Hold/carry significant difficulty': 'Dificuldade significativa para segurar/carregar',

	'Ergonomic Work Analysis': 'Análise Ergonômica do Trabalho',
	'Ergonomic Workplace Analysis': 'Análise Ergonômica do Local de Trabalho',
	'Type of report': 'Tipo de relatório',
	until: 'até',

	Companies: 'Empresas',
	'Corrupted file': 'Arquivo corrompido',
	'Extracted data': 'Dados extraídos',
	'Not processing': 'Não processado',
	Processing: 'Processando',
	Processed: 'Processado',
	'In queue': 'Em fila',

	// Upload
	'Send video': 'Enviar vídeo',
	'Add files or drag': 'Adicionar arquivos ou arraste',
	'Unsupported file': 'Arquivo não suportado',
	'Drop files here': 'Solte os arquivos aqui',
	'Unsupported video format': 'Formato de video não é suportado',
	and: 'e',
	'is larger than': 'É maior que',
	'Max size': 'Tamanho máximo',
	'Image description': 'Descrição da imagem',
	'Image description updated successfully': 'Descrição da imagem atualizada com sucesso',
	'Are you sure you want to delete this image?': 'Tem certeza de que deseja excluir esta imagem?',
	'Image deleted successfully': 'Imagem excluída com sucesso',
	'Error deleting image': 'Erro ao excluir imagem',
	Blur: 'Desfoque',
	'Are you sure you want to exit? You have an uploads in process.':
		'Tem certeza que deseja sair ? Você tem um uploads em processo.',
	'User created with success': 'Usuário criado com sucesso',
	'File duplicated': 'Arquivo duplicado',
	'Files number exceeded': 'Número de arquivos excedido',

	// Select project
	'Select the desired company below': 'Selecione a empresa desejada abaixo',
	'Select the desired industrial site below': 'Selecione a planta industrial desejada abaixo',

	'Create a new company': 'Crie uma nova empresa',
	'Create a new industrial site': 'Crie uma nova planta industrial',

	'Enter a name for the company': 'Insira um nome para a empresa',
	'Enter a name for the industrial site': 'Insira um nome para a planta industrial',

	'Company created successfully': 'Empresa criada com sucesso',
	'Industrial site created successfully': 'Planta industrial criada com sucesso',

	'There are no registered companies': 'Não há empresas cadastradas',
	'There are no registered industrial sites': 'Não existe nenhuma planta industrial cadastrada.',

	'Failed to fetch information': 'Falha ao buscar informações',

	'Congratulations! Now create an industrial site that belongs to this company.':
		'Parabéns! Agora crie a planta industrial que pertence a essa empresa e comece a utilizar a plataforma',
	'Create industrial site': 'Criar planta industrial',

	'Welcome to Kinebot, create your first company': 'Bem vindo ao Kinebot, crie sua primeira empresa.',
	'Create company': 'Criar empresa',

	'Go back': 'Voltar',
	Back: 'Voltar',
	Create: 'Criar',

	'Ergonomic tools': 'Ferramentas ergonômicas',
	'Select the most suitable tool for your analysis': 'Selecione a ferramenta mais adequada para sua análise',
	'Biomechanical analysis': 'Análise biomecânica',
	'Load analysis': 'Análise de cargas',
	'Repeatability analysis': 'Análise de repetitividade',

	// Report/UploadList
	Workstation: 'Posto de trabalho',
	Description: 'Descrição',
	Size: 'Tamanho',
	'Upload date': 'Data de upload',
	Status: 'Status',
	Sector: 'Setor',
	Rating: 'Classificação',
	Actions: 'Ações',
	Action: 'Ações',
	'Not assigned': 'Não atribuido',
	'Heads up!': 'Atenção!',
	'Heads up! Want to delete this file?': 'Atenção! Deseja excluir este arquivo?',
	'Heads up! Want to delete this report?': 'Atenção! Deseja excluir este relatório?',
	'Heads up! Want to delete this action plan?': 'Atenção! Deseja excluir este plano de ação?',
	'Heads up! Want to delete this workstation?': 'Atenção! Deseja excluir este posto de trabalho?',
	'Heads up! Want to delete this line? All workstations related to it will be lost.':
		'Atenção! Deseja excluir esta linha? Todos postos de trabalho relacionados a ela serão perdidos',
	'Heads up! Want to delete this sector? All lines and workstations related to it will be lost.':
		'Atenção! Deseja excluir este setor? Todas as linhas e postos de trabalho relacionados a ele serão perdidos',
	'Heads up! Want to delete this industrial site? All sectors, lines and workstations related to it will be lost.':
		'Atenção! Deseja excluir esta planta industrial? Todos setores, linhas e postos de trabalho relacionados a ela serão perdidos',
	'Force/Charge movement data': 'Dados sobre movimento com Força/Carga',

	Repetitions: 'Repetições',
	'Repetitions per minute': 'Repetições por minuto',
	Legs: 'Pernas',
	Diagnostic: 'Diagnóstico',
	'Analysis results': 'Resultados da análise',

	'Not found': 'Não encontrado',
	Light: 'Leve',
	'Failed to fetch data': 'Falha ao buscar os dados.',
	//'Risk level of the job': 'Grau de risco do posto de trabalho',
	'Average exposure of the workplace': 'Média de exposição do posto de trabalho',
	'Unable to show results.': 'Não foi possível mostrar os resultados.',

	'Load less than 2 kg (intermittent)': 'Carga menor de 2 kg (intermitente)',
	'Load from 2 kg to 10 kg (intermittent)': 'Carga de 2 kg a 10 kg (intermitente)',
	'Load from 2 kg to 10 kg (static or repetitive)': 'Carga de 2 kg a 10 kg (estático ou repetitivo)',
	'Bigger load 10 kg of repetitive load or blows': 'Carga maior 10 kg de carga repetitivos ou pancadas',
	'Legs and feet supported and with equal load distribution':
		'As pernas e pés apoiados e com igual distribuição de carga',
	'Legs without support': 'Pernas sem apoio',

	Reports: 'Relatórios',
	'Select the data visualization model': 'Selecione o modelo de visualização dos dados',
	Angle: 'Ângulo',
	'Angle in degrees (°)': 'Ângulo em graus (°)',
	'Time in seconds (s)': 'Tempo em segundos (s)',
	Parameters: 'Parâmetros',
	'Manual lifting': 'Levantamento de cargas',
	'NIOSH / ISO 11228-1 - Manual lifting analysis': 'NIOSH / ISO 11228-1 - Análise de levantamento manual de cargas',
	'Push and pull': 'Empurrar e puxar',
	'KIM - Push and pull': 'KIM - Empurrar e puxar',
	'KIM - PP Report Results': 'KIM - EP Relatório de Resultados',
	meters: 'metros',
	'Temporal distribution': 'Distribuição temporal',
	Distance: 'Distância',
	'Working conditions': 'Condições de trabalho',
	'Vehicle properties': 'Propriedades veículo',
	Vehicle: 'Veículo',
	'Vehicle: ': 'Veículo: ',
	'Distance or duration': 'Distância ou duração',

	'Select one of the options below': 'Selecione uma das opções abaixo',
	'Short distances': 'Distâncias curtas',
	'Long distances': 'Distâncias longas',
	Time: 'Tempo',
	Mass: 'Massa',
	'Mass: ': 'Massa: ',
	Precision: 'Precisão',
	'Worker gender': 'Gênero do trabalhador',
	'Pushing / Pulling in pairs': 'Empurrando / Puxando em pares',
	'By distance': 'Pela distância',
	'By duration': 'Pela duração',
	'Distance per work day (in meters)': 'Distância por dia de trabalho (em metros)',
	'Duration per work day (in minutes)': 'Duração por dia de trabalho (em minutos)',
	'≤ 40': '≤ 40',
	'≤ 200': '≤ 200',
	'≤ 400': '≤ 400',
	'≤ 800': '≤ 800',
	'≤ 1,200': '≤ 1.200',
	'≤ 1,800': '≤ 1.800',
	'≤ 2,500': '≤ 2.500',
	'≤ 4,200': '≤ 4.200',
	'≤ 6,300': '≤ 6.300',
	'≤ 8,400': '≤ 8.400',
	'≤ 11,000': '≤ 11.000',
	'≤ 15,000': '≤ 15.000',
	'≤ 20,000': '≤ 20.000',
	'≤ 1': '≤ 1',
	'≤ 5': '≤ 5',
	'≤ 10': '≤ 10',
	'≤ 20': '≤ 20',
	'≤ 30': '≤ 30',
	'≤ 45': '≤ 45',
	'≤ 60': '≤ 60',
	'≤ 100': '≤ 100',
	'≤ 150': '≤ 150',
	'≤ 210': '≤ 210',
	'≤ 270': '≤ 270',
	'≤ 360': '≤ 360',
	'≤ 480': '≤ 480',
	'Select one of the vehicles': 'Selecione um dos veículos',
	Barrows: 'Carrinhos de mão',
	Carriages: 'Carros de transporte',
	'Overhead conveyors': 'Transportadores',
	'Overhead cranes': 'Guindastes',
	'Choose an option': 'Escolha uma opção',
	'Reference image: only swivel castors': 'Imagem de referência: apenas rodas móveis',
	'Reference image: with fixed castors or lockable swivel castors':
		'Imagem de referência: com rodas fixas ou que podem ser travadas',
	'Reference image: pedestrian-controlled': 'Imagem de referência: controlados por pedestre',
	'Driveway conditions': 'Condições da calçada',
	'Inclination or stairs': 'Inclinação ou escadas',
	'Select the mass to be transported (in kg)': 'Selecione a massa a ser transportada (em kg)',
	'Driveway completely level, smooth, solid, dry, without inclinations':
		'Calçada completamente nivelada, lisa, sólida, seca, sem inclinações',
	'Driveway mostly smooth and level, with small damaged spots/faults, without inclinations':
		'Calçada quase lisa e nivelada, com pequenas danificações em alguns pontos, sem inclinações',
	'Mixture of cobbles, concrete, asphalt, slight inclinations, dropped kerb':
		'Mistura de paralelepípedos, concreto, asfalto, inclinações leves, meio-fio rebaixado',
	'Mixture of roughly cobbled, hard sand, slight inclinations, small edges/sills':
		'Mistura rude de paralelepípedos, areia dura, inclinações leves e pequenas arestas/soleiras',
	'Earth or roughly cobbled driveway, potholes, heavy soiling, slight inclinations, landings, sills':
		'Mistura rude de terra ou paralelepípedos, buracos, sujeira pesada, pequenas inclinações, aterragem, soleiras',
	'Inclinations of 2 ≤ 4° (4 ≤ 8%)': 'Inclinações de 2 ≤ 4° (4 ≤ 8%)',
	'Inclinations of 5 ≤ 10° (9 ≤ 18%)': 'Inclinações de 5 ≤ 10° (9 ≤ 18%)',
	'Stairs, inclinations > 10° (18%)': 'Escadas, inclinações > 10° (18%)',
	'No significant inclination': 'Sem inclinação relevante',
	'≤ 50': '≤ 50',
	'≤ 300': '≤ 300',
	'≤ 600': '≤ 600',
	'≤ 1,000': '≤ 1.000',
	'≤ 1,300': '≤ 1.300',
	'> 1,300': '> 1.300',
	'Select the appropriate options': 'Selecione a opção apropriada',
	'Unfavorable working conditions - more than one can be selected':
		'Condições de trabalho desfavoráveis - mais de uma opção pode ser selecionada',
	'Unfavorable vehicle properties - more than one can be selected':
		'Propriedades desfavoráveis do veículo - mais de uma opção pode ser selecionada',
	'Unfavorable working conditions': 'Condições de trabalho desfavoráveis',
	'Unfavorable vehicle properties': 'Propriedades desfavoráveis do veículo',
	'Regularly significantly increased starting forces, because transport devices sink into the ground or get wedged':
		'Regularmente necessária uma força considerável para iniciar movimentação, devido ao veículo afundar no chão ou ficar travado',
	'Frequent stops with breaking': 'Paradas frequentes com freagem',
	'Frequent stops without breaking': 'Paradas frequentes sem freagem',
	'Many changes of direction or curves, frequent manouvering':
		'Muitas mudanças de direção ou curvas, manobramento frequente',
	'Load must be positioned precisely and stopped, driveway must be adhered to precisely':
		'Carga precisa ser posicionada precisamente e fixada, aderindo um lugar exato da calçada',
	'Increased movement speed (approx. 1.0 ≤ 1.3 m/s)': 'Velocidade de movimento elevada (aprox. 1.0 ≤ 1.3 m/s)',
	'None: there are no unfavorable working conditions': 'Nenhuma: não há condições de trabalho desfavoráveis',
	'No suitable handles or construction parts for applying force':
		'Não há alças ou partes adequadas para aplicação de força',
	'No brake when driving on inclinations > 2° (> 3%)': 'Sem freios quando manuseando ou inclinações > 2° (> 3%)',
	'Unadjusted castors (e.g. too small on soft or uneven floor)':
		'Rodas mal ajustadas (ex.: pequenas demais ou não condizem com o piso)',
	'Defective castors (worn-out, rubbing, stiff, air pressure too low)':
		'Rodas defeituosas (desgastadas, com fricção, travadas, pressão de ar muito baixa)',
	'None: there are no unfavorable properties of the transport devices':
		'Nenhuma: não há propriedades desfavoráveis do veículo',

	'Trunk upright or slightly inclined forward, no twisting / Force application height can be selected freely / No hindrance for the legs':
		'Tronco ereto ou levemente inclinado para frente, sem torção / Força de aplicação com altura selecionada livremente / Sem complicação para as pernas',
	'Body inclined towards the direction of movement or slight twisting when pulling the load on one side / Fixed force application height ranging from 0.9 – 1.2 m / No or only slight hindrance for the legs / Predominantly pulling':
		'Corpo inclinado na direção do movimento ou levemente torcido puxando a carga de lado / Aplicação de força na altura fixa de 0.9 - 1.2m / Nenhuma ou pequena complicação para as pernas / Predominantemente puxando',
	'Awkward body postures caused by fixed force application height < 0.9 or > 1.2 m , lateral force application on one side or significantly obstructed view / Significant hindrance for the legs / Constant twisting and/or lateral inclination of the trunk':
		'Posturas corporais estranhas causadas por força na altura fixa de < 0.9 ou > 1.2m, aplicação de força lateral em um lado ou com vista significantemente obstruída / Complicação considerável para as pernas / Torção constante e/ou inclinação lateral do tronco',

	'Trunk upright or slightly inclined forward, no twisting':
		'Tronco ereto ou levemente inclinado para frente, sem torção',
	'Body inclined towards the direction of movement or slight twisting when pulling the load on one side':
		'Corpo inclinado na direção do movimento ou levemente torcido puxando a carga de lado',
	'Awkward body postures caused by fixed force application height < 0.9 or > 1.2 m , lateral force application on one side or significantly obstructed view':
		'Posturas corporais estranhas causadas por força na altura fixa de < 0.9 ou > 1.2m, aplicação de força lateral em um lado ou com vista significantemente obstruída',

	'Force application height can be selected freely': 'Força de aplicação com altura selecionada livremente',
	'Fixed force application height ranging from 0.9 – 1.2 m': 'Aplicação de força na altura fixa de 0.9 - 1.2m',
	'Significant hindrance for the legs': 'Complicação considerável para as pernas',

	'No hindrance for the legs': 'Sem complicação para as pernas',
	'No or only slight hindrance for the legs': 'Nenhuma ou pequena complicação para as pernas',
	'Constant twisting and/or lateral inclination of the trunk': 'Torção constante e/ou inclinação lateral do tronco',

	'Predominantly pulling': 'Predominantemente puxando',

	Postures: 'Posturas',
	'Direction of force': 'Direção da força',
	Unfavorable: 'Desfavorável',
	'Score and risk assessment': 'Score e definição do risco',
	'Intensity of load: ': 'Intensidade da carga',
	'Probability of physical overload / Possible health consequences: ':
		'Probabilidade de sobrecarga física / Possíveis consequências de saúde: ',
	'Physical overload is unlikely / No health risk is to be expected.':
		'Sobrecarga física é improvável / Sem risco de saúde esperado.',
	'No health risk is to be expected': 'Sem risco de saúde esperado',
	'Physical overload is possible for less resilient persons /  Fatigue, low-grade adaptation problems which can be compensated for during leisure time.':
		'Sobrecarga física é possível para pessoas menos resistentes / Fadiga, pequenos problemas de adaptação que podem ser compensados com tempo de descanso.',
	'Physical overload is possible for less resilient persons':
		'Sobrecarga física é possível para pessoas menos resistentes',
	'Fatigue, low-grade adaptation problems which can be compensated for during leisure time':
		'Fadiga, pequenos problemas de adaptação que podem ser compensados com tempo de descanso.',
	'Physical overload is also possible for normally resilient persons / Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'Sobrecarga física é possível mesmo para pessoas com resistência normal / Distúrbios (dor), possibilidade de disfunções, reversível na maioria dos casos, sem manifestação morfológica',
	'Physical overload is also possible for normally resilient persons':
		'Sobrecarga física é possível mesmo para pessoas com resistência normal',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'Distúrbios (dor), possibilidade de disfunções, reversível na maioria dos casos, sem manifestação morfológica',
	'Physical overload is likely / More pronounced disorders and/or dysfunctions, structural damage with pathological significance':
		'Sobrecarga física é provável / Distúrbios acentuados e/ou disfunções, dano estrutural com significância patológica',
	'More pronounced disorders and/or dysfunctions, structural damage with pathological significance':
		'Distúrbios acentuados e/ou disfunções, dano estrutural com significância patológica',
	'Measures: ': 'Medidas: ',
	' For less resilient persons, workplace redesign and other prevention measures may be helpful.':
		' Para as pessoas menos resitentes, trocar o local de trabalho e outras medidas de prevenção podem ser de ajuda.',
	' Workplace redesign and other prevention measures should be considered.':
		' Trocar o local de trabalho e outras medidas de prevenção devem ser consideradas.',
	' Workplace redesign measures are necessary. Other prevention measures should be considered.':
		' Trocar o local de trabalho é necessário. Outras medidas de prevenção também devem ser consideradas.',
	None: 'Nenhuma',
	Results: 'Resultados',

	Information: 'Informações',
	'Body parts': 'Partes do corpo',
	Charts: 'Gráficos',

	'Industrial Site': 'Planta industrial',
	'Collection date': 'Data de coleta',
	'Risk range': 'Faixa de risco',
	'Risk Range': 'Faixa de risco',
	'Day duration': 'Duração do dia de trabalho',
	'times/day': 'vezes/dia',
	'Trunk rotation': 'Rotação do tronco',
	'Load center': 'Centro da carga',
	'Arms elevated': 'Braços elevados',
	'Hands above shoulder': 'Mãos acima do ombro',
	Activity: 'Atividade',
	Evaluator: 'Avaliador',

	'Failed to fetch sectors': 'Falha ao buscar os setores',
	'Failed to create a new sector': 'Falha ao criar um novo setor',
	'Failed to fetch risk bands': 'Falha ao buscar as faixas de risco',
	'Sector created successfully': 'Setor criado com sucesso',
	'Line created successfully': 'Linha criada com sucesso',
	'Workstation created successfully': 'Posto de trabalho criado com sucesso',
	'TLID created successfully': 'TLID criada com sucesso',
	'Evaluator created successfully': 'Avaliador criado com sucesso',
	'Cycle created successfully': 'Ciclo criado com sucesso',

	'Select a sector': 'Selecione o setor',
	'Insert a workstation': 'Insira o posto de trabalho',
	'Insert the date of collection': 'Insira a data da coleta',
	'Select a risk band': 'Selecione uma faixa de risco',
	'Graphs of selected body parts': 'Gráficos das partes do corpo selecionadas',

	Summary: 'Resumo',
	'Range of Risk': 'Faixa de risco',
	'Job information': 'Informação de trabalho',
	'File data': 'Dados do arquivo',
	'Collected Information': 'Informações Coletadas',

	File: 'Arquivo',
	Duration: 'Duração',
	'Relevant points': 'Pontos relevantes',
	Frequency: 'Frequência',
	'Most critical move': 'Movimento mais crítico',
	'Include conclusion': 'Incluir conclusão',
	'Include signature': 'Incluir assinatura',
	'Insert conclusion': 'Inserir conclusão',
	'Risk track created successfully!': 'Faixa de risco criada com sucesso!',
	'Create custom risk bands based on your analysis':
		'Crie faixas de riscos personalizadas de acordo com as suas análises',

	//Dashboard
	'Industrial site status': 'Status da planta industrial',
	'Harmful postures': 'Posturas lesivas',
	'Inadequate postures': 'Posturas inadequadas',
	'Workstation with good postures': 'Postos com boas posturas',
	'Workers in real danger': 'Trabalhadores em risco real',
	'Total of videos': 'Total de vídeos',
	'Processed minutes': 'Minutos processados',
	'Critical sector': 'Setor crítico',
	'Registered sectors': 'Setores cadastrados',
	'Exported reports': 'Relatórios extraídos',
	'Sectors in alert': 'Setores em alerta',
	'Main statistics': 'Estatísticas principais',
	'No. of videos by risk level': 'Total de vídeos por grau de risco',
	Month: 'Mês',
	Year: 'Ano',
	Day: 'Dia',
	'Assessments completed': 'Avaliações completas',
	'Videos by sector': 'Vídeos por setores',
	'Percentage of videos by risk': 'Percentual de vídeos por risco',
	'Ergonomics Management': 'Gestão de Ergonomia',
	'Risk Quotation': 'Cotação de Risco',
	'Total workstations': 'Total de postos',
	'Total pending evaluations': 'Total de avaliações pendentes',
	'Total evaluations consolidated': 'Total de avaliações consolidadas',
	Evaluations: 'Avaliações',
	'Not analyzed': 'Não analisados',
	'Unit overview': 'Visão geral da unidade',
	'There is nothing to access.': 'Não há nada para acessar.',
	'There is no data': 'Não há dados',
	'of the workstation are': 'dos postos de trabalho são',
	'There are no registered action plans': 'Não há planos de ação registrados',
	'Not applicable': 'Não aplicável',
	'Acceptable Risk': 'Risco aceitável',
	'Acceptable risk': 'Risco aceitável',
	'Moderate Risk': 'Risco moderado',
	'Moderate risk': 'Risco moderado',
	'High Risk': 'Risco elevado',
	'Very high risk': 'Risco muito elevado',
	'Serious and imminent risk': 'Risco grave e iminente',
	'High risk': 'Risco elevado',
	'Very High Risk': 'Risco muito elevado',
	'Extreme and Imminent Risk': 'Risco grave e iminente',
	'Serious and Imminent Risk': 'Risco grave e iminente',
	'Serious risk': 'Risco grave',
	'Serious and imminent': 'Grave e iminente',
	'Not GNS': 'Sem GNS',

	// Dashboard Filter
	Lines: 'Linhas',
	'Select the line': 'Selecione a linha',
	'Select the Workstation': 'Selecione o Posto de Trabalho',
	'Working Population': 'População trabalhadora',
	Others: 'Outros',
	'Stress Level': 'Nível de Estresse',
	'Risk Level': 'Nível de Risco',

	// Dashboard Tools Results
	Repetitiveness: 'Repetitividade',
	'Cargo Handling': 'Manuseio de Carga',
	'Work Organization': 'Organização do Trabalho',
	'Score by workstation': 'Índice por posto de trabalho',
	'Total evaluations': 'Total de avaliações',
	// Dashboard Movement by score
	'Movement by score': 'Percentual de Exposição',
	'Risk per Workstation': 'Risco por posto de trabalho',

	// Dashboard Workstations
	Workstations: 'Postos de trabalho',
	'Higher workstation risk score': 'Maior índice de risco do posto de trabalho',
	'Workstation score': 'Nota do posto',

	// Dashboard Action Plans
	'Action plans': 'Planos de ação',
	'Action plan': 'Plano de ação',
	'Create actions to address the problems encountered': 'Crie ações para resolver os problemas encontrados',
	'Planned Actions': 'Ações previstas',
	Completed: 'Concluídas',
	Concluded: 'Concluído',
	'Order by deadline': 'Ordenar por prazo',
	'Order by worst score': 'Ordenar por score',
	Ascending: 'Crescente',
	Descending: 'Decrescente',
	'Deadline : ': 'Prazo : ',

	// Buttons
	Next: 'Avançar',
	Previous: 'Voltar',
	delete: 'excluir',
	Delete: 'Excluir',

	'Do you really want to delete these tracks?': 'Deseja realmente exlcuir essas faixas ?',
	'Heads up! the deletion is permanent': 'Atenção! a exclusão é permanente',
	'Risk ranges deleted successfully': 'Faixas de risco excluídas com sucesso',

	'Description (optional)': 'Descrição (opcional)',

	// Body parts
	Neck: 'Pescoço',
	Trunk: 'Tronco',
	UpperArm: 'Ombro',
	LowerArm: 'Cotovelo',

	'Customize bands of risk': 'Personalize faixas de risco',
	'Create custom risk strips according to your needs.':
		'Crie faixas de riscos personalizadas de acordo com as suas necessidades.',

	Name: 'Nome',
	'Industrial site name': 'Nome da planta industrial',
	'Enter a name': 'Insira um nome',
	'Please enter a valid name': 'Insira um nome válido',
	'Please enter a valid phone number': 'Insira um telefone válido',
	'Invalid phone number': 'Número de telefone inválido',
	'Insert short description': 'Insira uma breve descrição',
	'Add new band': 'Adicionar nova banda',
	'Create new band': 'Criar nova banda',
	'Minimum angle': 'Ângulo mínimo',
	'Maximum angle': 'Ângulo máximo',
	Coloring: 'Coloração',
	Remove: 'Remover',

	//	Breadcrumb
	Home: 'Início',
	'Manage users': 'Gerenciar usuários',
	Preferences: 'Preferências',
	'My informations': 'Minhas informações',
	'My plan': 'Meu plano',

	individual: 'Individual',
	team: 'Equipe',
	business: 'Empresarial',
	pilot: 'Piloto',

	yearly: 'anual',
	monthly: 'mensal',
	Yearly: 'Anual',
	Monthly: 'Mensal',

	User: 'Usuário',
	Supervisor: 'Supervisor',
	Master: 'Master',
	Admin: 'Administrador',

	'Choose a plan different from your current plan': 'Escolha um plano diferente do seu plano atual',
	'Plan successfully canceled': 'Plano cancelado com sucesso',
	'We received your order, we are processing your payment': 'Recebemos seu pedido, estamos processando seu pagamento',

	'Password changed successfully': 'Senha alterada com sucesso',

	'Customer plan not found': 'Plano do cliente não encontrado',
	'Customer data not found': 'Dados do cliente não encontrados',
	'User access not found': 'Permissão do usuário não encontrada',
	'File deleted successfully': 'Arquivo excluído com sucesso',

	'Check the parameters entered': 'Verifique os dados inseridos',
	'Number of document characters are invalid': 'Número de caracteres do documento são inválidos',
	'Invalid inserted CPF': 'CPF inserido inválido',
	'Invalid inserted CNPJ': 'CNPJ inserido inválido',

	'It is necessary to spend a day after contracting the service to change the plan':
		'É necessário passar um dia após a contratação do serviço para alterar o plano.',

	'Fake communication failure': 'Falha na comunicação',

	'Remember me': 'Lembrar de mim',
	'Forgot password': 'Esqueceu sua senha?',
	'Log in': 'Acessar',
	Password: 'Senha',
	'Please input your password!': 'Insira uma senha',
	'Invalid email or password': 'E-mail ou senha inválidos',
	'The input is not a valid e-mail!': 'Este e-mail não é válido!',
	'Please input your e-mail': 'Por favor, digite seu e-mail',
	'Inactive account, please activate': 'Conta invativa, por favor ativar',
	'Enter your email': 'Insira seu e-mail',
	Send: 'Enviar',
	'User not found': 'Usuário não encontrado',
	'Success, check your email box': 'Sucesso, veja sua caixa de e-mail',
	'Password recovery': 'Redefinição de senha',
	'Token invalid': 'Requisição inválida',
	'Token expired, generated a new one': 'Sessão expirada, tente novamente',
	'Please confirm your password!': 'Por favor confirme sua senha',
	'Confirm Password': 'Confirme sua senha',
	'The two passwords that you entered do not match!': 'As duas senhas não conferem, verifique',
	Confirm: 'Confirmar',
	Generate: 'Gerar',
	Validate: 'Validar',
	Continue: 'Continuar',
	'Reset token': 'Recuperar',
	Cancel: 'Cancelar',
	flexion: 'Flexão',
	turned: 'Virado',
	extension: 'Extensão',
	sideways: 'Lateralmente',
	crouched: 'Agachado',
	downed: 'Abaixado',
	arm_raised: 'Braço levantado',
	behind: 'Atrás',
	raised: 'Levantado',
	none: 'Nenhum',

	// Check-in Customer
	'Registered successfully!': 'Cadastro realizado com sucesso!',
	'Just a little longer, check your e-mail inbox': 'Agora falta pouco, verifique sua caixa de entrada no email',
	Access: 'Acessar',
	'Kinebot - Terms of use': 'Kinebot - Termos de uso',
	'terms of use': 'termos de uso',
	"Welcome! Let's start": 'Seja bem-vindo, vamos começar!',
	'Enter your phone number': 'Insira seu telefone',
	'Select your contry': 'Selecione seu país',
	State: 'Estado',
	'State:': 'Estado:',
	'Select your state': 'Selecione o seu estado',
	'Select your city': 'Selecione a sua cidade',
	'Zip code': 'CEP',
	'Enter your zipcode': 'Insira o seu código postal',
	'Enter your address': 'Insira o seu endereço',
	'Enter your street number': 'Insira o número da rua',
	'Coupon (optional)': 'Cupom (opcional)',
	Coupon: 'Cupom',

	// User Activation
	'There are problems on your operation.': 'Existem alguns problemas com a sua operação.',
	Leave: 'Sair',
	Data: 'Dados',
	'Final steps': 'Finalização',
	'Card number': 'Número do cartão',
	'Enter your credit card number': 'Insira o número do cartão',
	'Invalid credit card': 'Cartão inválido',
	'Card holder name': 'Nome do titular',
	'Enter the card holder name': 'Insira o nome do titular',
	"Enter the card's due date": 'Insira a validade do cartão',
	'Invalid month': 'Mês inválido',
	'Invalid card date': 'Data do cartão inválida',
	'Enter the security code': 'Insira o código de segurança',
	'Invalid code': 'Código inválido',
	'Payment information': 'Dados de pagamento',

	// Maintenance
	"We are going through maintenance, we'll be back shortly.": 'Estamos em manutenção, voltamos em breve.',

	// Finalization
	'Personal data': 'Dados pessoais',
	'Document no.': 'CPF',
	'Payment details': 'Detalhes do pagamento',
	'You will only be charged after the free test period, it can be cancelled at anytime.':
		'O valor da cobrança só será efetuado após o período gratuito, podendo ser cancelado a qualquer momento.',
	'Payment method': 'Método de pagamento',
	'Payment options': 'Tipo de pagamento',
	'Full payment': 'À vista',
	Discounts: 'Descontos',
	'I have read and agree with the': 'Eu li e concordo com os',
	Close: 'Fechar',

	// User Activation - Information
	'Validating coupon': 'Validando cupom',
	"Couldn't find the coupon": 'Não foi possível buscar o cupom',
	Individual: 'Individual',
	Team: 'Equipe',
	Business: 'Empresarial',
	'Enter your document no.': 'Insira o CPF',
	'Enter a valid document': 'Insira um CPF válido',
	'Enter a phone number': 'Insira um telefone',
	'Enter the zip code': 'Insira o CEP',
	'Enter the city': 'Insira a cidade',
	'Enter the state': 'Insira o estado',
	'Street number': 'Número da rua',
	'Street number:': 'Número da rua:',

	// Credit Card
	'Under review': 'Cartão sob revisão',
	'Insufficient funds': 'Saldo insuficiente',
	'Not accepted': 'Transação inválida',
	'Customer already registered': 'Usuário já cadastrado',
	'Failed to perform transaction': 'Falha ao realizar a transação',

	'email must be unique': 'E-mail já registrado',

	'Error loading video': 'Erro ao carregar o vídeo',
	'Failed to fetch your plan information.': 'Falha ao obter as informações do seu plano',
	'Failed to fetch total customer videos.': 'Falha ao buscar o total de vídeos do cliente',
	'Maximum uploads reached.': 'Máximo de uploads atingido',
	'Maximum minutes reached.': 'Máximo de minutos atingido',
	'Corrupted video.': 'Vídeo corrompido',

	// Painel control
	'Maximum users reached': 'Máximo de usuários cadastrados',

	"The 'name' field is required.": 'O campo nome é obrigatório.',
	"The 'email' field is required.": 'O campo email é obrigatório.',
	"The 'country' field is required.": 'O campo país é obrigatório.',
	"The 'state' field is required.": 'O campo estado é obrigatório.',
	"The 'city' field is required.": 'O campo cidade é obrigatório.',
	"The 'address' field is required.": 'O campo endereço é obrigatório.',
	"The 'street_number' field is required.": 'O campo número é obrigatório.',
	"The 'zipcode' field is required.": 'O campo código postal é obrigatório.',

	// ********************************** //
	'Personal information': 'Informações pessoais',
	Localization: 'Localização',

	'Full name': 'Nome completo',
	'Full name:': 'Nome completo:',
	'Enter your full name': 'Insira seu nome completo',
	'Enter your name': 'Insira seu nome',
	'Insert a document': 'Insira um documento',
	'Insert a valid document': 'Insira um documento válido',
	Address: 'Endereço',
	'Address:': 'Endereço:',
	'Enter an address': 'Insira um endereço',
	Number: 'Número',
	'Enter the number': 'Insira o número',
	Zipcode: 'CEP',
	'Zipcode:': 'Código postal:',
	'Enter zip code': 'Insira o código postal',
	Country: 'País',
	'Country:': 'País:',
	'Select your country': 'Selecione o seu país',
	'Select state': 'Selecione o estado',
	City: 'Cidade',
	'City:': 'Cidade:',
	'Select city': 'Selecione a cidade',

	'Update performed': 'Operação realizada',
	'Customer information updated successfully': 'Informações atualizadas com sucesso',
	'Fill in your personal information': 'Complete suas informações pessoais',

	// Forgot password
	'Forgot your password?': 'Esqueceu sua senha?',
	'We will send you an email to retrieve your password, rest assured :)':
		'Iremos enviar um e-mail para você recuperar sua senha, fique tranquilo :)',
	'Back to login': 'Voltar para o login',
	'Please enter a valid e-mail address': 'Insira um e-mail válido',
	'Enter an e-mail': 'Insira um e-mail',

	'Oops... Something went wrong!': 'Ops... Algo deu errado!',
	'Operation performed successfully': 'Operação realizada com sucesso',
	'Check your email inbox': 'Verifique sua caixa e-mails',
	'Create new password': 'Crie uma nova senha',
	'Your new password must be different from previous used passwords':
		'Sua nova senha deve ser diferente das senhas usadas anteriormente',
	'Enter your new password': 'Insira sua nova senha',
	'Confirm new password': 'Confirme a nova senha',
	'The two passwords that you entered do not match': 'As duas senhas que você digitou não coincidem',
	Save: 'Salvar',
	'Click here to continue': 'Clique aqui para continuar',
	'Invalid Token': 'Token inválido',
	'Expired token': 'Token expirado',

	trunk: 'Tronco',
	neck: 'Pescoço',
	left_lower_arm: 'Cotovelo esquerdo',
	right_lower_arm: 'Cotovelo direito',
	left_upper_arm: 'Ombro esquerdo',
	right_upper_arm: 'Ombro direito',
	left_knee: 'Joelho esquerdo',
	right_knee: 'Joelho direito',
	left_ankle: 'Tornozelo esquerdo',
	right_ankle: 'Tornozelo direito',
	hip: 'Quadril',
	left_hand: 'Punho esq.',
	right_hand: 'Punho dir.',

	Knee: 'Joelho',
	Ankle: 'Tornozelo',
	Hip: 'Quadril',
	Hand: 'Punho',
	Qualification: 'Qualificação',
	'Select the body parts to display': 'Selecione as partes do corpo a serem exibidas',

	'Light risk': 'Risco leve',
	'Average risk': 'Risco médio',

	Level: 'Nível',
	'Limit of bands reached': 'Limite de bandas atingido',

	'Industrial site': 'Planta industrial',
	Period: 'Período',
	Search: 'Buscar',
	Clear: 'Limpar',

	'Select company': 'Selecionar empresa',

	//User management
	'Create new user': 'Criar novo usuário',
	Email: 'Email',
	Permissions: 'Permissões',
	'Companies - Industrial sites': 'Empresas - Plantas industriais',

	'Change password': 'Alterar senha',
	'Current password': 'Senha atual',
	'New password': 'Nova senha',
	'Confirm password': 'Confirmar senha',
	'Enter your current password': 'Insira sua senha atual',
	'Enter a new password': 'Insira uma nova senha',
	'Password must be at least 6 characters long': 'A senha deve ter no mínimo 6 caracteres',
	'Repeat your new password': 'Repita sua nova senha',
	"The two passwords don't match, check": 'As duas senhas não conferem, verifique',
	'Sorry time exceeded, try again.': 'Desculpe, o tempo foi excedido, tente novamente',
	'Invalid current password': 'Senha atual inválida',
	'Update information': 'Atualizar informações',

	'Phone number': 'Telefone',
	'Account type': 'Tipo da conta',
	'Created in': 'Criada em',
	'Postal code': 'CEP',
	'Sorry, something went wrong :(': 'Desculpe, algo deu errado :(',
	Retry: 'Tentar novamente',

	// Layout - Sidebar
	Settings: 'Configurações',
	'My account': 'Minha conta',
	Plan: 'Plano',
	'Subscription type': 'Tipo de assinatura',
	'Subscription type:': 'Tipo de assinatura:',
	Recurrence: 'Recorrência',
	'Recurrence:': 'Recorrência:',
	'Expiration date': 'Data de expiração',
	'Plan expiration date:': 'Data de expiração do plano:',
	'Active users': 'Usuários ativos',
	'Processed videos': 'Vídeos processados',
	'Processed videos:': 'Vídeos processados:',
	'Processing time': 'Tempo de processamento',
	'Processing time:': 'Tempo de processamento:',
	'Additional minutes': 'Minutos adicionais',
	'Add credits': 'Adicionar créditos',
	'Renew subscription': 'Renovar assinatura',
	'Change subscription': 'Alterar assinatura',
	'Cancel subscription': 'Cancelar assinatura',
	of: 'de',
	minutes: 'minutos',

	Test: 'Teste',

	Minutes: 'Minutos',
	Purchase: 'Comprar',
	Payments: 'Pagamentos',
	Payment: 'Pagamento',
	'Buy additional credits': 'Compre créditos adicionais',
	'Enter the amount of additional credits (minutes) below to continue using the platform':
		'Insira abaixo a quantidade de créditos adicionais (minutos) para continuar usando a plataforma',
	'Consolidate data': 'Consolidar dados',
	'Export report': 'Exportar relatório',
	'There is no post with screwdriver / screwdriver': 'Não tem posto com parafusadeira/apertadeira',
	'Data not found': 'Dados não encontrados',
	'Requires actions': 'Requer ações',
	'No actions required': 'Não requer ações',
	'High Risk and Requires Action': 'Alto Risco e Requer ações',
	'Moderate risk and no action required': 'Risco Moderado e Não requer ações',
	'Low Risk and No Action Required': 'Baixo Risco e Não requer ações',
	'Intensity of work': 'Intensidade do trabalho',
	'Work organization': 'Organização do trabalho',
	'Is spontaneous breaks allowed during the workday?':
		'É permitido pausas espontâneas durante a jornada de trabalho?',
	'Is there a diversification of tasks in the performance of your functions?':
		'No desempenho de suas funções há diversificação de tarefas?',
	'Materials are always available at the workstation, avoiding rush, delay or overload?':
		'Os materiais sempre estão disponíveis no posto de trabalho evitando correria, atraso ou sobrecarga?',
	Complexity: 'Complexidade',
	'Movements do not require high dexterity': 'Movimentos não exigem alta destreza',
	'Low level of attention requirement for long periods': 'Baixo nível de exigência de atenção por longos períodos',
	'Workstation is complex and high cognitive demand': 'Posto é complexo e de alta exigência cognitiva',
	'Workstation is simple and of low cognitive requirement': 'Posto é simples e de baixa exigência cognitiva',
	'Displacement ': 'Deslocamento ',
	'Squat ': 'Agachamento ',
	Cervical: 'Cervical',
	'Left Shoulder/Arm': 'Ombro/Braço Esq.',
	'Right Shoulder/Arm': 'Ombro/Braço Dir.',
	'Left wrist': 'Punho esq.',
	'Right wrist': 'Punho dir.',
	'No repeatability': 'Sem repetividade',
	'With repetition': 'Com repetividade',
	' x per hour': ' x por hora',
	'Without risk': 'Sem risco',
	'Action Level': 'Nível de ação',
	'Complementary resources': 'Fatores complementares',
	'Percussion tools ': 'Ferramentas de percussão ',
	'Hit against ': 'Batidas contra ',
	'Present Risk': 'Risco Presente',
	'Global Ranking': 'Classificação Global',
	'Operator report': 'Relato do operador',
	'Enter operator report below': 'Insira abaixo o relato do operador',
	'Easy to understand information': 'Informação de fácil compreensão',

	'≤ 10 steps per minute': '≤ 10 passos por minuto',
	'15 to 25 steps per minute': 'de 15 a 25 passos por minuto',
	'Above 25 steps per minute': 'Acima de 25 passos por minuto',

	'Inform below the displacement of the operator during the workday':
		'Informar abaixo o deslocamento do operador durante a jornada de trabalho',
	'Regulation notes': 'Notas de regulação',
	'Spontaneous breaks are allowed during the workday (e.g. drinking water, drinking coffee, going to the bathroom)':
		'É permitido pausas espontâneas durante a jornada de trabalho (ex.: tomar água, beber café, ir ao banheiro)',
	'In the performance of their functions, there is diversification of tasks':
		'No desempenho de suas funções há diversificação de tarefas',
	'Materials are always available at the workstation, avoiding rush, delay or overload':
		'Os materiais sempre estão disponíveis no posto de trabalho evitando correria, atraso ou sobrecarga',
	'Work intensity: give a score from 1 to 7 (1 being a little work and 7 being very intense work)':
		'Intensidade do trabalho: dê uma nota de 1 a 7 (sendo 1 pouco trabalho e 7 trabalho intensíssimo)',

	Wrist: 'Punho',
	'Hit against': 'Batidas',
	'Enter job information below': 'Insira abaixo informações sobre o posto de trabalho',
	'During the operation, the operator taps his hands to adjust parts or components.':
		'O operador realiza durante a operação batidas com as mãos para fazer ajuste de peças ou componentes.',

	'Add a companion video for wrist analysis': 'Adicione um vídeo complementar para análise do punho',
	'Do not include in the analysis': 'Não incluir na análise',
	'Include external video': 'Incluir vídeo externo',
	'Enter video name': 'Digite o nome do vídeo',

	'Sledgehammer and/or taps are hits from hard hits (except hit adjustments)':
		'Marreta e/ou tas so batidas de batidas fortes (exceto ajustes de batida)',
	'Light - Quiet': 'Leve - Tranquilo',
	'Medium - Some effort is perceived (defined)': 'Médio - Percebe-se algum esforço (definido)',
	'Heavy - Clear effort: no change in facial expression': 'Pesado - Esforço nitido: sem mudança de expressão facial',
	'Very heavy - Sharp effort: changes facial expression': 'Muito pesado - Esforço nitido: muda a expressão facial',
	'Next. maximum - Use of torso and limbs to generate greater force':
		'Próximo. máximo - Uso do tronco e membros para gerar força maior',

	// ------- //
	'Workstation Information': 'Informação de trabalho',

	'Enter operator difficulty control below': 'Insira abaixo o controle de dificuldade do operador',
	'Control Difficulty': 'Dificuldade de controle',
	'Select a cost center': 'Selecione o centro de custo',

	'Enter data about vibration in employee activity below':
		'Insira abaixo os dados sobre a vibração na atividade do funcionário, caso não tenha não é necessário preencher',

	"Enter below the data on the employee's reaction in the activity":
		'Insira abaixo os dados sobre a reação do colaborador na atividade',
	'Insert a new reaction': 'Insira uma nova reação',
	'Insert a new vibration': 'Insira uma nova vibração',

	"Enter below the data of the employee's effort in the activity":
		'Insira abaixo os dados sobre o esforço do colaborador na atividade',

	'Insert a new effort': 'Insira um novo esforço',
	'Cost center': 'Centro de custo',
	'Enter a workstation': 'Insira o posto de trabalho',

	'Enter the data related to the selected video below': 'Insira abaixo os dados relacionados ao vídeo selecionado',

	Staff: 'Quadro de colaboradores',
	'Enter the Company Activities': 'Insra o CNAE',
	'Insert a production line': 'Insira a linha de produção',
	'Add new range': 'Adicionar nova banda',
	'industrial site': 'planta industrial',
	'Select a industrial site': 'Selecione a planta industrial',
	'Select an industrial site': 'Selecione a planta industrial',
	'Production line': 'Linha de produção',
	'Select a production line': 'Selecione a linha de produção',

	Role: 'Cargo/Função',
	Code: 'Código',

	'Tax Code': 'CNPJ',
	'Enter a Tax Number': 'Insira o CNPJ',
	'Insert a valid Tax Number': 'Insira um CNPJ válido',

	'Select a role': 'Selecione um cargo/função',
	'User type': 'Tipo de usuário',
	'User type:': 'Tipo de usuário:',
	Document: 'Documento',
	'Document:': 'Documento:',
	'Current plan': 'Plano atual',
	'Not informed': 'Não informado',

	'Risk ranges': 'Bandas de risco',
	'Local application': 'Local de aplicação',
	'Units to be analyzed': 'Unidades a serem analisadas',
	'Select the units that will be included in the review': 'Selecione as unidades que serão incluídas na revisão',
	Factory: 'Fábrica',
	'Select the industrial sites to be analyzed': 'Selecione as plantas industriais a ser analizadas',
	'Production Volume': 'Volume de produção',
	Investments: 'Investimentos',
	'Enter production volumes below': 'Insira os volumes de produção abaixo',
	'Inform below the investments in ergonomics': 'Informe abaixo os investimentos em ergonomia',

	Date: 'Data ',
	'Date of reference': 'Data de referência',
	'Date of the report': 'Data do relatório',

	'Ergonomic analysis of work': 'Avaliação ergonômica do trabalho',
	Presentation: 'Apresentação',
	'Plant Information': 'Informações da planta',
	'Insert a company name': 'Insira o nome da empresa',
	'Risk degree': 'Grau de risco',
	Activity: 'Atividade',
	District: 'Bairro',
	Administrative: 'Administrativo',
	'Work Shift': 'Turno de Trabalho',
	Operational: 'Operacional',
	'Direct hourly worker': 'Horista direto',
	'Indirect hourly worker': 'Horista indireto',
	'Monthly worker': 'Mensalista',
	'Normal working hours': 'Horário normal de trabalho',

	// AET
	'Include checklists related to this analysis below': 'Inclua abaixo as checklists relacionadas a essa análise',
	'Non-standard scale': 'Escala não padronizada',

	// Bodyparts
	'Lower members': 'Membros inferiores',
	'Left elbow': 'Cotovelo esquerdo',
	'Right elbow': 'Cotovelo direito',
	'Left shoulder': 'Ombro esquerdo',
	'Right shoulder': 'Ombro direito',
	'Left knee': 'Joelho esquerdo',
	'Right knee': 'Joelho direito',
	'Left ankle': 'Tornozelo esquerdo',
	'Right ankle': 'Tornozelo direito',

	/* Nomenclature v2 */
	'Left hand': 'Mão esquerda',
	'Right hand': 'Mão direita',
	'Video description': 'Descrição de vídeo',
	Below: 'Abaixo de',
	Above: 'Acima de',

	Checklist: 'Checklist',
	'Frequency and duration': 'Frequência e duração',

	'Date of collection': 'Data de coleta',

	'Load from 2 kg ≤ 10 kg (intermittent)': 'Carga de 2 kg a 10 kg (intermitente)',
	'Load from 2 kg ≤ 10 kg (static or repetitive)': 'Carga de 2 kg a 10 kg (estático ou repetitivo)',
	'Load more than 10 kg of repetitive load or blows': 'Carga maior 10 kg de carga repetitivos ou golpes',

	Invalid: 'Inválido',
	Safe: 'Aceitável',
	Info: 'Leve',
	Attention: 'Atenção',
	Danger: 'Perigo',
	safe: 'aceitável',
	info: 'leve',
	warning: 'alto',
	danger: 'perigo',

	'Activity score': 'Score da atividade',
	'Exposure score per joint': 'Score de exposição por articulação',
	'Angle in time': 'Ângulo no tempo',
	'REBA time score': 'Score temporal REBA',
	'Score left': 'Score esquerdo',
	'Score right': 'Score direito',
	'Angle by time': 'Ângulo no tempo',
	Score: 'Score',
	'L. Knee': 'Joelho E.',
	'R. Knee': 'Joelho D.',
	'L. Elbow': 'Cotovelo E.',
	'R. Elbow': 'Cotovelo D.',
	'L. Shoulder': 'Ombro E.',
	'R. Shoulder': 'Ombro D.',
	'Left Knee': 'Joelho E.',
	'Right Knee': 'Joelho D.',
	'Left Elbow': 'Cotovelo E.',
	'Right Elbow': 'Cotovelo D.',
	'Left Shoulder': 'Ombro E.',
	'Right Shoulder': 'Ombro D.',

	'Corrective action not required': 'Ação corretiva não necessária',
	'Corrective action as soon as possible': 'Ação corretiva o mais rápido possível',
	'High priority corrective action': 'Ação corretiva de alta prioridade',
	'Immediate corrective action': 'Ação corretiva imediata',
	'Unable to show results': 'Não foi possível mostrar os resultados',

	/* Nomenclature */
	Line: 'Linha',
	Effort: 'Esforço',
	Reaction: 'Reação',
	Vibration: 'Vibração',
	'Beats against': 'Batidas contras',
	Percussion: 'Percussão',
	Hands: 'Mãos',
	'Shoulders/Arms': 'Ombros/Braços',
	Left: 'Esquerda',
	Right: 'Direita',
	Exit: 'Sair',
	Filters: 'Filtros',

	/* Login - Page */
	// Placeholder's
	'E-mail': 'E-mail',
	'E-mail:': 'E-mail',

	// Validation's errors inputs
	'Enter a valid e-mail': 'Insira um e-mail válido',
	'Enter your password': 'Insira sua senha',
	Login: 'Login',

	// SideMenu
	Dashboard: 'Dashboard',
	Upload: 'Upload',
	PEA: 'AEP',

	// Dashboard
	'Comparison over the last 6 months': 'Comparativo nos ultimos 6 meses',
	/*************/

	'Are you sure?': 'Tem certeza?',
	'You are being redirected': 'Você está sendo redirecionado',
	'Are you sure you want to quit? You have an upload in process.':
		'Tem certeza que deseja sair? Você tem um upload em processo',

	// Upload filter
	'Select a company': 'Selecione uma empresa',
	'Select a line': 'Selecione a linha',
	'Select the workstation': 'Selecione o posto de trabalho',
	'Select a workstation': 'Selecione o posto de trabalho',

	// Chart
	'No data available': 'Não há dados',
	'There is no registered data.': 'Não há dados cadastrados.',

	// Layout
	Logout: 'Sair',

	// Report
	'Add item': 'Adicionar item',
	"Approximated values, depends mainly on the filming methods. In case there is no data, the algorithm didn't find the points to determine the angle, please review the filming method used.":
		'Valores aproximados, dependentes da técnica de filmagem adotada. Caso não tenha dados o algoritmo não identificou os pontos para determinar o ângulo, observar técnicas de filmagem.',
	'The results obtained from each body part can be affected by the method and position of filming, the identification of the person in the analysis can suffer interference from objects present in the room. The angle data shown are approximate values.':
		'Os resultados obtidos em cada membro do corpo poderão ser impactados de acordo com a forma e posição de gravação, a identificação da pessoa que é analisada pode sofrer interferência de objetos presentes no local de operação. Os dados dos ângulos mostrados são valores aproximados.',
	Reference: 'Referência',
	'Investigate and change immediately': 'Investigar e mudar imediatamente',
	'Analysis of the movement by angle': 'Análise do movimento por ângulo',
	'Analysis of the movement by score': 'Análise do movimento com score',
	'Analysis of the movement & Body parts': 'Análise do movimento & Partes do corpo',
	'Report types': 'Tipos de relatórios',
	'Generate reports': 'Gerar relatórios',
	Finish: 'Finalizar',
	'Description already exists!': 'Descrição já existente!',
	'Enter a new sector': 'Insira um novo setor',
	'Do you wish to delete this sector?': 'Deseja excluir esse setor?',
	'This sector is used in other reports, do you really wish to delete it?':
		'Esse setor está sendo utilizado em outros relatórios, tem certeza que deseja excluir?',
	'Sector created successfully!': 'Setor criado com sucesso!',
	'Line created successfully!': 'Linha criada com sucesso!',
	'Workstation created successfully!': 'Posto de trabalho criado com sucesso!',
	"This operation couldn't be completed": 'Não foi possível realizar esta ação',
	Sectors: 'Setores',
	'Fill in the essential information below.': 'Preencha abaixo algumas informações essencias.',
	'Select the sector from the above analysis': 'Selecione o setor da análise acima',
	'Select the sector for the analysis': 'Selecione o setor da análise',
	Add: 'Adicionar',
	'Enter the workstation': 'Insira o posto de trabalho',
	'Enter the date the collection was made': 'Insira a data em que a coleta foi feita',
	'Select the tool for the analysis and the type of report you wish to generate.':
		'Selecione a ferramenta que deseja aplicar para a análise e o tipo de relatório que deseja gerar.',
	Tool: 'Ferramenta',
	'Pick the tool above': 'Selecione a ferramenta acima',
	'Select the type of tool': 'Selecione o tipo da ferramenta',
	Report: 'Relatório',
	'Select the type of report above': 'Selecione o tipo de relatório acima',
	'Select the type of report': 'Selecione o tipo de relatório',

	// BriefBest
	'Shoulder movement': 'Movimentos de ombros',
	'Flexion greater than 20° degrees': 'Flexão maior que 20° graus',
	'Executed with support': 'Execução com suporte',
	Rotation: 'Rotação',
	'Force greater or equal to 11.3kg': 'Força maior ou igual a 11.3kg',
	'Forearm movement': 'Movimentos de antebraço',
	'Greater or equal to 40°': 'Maior ou igual a 40°',
	'Full extension': 'Extensão completa',
	'Force greater or equal to 4.5kg': 'Força maior ou igual a 4.5kg',
	'Movement of hands and wrist': 'Movimentos das mãos e punhos',
	'Ulnar deviation': 'Desvio ulnar',
	'Radial deviation': 'Desvio radial',
	'[Force]: Pinch or pressure with the fingers greater or equal to 0.9kg, or palm pressure greater or equal to 4.5kg.':
		'[Força]: Pinça ou pressão com os dedos maior ou igual 0,9kg, ou pressão palmar maior ou igual 4,5kg.',
	'[Duration]: Greater or equal to 10 seconds.': '[Duração]: Maior ou igual a 10 segundos.',
	'[Frequency]: Greater or equal to 30 minutes.': '[Frequência]: Maior ou igual a 30 minutos.',
	'Leg movement': 'Movimentos das pernas',
	Squatting: 'Agachado',
	'With support': 'Com suporte',
	'Foot pedal greater or equal to 4.5kg': 'Pedal de pé maior ou igual á 4.5kg',
	'Neck movement': 'Movimentos de pescoço',
	'Flexion greater than 30°': 'Flexão maior que 30° graus',
	'Side movement': 'Movimento para os lados',
	Extended: 'Extendido',
	'Rotation greater than 20°': 'Rotação maior que 20° graus',
	'Force greater or equal to 0.9kg': 'Força maior ou igual a 0.9kg',
	'Arm behind the body': 'Braço atrás do corpo',
	'Shoulders tucked in': 'Ombros encolhidos',
	Elbows: 'Cotovelos',
	Ombros: 'Shoulders',
	'Back ': 'Costas', // Coloquei um espaço depois de "Back" para diferenciar de "Voltar"
	"Data couldn't be loaded.": 'Não foi possível carregar.',
	'Body parts - Critical:': 'Partes do corpo - Criticas:',
	Indicators: 'Indicadores',
	'Glove usage': 'Uso de luvas',
	'Impact exposure': 'Exposição a impacto',
	'Vibration exposure': 'Exposição a vibração',
	'Low temperature exposure': 'Exposição à baixas temperaturas',
	'Mechanical compression of muscular tissue': 'Compressão mecânica do tecido muscular',
	'More than 40 hours': 'Maior que 40 horas',
	'20 - 40 hours': '20 - 40 horas',
	'4 - 19 hours': '4 - 19 horas',
	'Less than 4 hours': 'Menor que 4 horas',
	Video: 'Vídeo',
	'Exposure time': 'Tempo de exposição',
	'Tool used': 'Ferramenta utilizada',
	'Physical stress factors': 'Fatores de estresse físico',
	"Data couldn't be loaded": 'Não foi possível buscar os dados',
	'Very high': 'Muito alto',
	'Final score:': 'Pontuação final:',
	'(Task risk x Exposure time factor)': '(Risco da tarefa x fator tempo de exposição)',
	'Priority:': 'Prioridade:',
	'Subtitle:': 'Legendas:',
	Graphs: 'Gráficos',
	'Not identified': 'Não identificado',
	Comments: 'Comentários',
	'Comments:': 'Comentários:',
	'Enter the analysis conclusion': 'Insira aqui a conclusão da análise',
	'Complementary factors': 'Fatores complementares',
	'Physical stress': 'Estresse físico:',
	'Inadequate use of gloves': 'Uso inadequado de luvas',
	'Weekly exposure time:': 'Tempo de exposição semanal:',
	'Physical factors': 'Fatores físicos',
	Filter: 'Filtrar',
	Company: 'Empresa',
	'Select the company': 'Selecione a empresa',
	'Select the industrial site': 'Selecione a planta industrial',
	Function: 'Função',
	'Enter the function': 'Insira a função',
	'Customized reports': 'Relatórios customizados',

	// Settings
	"We weren't able to change your password": 'Não foi possível alterar a sua senha',
	'Warning!': 'Atenção!',
	'Failed to fetch requested information': 'Falha ao buscar informações solicitadas',
	'Do you really wish to cancel your plan?': 'Deseja realmente cancelar seu plano?',
	'After cancelling your plan, when the expiration date comes, you will have no more access to the platform.':
		'Ao cancelar seu plano, após a data de expiração atual você não terá acesso a plataforma.',
	"We weren't able to cancel your plan": 'Não foi possível cancelar o plano',
	"Select a plan that's different from your current one": 'Selecione um plano diferente do seu plano atual',
	"We couldn't process the operation": 'Não foi possível realizar a operação',
	'Plan cancelled on:': 'Plano cancelado em:',
	'Active users:': 'Usuários ativos:',
	'Plan switch': 'Alteração de plano',
	'You have recently changed your plan': 'Recentemente você alterou sua assinatura',
	'Plan type:': 'Tipo de assinatura:',
	'New plan start date:': 'Data de início do novo plano:',
	'User limit:': 'Limite de usuários:',
	'Upload limit:': 'Limite de uploads:',
	'Processing time limit:': 'Limite de minutos de processamento:',
	'Cancel plan': 'Cancelar plano',
	'Error when trying to verify industrial sites from company.':
		'Erro ao verificar plantas industriais dentro da companhia.',
	'Error when trying to delete the company': 'Erro ao deletar empresa',
	'Enter a permission': 'Insira uma permissão',
	'Select a permission': 'Selecione uma permissão',
	'Edit user': 'Editar usuário',
	'User changed successfully': 'Usuário alterado com sucesso',
	Permission: 'Permissão',
	'Do you wish to delete this user?': 'Deseja excluir este usuário',
	Active: 'Ativo',
	Inactive: 'Inativo',
	All: 'Todos',
	Disabled: 'Desabilitado',

	// Manage companies
	'Manage companies': 'Gerenciar empresas',
	'Manage industrial sites': 'Gerenciar plantas industriais',
	'Heads up! This company is not empty': 'Atenção! Esta empresa não está vazia',
	'To continue, first remove industrial sites belonging to this company.':
		'Para continuar, remova as plantas industriais pertencentes a esta empresa.',
	'All industrial sites in this company will be deleted, along with their respective uploads and reports. Do you wish to proceed?':
		'Todas as plantas industriais dessa empresa serão deletadas, em conjunto com seus uploads e relatórios. Tem certeza que deseja prosseguir?',
	'All uploads and reports from this industrial site will be deleted. This action cannot be undone. Do you wish to continue?':
		'Todos os uploads e relatórios dessa planta industrial serão deletados. Esta ação não pode ser desfeita. Tem certeza que deseja prosseguir?',
	'Failed to update information': 'Falha ao atualizar a informação',
	'Edit company': 'Editar empresa',
	Loading: 'Carregando',
	'Company name': 'Nome da empresa',
	'Industrial sites': 'Plantas industriais',
	'Total Industrial Sites': 'Total de plantas industriais',
	'Manage industrial site': 'Gerenciar planta industrial',
	'Update company name': 'Atualizar nome da empresa',
	'Delete company': 'Apagar empresa',
	'Organization created successfully': 'Empresa criada com sucesso.',
	'Organization deleted successfully': 'Empresa removida com sucesso.',
	'Updated information': 'Informação atualizada',
	'Error while changing the name of the industrial site': 'Erro ao editar o nome da planta industrial',

	// ui/Reports
	'1 - Acceptable posture if not repeated or kept for long periods':
		'1 - Postura aceitável se não for repetida ou mantida durante longos períodos',
	'2 - Investigate; possibility to request for change; it is convenient to introduce alterations':
		'2 - Investigar; possibilidade de requerer mudanças; é conveniente introduzir alterações',
	'3 - Investigate; make changes quickly': '3 - Investigar; realizar mudanças rapidamente',
	'4 - Immediate change': '4 - Mudanças imediatas',
	'Acceptable posture if not repeated or kept for long periods':
		'Postura aceitável se não for repetida ou mantida durante longos períodos',
	'Investigate; possibility to request for change; it is convenient to introduce alterations':
		'Investigar; possibilidade de requerer mudanças; é conveniente introduzir alterações',
	'Investigate; make changes quickly': 'Investigar; realizar mudanças rapidamente',
	'Immediate change': 'Mudanças imediatas',
	Ergonomist: 'Ergonomista',
	'Left lower arm': 'Antebraço esquerdo',
	'Right lower arm': 'Antebraço direito',
	'Left upper arm': 'Braço esquerdo',
	'Right upper arm': 'Braço direito',
	Type: 'Tipo',

	// views/Report/Niosh
	'Manual Lifting Report': 'Relatório - Levantamento Manual',
	'Enter the job characteristics below.': 'Entre com as características do trabalho abaixo.',
	'Gender of the worker': 'Genero do trabalhador',
	'Select the gender': 'Selecione o gênero',
	Age: 'Idade',
	'Select the age': 'Selecione a idade',
	'How many workers are lifting the object?': 'Quantos trabalhadores levantam o objeto?',
	'Which hands are used?': 'Quais mãos são utilizadas?',
	One: 'Um',
	Two: 'Dois',
	Three: 'Três',
	'Both hands': 'Duas mãos',
	'One hand': 'Uma mão',
	'Select the coupling quality': 'Selecione a qualidade da pega',
	'Select the lifting frequency': 'Selecione a frequência do levantamento',
	'Select the lifting duration': 'Selecione a duração do levantamento',
	'Lifting frequency (lifts per minute)': 'Frequência de levantamento (levant./min)',
	Poor: 'Pobre',
	Fair: 'Razoável',
	Good: 'Boa',
	'1 hour': '1 hora',
	'1 - 2 hours': '1 a 2 horas',
	'2 - 8 hours': '2 a 8 horas',
	'Enter the task variables below.': 'Insira abaixo as variáveis do trabalho.',
	'Please enter a value': 'Insira um valor',
	'Weight of the object': 'Peso do objeto',
	'Distance the object is moved vertically': 'Distância que o objeto é deslocado verticalmente',
	'Vertical distance of the object at the beginning of handling, relative to the ground':
		'Distância vertical do objeto no inicio do manuseio, relativa ao solo',
	'Horizontal distance of the object relative to the body': 'Distância horizontal do objeto, relativa ao corpo',
	'Rotation angle': 'Ângulo de rotação',
	'Recommended Weight Limit (RWL)': 'Limite de peso recomendado (LPR)',
	'Lifting Index (LI)': 'Índice de levantamento (IL)',
	'Coupling factor: ': 'Fator de pega: ',
	'Frequency factor: ': 'Fator frequência: ',
	'lifts / min': 'levant. / min',
	'Report date': 'Data do relatório',
	'Comment:': 'Comentário:',
	Details: 'Detalhes',
	Risk: 'Risco',
	'Very low risk': 'Risco muito baixo',
	Measurements: 'Medidas',
	'Lifted by ': 'Levantado por ',
	'1 worker': '1 pessoa',
	'2 workers': '2 pessoas',
	'3 workers': '3 pessoas',
	Using: 'Usando',
	'only one hand': 'apenas uma mão',
	'both hands': 'as duas mãos',
	'Reference weight': 'Peso de referência',
	'Enter the required values': 'Insira os valores obrigatórios',
	'Report created successfully': 'Relatório criado com sucesso',
	'Comment updated successfully': 'Comentário atualizado com sucesso',
	'Document created successfully': 'Documento criado com sucesso',

	// NIOSH - Conclusions
	Conclusions: 'Conclusões',
	Conclusion: 'Conclusão',
	'The weight to be lifted': 'O peso a ser levantado',
	'is greater than the recommended weight limit (RWL)': 'é maior do que o limite de peso recomendado (LPR)',
	'is less than the recommended weight limit (RWL)': 'é menor do que o limite de peso recomendado (LPR)',
	' The lifting index (LI)': ' O índice de levantamento (IL)',
	'is more than 3.': 'é maior do que 3.',
	'is more than 2 and less than 3.': 'está entre 2 e 3.',
	'is more than 1,5 and less than 2.': 'está entre 1,5 e 2.',
	'is more than 1 and less than 1,5.': 'está entre 1 e 1,5.',
	'is less than 1.': 'é menor do que 1.',
	'is equal to or more than 3.': 'é igual ou maior do que 3.',
	'is equal to or more than 2 and less than 3.': 'é igual ou maior do que 2 e menor do que 3.',
	'is equal to or more than 1 and less than 2.': 'é igual ou maior do que 1 e menor do que 2.',
	'is greater than or equal to the recommended weight limit (RWL)':
		'é maior ou igual ao limite de peso recomendado (LPR)',
	' There is a very high risk. These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		' O risco é muito alto. Estes valores indicam que o levantamento seria perigoso para a maioria dos trabalhadores saudáveis.',
	' There is a high risk. These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		' O risco é alto. Estes valores indicam que o levantamento seria perigoso para a maioria dos trabalhadores saudáveis.',
	' There is a moderate risk. These values indicate that this job is somewhat stressful.':
		' O risco é moderado. Estes valores indicam que a tarefa é um pouco rigorosa.',
	' There is a low risk. These values indicate that this job is adequate for the majority of industrial workers, but some may have trouble.':
		' O risco é baixo. Estes valores indicam que a tarefa é adequada para a maioria dos trabalhadores, poucos poderiam encontrar problemas.',
	' There is a low risk. These values indicate that this job is adequate for the majority of industrial workers.':
		' O risco é baixo. Estes valores indicam que a tarefa é adequada para a maioria dos trabalhadores.',
	' There is a very low risk. These values indicate that this job is adequate for the majority of industrial workers.':
		' O risco é muito baixo. Estes valores indicam que a tarefa é adequada para a maioria dos trabalhadores.',
	'These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		'Estes valores indicam que o levantamento seria perigoso para a maioria dos trabalhadores saudáveis.',
	'These values indicate that this job is somewhat stressful.':
		'Estes valores indicam que a tarefa é um pouco rigorosa.',
	'These values indicate that this job is adequate for the majority of industrial workers, but some may have trouble.':
		'Estes valores indicam que a tarefa é adequada para a maioria dos trabalhadores, poucos poderiam encontrar problemas.',
	'These values indicate that this job is adequate for the majority of industrial workers.':
		'Estes valores indicam que a tarefa é adequada para a maioria dos trabalhadores.',
	Male: 'Masculino',
	Female: 'Feminino',
	Man: 'Homem',
	Woman: 'Mulher',
	Measures: 'Medidas',
	'20 to 45 years old': '20 a 45 anos',
	'20 to 45': '20 a 45',
	'< 20 years old': '< 20 anos',
	'> 45 years old': '> 45 anos',
	'Download PDF': 'Baixar PDF',

	// NIOSH - Critical factors
	'The most critical variables are listed below with suggestions:':
		'As variáveis mais críticas estão listadas abaixo com sugestões de melhoria:',
	'Bring the load closer to the worker by removing any horizontal barriers or reducing the size of the object. Lifts near the floor should be avoided.':
		'Leve o peso para mais próximo do trabalhador removendo qualquer barreira horizontal ou reduzindo o tamanho do objeto. Levantamentos próximos ao piso devem ser evitados se possível.',
	'Raise/lower the origin/destination of the lift. Avoid lifting near the floor or above the shoulders.':
		'Eleve a origem ou desça o destino do levantamento. Evite levantamentos próximos ao piso ou acima dos ombros.',
	'Reduce the vertical distance between the origin and the destination of the lift.':
		'Reduza a distância vertical entre a origem e o destino do levantamento.',
	'Move the origin and destination closer together to reduce the angle of twist, or move them further apart to force the worker to turn the feet and step, rather than twist the body.':
		'Mova a origem e o destino mais pertos um do outro para reduzir o ângulo de torção, ou deixe-os mais afastados para que o trabalhador precise dar um passo sem torcer o corpo.',
	'Reduce the lifting frequency rate, reduce the lifting duration, or provide longer recovery periods (i.e., light work period).':
		'Reduza a frequência de levantamento, reduza a duração do levantamento ou proporcione períodos de descanso maiores (tarefas menos exigentes).',
	'Improve the hand-to-object coupling by providing optimal containers with handles or handhold cutouts, or improve the handholds for irregular objects.':
		'Melhore a facilidade de agarre providenciando alças ou recortes para as mãos. Para objetos irregulares, melhore os apoios para as mãos.',
	'Consider using both hands when lifting the weight.': 'Considere utilizar as duas mãos ao realizar o levantamento.',
	'One handed': 'Usando uma mão',
	'Distance H': 'Distância H',
	'Distance Vc': 'Distância Vc',
	'Distance Dc': 'Distância Dc',
	'Angle A': 'Ângulo A',
	'Frequency/Duration': 'Frequência/Duração',
	Coupling: 'Pega',
	Characteristics: 'Características',
	Variables: 'Variáveis',
	Result: 'Resultado',
	'Choose a gender': 'Escolha um gênero',
	Gender: 'Gênero',
	Pairs: 'Pares',

	// STRAIN INDEX REPORT
	'Report Results - Revised Strain Index': 'Relatório - Strain Index Revisado',
	'Intensity of exertion': 'Intensidade do esforço',
	'Efforts per minute': 'Esforços por minuto',
	'Number of exertions': 'Número de esforços',
	'Observation time': 'Tempo de observação',
	'Duration per exertion': 'Duração por esforço',
	'Hand/wrist posture': 'Postura da mão/punho',
	'Type of wrist posture': 'Tipo de postura do punho',
	'Hand/wrist angle': 'Ângulo da mão/punho',
	'Duration of task per day': 'Duração da tarefa por dia',
	'Revised Strain Index (RSI)': 'Strain Index Revisado (RSI)',
	'Risk factor': 'Fator de risco',
	Input: 'Entrada',
	'Job is probably safe': 'A tarefa é provavelmente segura',
	'Job is probably hazardous': 'A tarefa é provavelmente perigosa',
	Degrees: 'Graus',
	'Duration/day': 'Duração/dia',
	'Intensity of exertion (Borg Scale - BS)': 'Intensidade do esforço (Borg Scale - BS)',
	'Somewhat Hard': 'Pouco Difícil',
	Hard: 'Difícil',
	'Very Hard': 'Muito Difícil',
	'Near Maximal': 'Quase Máxima',
	'Risk factors 1': 'Fatores de risco 1',
	'Risk factors 2': 'Fatores de risco 2',
	'Barely noticeable or relaxed effort (BS: 0-2)': 'Quase imperceptivel ou esforço mínimo (BS: 0-2)',
	'Noticeable or definite effort (BS: 3)': 'Esforço perceptível (BS: 3)',
	'Obvious effort; Unchanged facial expression (BS: 4-5)':
		'Esforço óbvio; Sem mudanças na expressão facial (BS: 4-5)',
	'Substantial effort; Changes expression (BS: 6-7)': 'Esforço substancial; Mudanças na expressão facial (BS: 6-7)',
	'Uses shoulder or trunk for force (BS: 8-10)': 'Utiliza ombros ou tronco para força (BS: 8-10)',
	'Number of exertions observed': 'Núm. de esforços observados',
	'Total observation time': 'Tempo total da observação',
	'Average single exertion time': 'Tempo médio de cada esforço',
	'(total exertions * single exertion time) must be less than or equal to the total observation time':
		'(núm. de esforços * tempo médio por esforço) deve ser menor ou igual ao tempo da observação',
	seconds: 'segundos',
	hours: 'horas',
	Extension: 'Extensão',
	Flexion: 'Flexão',
	'Revised Strain Index (Moore and Garg)': 'Strain Index Revisado (Moore e Garg)',
	'Report Results': 'Relatório',
	'Revised Strain Index': 'Strain Index Revisado',
	'(Moore and Garg)': '(Moore e Garg)',

	// REBA
	'REBA Report Results': 'Relatório REBA',
	'REBA score of the workplace': 'Pontuação REBA do posto de trabalho',
	'Left leg': 'Perna esquerda',
	'Right leg': 'Perna direita',
	'Load less than 5kg (intermittent)': 'Carga menor do que 5kg (intermitente)',
	'Load from 5kg to 20kg (intermittent)': 'Carga de 5kg a 20kg (intermitente)',
	'Load from 5kg to 20kg (static or repetitive)': 'Carga de 5kg a 20kg (estática ou repetitiva)',
	'Bigger load 20kg of repetitive load or blows': 'Carga maior do que 20kg de repetição ou de pancadas',
	Unacceptable: 'Inaceitável',
	Force: 'Força',
	Torque: 'Torque',
	Load: 'Carga',
	'Select the load': 'Selecione a carga',
	'Select the number of repetitions': 'Selecione o número de repetições',
	Acceptable: 'Aceitável',
	Investigate: 'Investigar',
	'Investigate and change soon': 'Investigar e mudar logo',
	'Investigate and change now': 'Investigar e mudar agora',
	'REBA Score': 'Score REBA',
	'The 4 most critical body parts': 'As 4 partes mais críticas',
	'Viewing the selected body part': 'Visualizando a parte selecionada',
	minute: 'minuto',
	'Requested video data is old, please upload to continue':
		'Os dados do vídeo solicitado são antigos, faça o upload para continuar',
	'View score': 'Ver pontuação',
	'Unable to view': 'Não foi possivel a visualização',
	'Worst grade found in time': 'Pior score encontrado no tempo',
	'Worst score': 'Pior score',
	'Worst RPN': 'Pior RPN',

	// Angle time
	'Create risk range': 'Criar faixa de risco',
	'Report Results - Angle by Time': 'Relatório - Ângulo no Tempo',
	'Please fill all required fields': 'Favor preencher todos os campos necessários',

	// ACTION PLANS
	'Action Plan Title': 'Título do Plano de Ação',
	'Describe the situation detected...':
		'Descreva a situação detectada e as medidas preventivas já implementadas (se houver)',
	'Task created successfully': 'Tarefa criada com sucesso',
	'Do you want to delete this action plan?': 'Gostaria de remover este plano de ação?',
	'Action plan created successfully': 'Plano de ação criado com sucesso',
	'Action plan updated successfully': 'Plano de ação atualizado com sucesso',
	'Create action plan': 'Criar plano de ação',
	'Update action plan': 'Atualizar plano de ação',
	'Please enter a valid description': 'Por favor, digite uma descrição válida',
	'Action plan description': 'Descrição do plano de ação',
	'Please enter a valid action plan description': 'Por favor, insira uma descrição válida do plano de ação',
	'Person responsible': 'Responsável',
	Responsible: 'Responsável',
	'Who is responsible for this action plan?': 'Quem é o responsável por este plano de ação?',
	'Describe the situation found and the preventive measures already implemented (if exist)':
		'Descreva a situação encontrada e as medidas preventivas já implementadas (caso existam)',
	'Describe the situation detected and the preventive measures already implemented (if any)':
		'Descreva a situação detectada e as medidas preventivas já implementadas (se houver)',
	Deadline: 'Data de vencimento',
	Deadline: 'Validade',
	'Finish editing your other task first': 'Primeiro finalize a edição da outra tarefa',
	'Add a new task': 'Adicione uma nova tarefa',
	History: 'Histórico',
	'To Do': 'Não iniciadas',
	Doing: 'Fazendo',
	Done: 'Concluídas',
	'TO DO': 'A FAZER',
	DOING: 'FAZENDO',
	DONE: 'FEITO',
	'Finish by: ': 'Concluir até: ',
	'On time': 'No prazo',
	Overdue: 'Atrasado',
	'Report type': 'Tipo do relatório',
	'Select a report type': 'Selecione o tipo do relatório',
	'Finishing in a week': 'Finalizando em uma semana',
	'Person responsible updated': 'Responśavel pelo plano de ação atualizado',
	'Deadline updated': 'Prazo do plano de ação atualizado',
	Tasks: 'Tarefas',
	'Task created': 'Tarefa criada',
	'Task deleted': 'Tarefa removida',
	'Task renamed': 'Tarefa renomeada',
	'Task type changed': 'Tipo da tarefa modificada',
	'Task and type changed': 'Tarefa e tipo alterado',
	'Task checked': 'Tarefa concluída',
	'Task unchecked': 'Tarefa desfeita',
	'Action plan created': 'Plano de ação criado',
	'Action plan renamed': 'Plano de ação renomeado',
	'Status changed': 'Status alterado',
	'Deadline changed': 'Prazo alterado',
	'by ': 'por ',
	'Successfully updated action plan data': 'Dados do plano de ação atualizados com sucesso',
	'Responsible user changed': 'Responsável alterado',
	'Action plan title': 'Título do plano de ação',
	Title: 'Título',
	'Select a file': 'Selecione um arquivo',
	'Select an option': 'Selecione uma opção',
	'Please enter a valid title': 'Por favor, digite um título válido',
	'Please enter a responsible': 'Por favor, insira um responsável',
	'Please enter a valid date': 'Por favor, insira uma data válida',
	'Please select a condition': 'Por favor, selecione uma condição',
	'Search company': 'Buscar empresa',
	'Search industrial site': 'Buscar planta industrial',
	'Enter a valid email': 'Insira um e-mail válido',
	'Enter a description for your action plan.': 'Insira uma descrição para seu plano de ação.',
	'Select a condition': 'Selecione uma condição',
	Eliminate: 'Eliminar',
	Control: 'Controlar',
	Compensate: 'Compensar',
	ELIMINATE: 'ELIMINAR',
	CONTROL: 'CONTROLAR',
	COMPENSATE: 'COMPENSAR',
	'Date of Completion': 'Data de finalização',
	Investment: 'Investimento',
	Attachments: 'Anexos',
	Progress: 'Progresso',
	Evidence: 'Evidência',
	Author: 'Autor',
	Origin: 'Origem',
	'Manage Columns': 'Administrar Colunas',
	'Priority editing': 'Edição de prioridade',
	'Due Date editing': 'Edição de prazo de vencimento',
	'Responsible editing': 'Edição de responsável',
	'Are you sure you want to delete the selected action plans?':
		'Pretende mesmo eliminar os planos de ação selecionados?',
	'New Task': 'Nova Tarefa',
	'Are you sure you want to delete the selected task?': 'Tem certeza de que deseja excluir a tarefa selecionada?',

	// KIM - MHO
	'Error, cannot get "': 'Erro, não é possível obter "',
	'" from "': '" de "',
	'Total duration of this sub-activity per working day': 'Duração total da atividade por dia trabalhado',
	'Total duration per day worked': 'Duração total por dia trabalhado',
	'Force exerted on hand': 'Força exercida na mão',
	'fingers (L|R)': 'dedos (E|D)',
	'gripping conditions': 'condições de aderência',
	'Power transfer': 'Transferência de energia',
	'Type of force exertion in the finger/hand area within a “standard minute”':
		'Força exercida na área da mão/dedos em um "minuto padrão"',
	'Force transfer / gripping conditions': 'Transferência de força / condições de pega',
	'Hand/arm position and movement': 'Posição e movimento da mão/braço',
	'Unfavourable working conditions': 'Condições de trabalhos desfavoráveis',
	'Work organization / temporal distribution': 'Organização de trabalho / distribuição temporal',
	'Body posture/movement': 'Postura e movimento do corpo',
	'Very low': 'Muito baixa',
	Moderate: 'Moderada',
	'Peak forces': 'Forças de pico',
	'Powerful hitting': 'Batidas fortes',
	'Up to 15% Fmax. Button actuation, shifting, ordering, material guidance, insertion of small parts.':
		'Até 15% de Fmax. Acionamento de botão, deslocamento, ordenamento, orientação de material, inserção de peças pequenas.',
	'Up to 30% Fmax. Gripping, joining small work pieces by hand or with small tools.':
		'Até 30% de Fmax. Agarrar ou unir peças pequenas com a mão ou com ferramentas pequenas.',
	'Up to 50% Fmax. Turning, winding, packaging, grasping, holding or joining parts, pressing in, cutting, working with small powered hand tools.':
		'Até 50% de Fmax. Tornear, enrolar, embalar, agarrar, segurar ou unir peças, pressionar, cortar, trabalhar com pequenas ferramentas manuais motorizadas.',
	'Up to 80% Fmax. Cutting involving major element of force, working with small staple guns, moving or holding parts or tools.':
		'Até 80% de Fmax. Corte envolvendo grande elemento de força, trabalhando com pequenas pistolas de grampo, movendo ou segurando peças ou ferramentas.',
	'More than 80% Fmax. Tightening, loosening bolts, separating, pressing in.':
		'Mais de 80% de Fmax. Apertar, desapertar parafusos, separar, pressionar.',
	'Hitting with the ball of the thumb, palm of the hand or fist.':
		'Golpear com a ponta do polegar, palma da mão ou punho.',
	'Optimum force transfer/application': 'Transferência/aplicação de força ideal',
	'Restricted force transfer/application': 'Transferência/aplicação de força restrita',
	'Force transfer/application considerably hindered':
		'Transferência/aplicação de força consideravelmente prejudicada',
	'Optimum force application': 'Aplicação de força ideal',
	'Restricted force application': 'Aplicação de força restrita',
	'Force application considerably hindered': 'Aplicação de força consideravelmente prejudicada',
	'Working objects are easy to grip (e.g. bar-shaped, gripping grooves) / good ergonomic gripping design (grips, buttons, tools).':
		'Objetos de trabalho são fáceis de segurar (por exemplo, em forma de barra, ranhuras de preensão) / bom design ergonômico de preensão (alças, botões, ferramentas).',
	'Greater holding forces required / no shaped grips.':
		'Maiores forças de pega necessárias / alças sem formato ergonômico.',
	'Working objects hardly possible to grip (slippery, soft, sharp edges) / no or only unsuitable grips.':
		'Objetos de trabalho dificeis de segurar (escorregadios, macios, bordas afiadas) / apenas alças inadequados ou nenhuma.',
	Restricted: 'Restrita',
	Unfavourable: 'Desfavorável',
	'Position or movements of joints in the middle (relaxed) range, only rare deviations, no continuous static arm posture, hand-arm rest possible as required.':
		'Posição ou movimentos das articulações no intervalo médio (relaxado), apenas desvios raros / sem postura estática contínua do braço / apoio mão-braço possível conforme necessário.',
	'Occasional positions or movements of the joints at the limit of the movement ranges, occasional long continuous static arm posture.':
		'Posições ou movimentos ocasionais das articulações no limite das amplitudes de movimento, postura de braço ocasionalmente estática, longa e contínua.',
	'Frequent positions or movements of the joints at the limit of the movement ranges, frequent long continuous static arm posture.':
		'Posições ou movimentos das articulações frequentemente no limite das amplitudes de movimento, postura de braço frequentemente estática, longa e contínua.',
	'Constant positions or movements of the joints at the limit of the movement ranges, constant long continuous static arm posture.':
		'Posições ou movimentos das articulações constantemente no limite das amplitudes de movimento, postura de braço constantemente estática, longa e contínua.',
	'Frequent variation of the physical workload situation due to other activities (including other types of physical workload) / without a tight sequence of higher physical workloads within one type of physical workload during a single working day.':
		'Variação frequente da situação de carga de trabalho física devido a outras atividades (incluindo outros tipos de carga de trabalho física) / sem uma sequência estreita de cargas de trabalho físicas mais altas dentro de um tipo de carga de trabalho física durante um único dia de trabalho.',
	'Rare variation of the physical workload situation due to other activities (including other types of physical workload) / occasional tight sequence of higher physical workloads within one type of physical workload during a single working day.':
		'Variação rara da situação de carga de trabalho física devido a outras atividades (incluindo outros tipos de carga de trabalho física) / sequência restrita ocasional de cargas de trabalho físicas mais altas dentro de um tipo de carga de trabalho física durante um único dia de trabalho.',
	'No/hardly any variation of the physical workload situation due to other activities (including other types of physical workload) / frequent tight sequence of higher physical workloads within one type of physical workload during a single working day with concurrent high load peaks.':
		'Nenhuma/quase nenhuma variação da situação de carga de trabalho física devido a outras atividades (incluindo outros tipos de carga de trabalho física)/sequência estreita frequente de cargas de trabalho físicas mais altas dentro de um tipo de carga de trabalho físico durante um único dia de trabalho com picos de carga elevados simultâneos.',
	'There are no unfavourable working conditions, i.e. reliable recognition of detail / no dazzle / good climatic conditions.':
		'Não há condições de trabalho desfavoráveis, ou seja, reconhecimento confiável de detalhes / sem encandeamento / boas condições climáticas.',
	'Occasionally impaired detail recognition due to dazzle or excessively small details difficult conditions such as draught, cold, moisture and/or disturbed concentration due to noise.':
		'Reconhecimento de detalhes ocasionalmente prejudicado devido a ofuscamento ou detalhes excessivamente pequenos condições difíceis como corrente de ar, frio, umidade e/ou concentração perturbada devido ao ruído.',
	'Frequently impaired detail recognition due to dazzle or excessively small details frequently difficult conditions such as draught, cold, moisture and/or disturbed concentration due to noise.':
		'Reconhecimento de detalhes frequentemente prejudicado devido a ofuscamento ou detalhes excessivamente pequenos condições frequentemente difíceis, como correntes de ar, frio, umidade e/ou concentração perturbada devido ao ruído.',
	'Alternation between sitting and standing, alternation between standing and walking, dynamic sitting possible':
		'Alternância entre sentado e em pé, alternância entre em pé e andando, assento dinâmico possível',
	'Trunk inclined forward only very slightly': 'Tronco inclinado para a frente apenas muito ligeiramente',
	'No twisting and/or lateral inclination of the trunk identifiable':
		'Sem torção e/ou inclinação lateral do tronco identificável',
	'Head posture: variable, head not inclined backward and/or severely inclined forward or constantly moving':
		'Postura da cabeça: variável, cabeça não inclinada para trás e/ou severamente inclinada para frente ou em constante movimento',
	'No gripping above shoulder height / no gripping at a distance from the body':
		'Sem preensão acima da altura do ombro/sem preensão à distância do corpo',
	'Predominantly sitting or standing with occasional walking':
		'Predominantemente sentado ou em pé com caminhada ocasional',
	'Trunk with slight inclination of the body towards the work area':
		'Tronco com leve inclinação do corpo em direção à área de trabalho',
	'Occasional twisting and/or lateral inclination of the trunk identifiable':
		'Torção ocasional e/ou inclinação lateral do tronco identificável',
	'Occasional deviations from good “neutral” head posture/movement':
		'Desvios ocasionais da boa postura/movimento “neutro” da cabeça',
	'Occasional gripping above shoulder height / occasional gripping at a distance from the body':
		'Apreensão ocasional acima da altura do ombro/apreensão ocasional à distância do corpo',
	'Exclusively standing or sitting without walking': 'Exclusivamente em pé ou sentado sem andar',
	'Trunk clearly inclined forward and/or frequent twisting and/or lateral inclination of the trunk identifiable':
		'Tronco claramente inclinado para frente e/ou torção frequente e/ou inclinação lateral do tronco identificável',
	'Frequent deviations from good “neutral” head posture/movement':
		'Desvios frequentes da boa postura/movimento “neutro” da cabeça',
	'Head posture hunched forward for detail recognition / restricted freedom of movement':
		'Postura da cabeça curvada para a frente para reconhecimento de detalhes/liberdade de movimento restrita',
	'Frequent gripping above shoulder height / frequent gripping at a distance from the body':
		'Preensão frequente acima da altura do ombro/preensão frequente à distância do corpo',
	'Trunk severely inclined forward / frequent or long-lasting bending':
		'Tronco fortemente inclinado para a frente/flexão frequente ou de longa duração',
	'Work being carried out in a kneeling, squatting, lying position':
		'Trabalho sendo realizado em posição ajoelhada, agachada e deitada',
	'Constant twisting and/or lateral inclination of the trunk identifiable':
		'Torção constante e/ou inclinação lateral do tronco identificável',
	'Body posture strictly fixed / visual check of action through magnifying glasses or microscopes':
		'Postura corporal estritamente fixa/verificação visual da ação através de lupas ou microscópios',
	'Constant deviations from good “neutral” head posture/movement':
		'Desvios constantes da boa postura/movimento “neutro” da cabeça',
	'Constant gripping above shoulder height / constant gripping at a distance from the body':
		'Pegada constante acima da altura do ombro/pegada constante a uma distância do corpo',
	'Manual Handling': 'Manuseio Manual',
	'Manual Handling Operations': 'Operações de Manuseio Manual',
	'KIM - Manual Handling Operations': 'KIM - Operações de Manuseio Manual',
	'Total duration per working day': 'Duração total por dia trabalhado',
	'Type of force exertion in the finger/hand (left | right)': 'Força exercida na área da mão/dedos (esq. | dir.)',
	'Probability of physical overload': 'Probabilidade de sobrecarga fisica',
	'Possible health consequences': 'Possíveis consequências à saúde',
	Measures: 'Medidas',
	'No measures need to be taken.': 'Nenhuma medida precisa ser tomada.',
	'Physical overload is unlikely.': 'Sobrecarga física não é provável.',
	'No health risk is to be expected.': 'Nenhum risco à saúde é esperado.',
	'None.': 'Nenhum.',
	'Physical overload is possible for less resilient persons.':
		'Sobrecarga física é possível para pessoas menos resilientes.',
	'Fatigue, low-grade adaptation problems which can be compensated for during leisure time.':
		'Fadiga, problemas de adaptação de baixo grau que podem ser compensados durante o tempo livre.',
	'For less resilient persons, workplace redesign and other prevention measures may be helpful.':
		'Para pessoas menos resilientes, mudanças no local de trabalho e outras medidas preventivas podem ser de ajuda.',
	'Physical overload is possible for normally resilient persons.':
		'Sobrecarga física é possível para pessoas normalmente resilientes.',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation.':
		'Distúrbios (dor), possivelmente incluindo disfunções, reversíveis na maioria dos casos, sem manifestação morfológica.',
	'Workplace redesign and other prevention measures should be considered.':
		'Mudanças no local de trabalho e outras medidas preventivas devem ser consideradas.',
	'Physical overload is likely.': 'Sobrecarga física é provável.',
	'More pronounced disorders and/or dysfunctions, structural damage with pathological significance.':
		'Distúrbios e/ou disfunções mais pronunciados, danos estruturais com significado patológico.',
	'Workplace redesign measures are necessary. Other prevention measures should be considered.':
		'Mudanças no local de trabalho são necessárias, outras medidas preventivas devem ser consideradas.',
	'Slightly increased': 'Ligeiramente elevada',
	'Substantially increased': 'Substancialmente elevada',
	'Type of force exertion in the finger/hand area': 'Tipo de esforço realizado na área da mão/dedos',
	'Intensity of force exertion in the finger/hand area within a "standard minute"':
		'Intensidade da força exercida na área da mão/dedos em um "minuto padrão"',
	Holding: 'Segurando',
	Moving: 'Movendo',
	'average (seconds holding / minute)': 'média (segundos segurando / min.)',
	'average (movements / minute)': 'média (movimentos / min.)',
	'Left arm': 'Braço esquerdo',
	'Right arm': 'Braço direito',

	'Time and force': 'Tempo e força',
	Conditions: 'Condições',
	Posture: 'Postura',

	'Select the body parts you are interested in': 'Selecione as partes do corpo que lhe interessam',
	'Select all': 'Selecionar todos',

	'Shoulder L': 'Ombro E',
	'Shoulder R': 'Ombro D',
	'Elbow L': 'Cotovelo E',
	'Elbow R': 'Cotovelo D',
	'Leg L': 'Perna E',
	'Leg R': 'Perna D',

	Cycle: 'Ciclo',
	'Select the cycle': 'Selecione o ciclo',
	'Select one of the vehicles or a wheel type:': 'Selecione um dos veículos ou um tipo de roda',
	Conveyors: 'Transportador',
	Cranes: 'Guindastes',
	'Driveway conditions:': 'Condições do piso:',
	'Select the mass to be transported (in kg):': 'Selecione a massa a ser transportada (em kg):',
	'Inclination or stairs:': 'Inclinação ou escadas:',
	'Conditions:': 'Condições:',

	'Increased movement speed (approx. 1.0 up to 1.3 m/s)': 'Maior velocidade de movimento (aprox. 1,0 até 1,3 m/s)s',

	//Preliminary Ergonomic Analysis

	//Error
	'length must be less than or equal to 50 characters long': 'comprimento deve ser menor ou igual a 50 caracteres',

	'Preliminary Ergonomic Analysis': 'Avaliação Ergonômica Preliminar',

	//Super Preliminary Ergonomic Analysis

	'Basic Information': 'Informações Básicas',
	'Select PEA': 'Seleção de AEP',

	"To generate this document, it's necessary that the EWA's must be consolidated, so the list below only shows the consolidated EWA's.":
		"Para gerar esse documento é necessário que as AEP's sejam consolidadas, por isso a lista abaixo apresenta apenas as AEPs consolidadas.",

	// Basic Informartion Step
	'Report Information': 'Dados do relatório',
	'Report name': 'Nome do relatório',
	'Enter report name': 'Digite o nome do relatório',
	'Select a Company': 'Selecione uma empresa',
	'Select the reference date': 'Selecione a data de referência',
	'Select the report date': 'Selecione a data do relatório',

	// Select PEA Step
	'File Name': 'Nome do arquivo',
	'File name': 'Nome do arquivo',
	'Created At': 'Criado em',
	'Uploaded date': 'Data de upload',
	'Date of creation': 'Data de criação',
	'Date of update': 'Data de atualização',
	'Analyst Name': 'Analista',
	Submit: 'Finalizar',

	//Signatures Step
	Signatures: 'Assinaturas',
	'Enter with a role': 'Digite o cargo/função',
	'Enter with a name of responsible': 'Digite o nome do responsável',
	'Add a new signature': 'Adicione uma assinatura',
	'Responsible name': 'Nome do responsável',
	'Responsibles selection': 'Seleção de responsáveis',
	'Technical manager': 'Responsável técnico',
	'Document type': 'Tipo de documento',
	'Document number': 'Número do documento',
	'Create responsible': 'Criar responsável',
	'Responsible role': 'Cargo do responsável',
	'Generate Document': 'Gerar Documento',
	'Generating document': 'Gerando documento',
	'Document generated successfully': 'Documento gerado com sucesso',
	'Failed to generate document': 'Falha ao gerar documento',
	'At least one signature is required': 'Pelo menos uma assinatura é necessária',
	'Responsible created successfully': 'Responsável criado com sucesso',
	'Failed to create responsible': 'Falha ao criar responsável',
	'Responsible updated successfully': 'Responsável atualizado com sucesso',
	'Failed to update responsible': 'Falha ao atualizar responsável',
	'Responsible deleted successfully': 'Responsável excluído com sucesso',
	'Failed to delete responsible': 'Falha ao excluir responsável',
	'Edit responsible': 'Editar responsável',
	'Delete responsible': 'Excluir responsável',
	'Are you sure you want to delete this responsible?': 'Tem certeza que deseja excluir este responsável?',
	'Responsible selected': 'Responsáveis selecionados',
	'New responsible': 'Novo responsável',
	'Select the responsibles who will sign this ergonomic work analysis document': 'Adicione assinaturas à análise',
	'Update responsible': 'Atualizar responsável',
	'Position/Role': 'Cargo/Função',
	'Document Type': 'Tipo de documento',
	'Document Number': 'Número do documento',

	// Conclusion Step
	'Check selected Files': 'Confira os Arquivos selecionados',
	'Files List': 'Lista de Arquivos',
	'Selected EWA': 'Análises Selecionadas.',
	'EWA created successfully': 'AEP criada com sucesso.',
	'Failed to upload PEA report.': 'Falha ao criar a AEP.',

	// Super PEA File History
	'Preliminary Ergonomic Analyzes': 'Avaliações Ergonômicas Preliminares',
	'Selected Files': 'Arquivos selecionados',
	'Worst Score': 'Pior Avaliação',
	'Open File List': 'Abrir Lista de Arquivos',
	'EWA deleted successfully': 'PEA removida com sucesso.',

	//Others words
	Men: 'Homens',
	Women: 'Mulheres',
	Likelihood: 'Probabilidade',
	Exposure: 'Exposição',
	'Possible Injuries/Harms': 'Possíveis lesões/danos',
	Job: 'Trabalho',
	'Assignment note': 'Nota da Tarefa',
	'Hours worked in the day': 'Horas trabalhadas no dia',
	'Weight Limit recommended (WLR)': 'Limite de peso recomendado (LPR)',
	'Lifting index (LI)': 'Índice de elevação (IL)',
	Comment: 'Comentário',
	Particularities: 'Particularidades',
	Production: 'Produção',
	'Working regime': 'Regime de trabalho',
	EWA: 'AET',
	'New document': 'Novo documento',
	'File history': 'Histórico de arquivos',
	'Items per page': 'Itens por página',
	'New Report': 'Novo Relatório',
	Analysis: 'Análise',

	//Action plans cards
	'Fill in the details above': 'Preencha os dados acima',

	'Risk Acceptable': 'Risco Aceitável',

	'Immediate action for improvement and reassess': 'Ação Imediata de melhoria e reavaliar',

	'Improvement action': 'Ação de melhoria',

	'Risk Very High': 'Risco Muito Elevado',
	'Perform Ergonomic Work Analysis': 'Realizar Avaliação Ergonômica do Trabalho',

	'Risk Serious and Imminent': 'Risco Grave e Iminente',
	'Stop the activity and carry out an Ergonomic Work Analysis':
		'Parar a atividade e realizar avaliação ergonômica do trabalho',

	//Possible injuries
	'Possible injuries': 'Possíveis lesões/agravos',
	'Fatigue complaints': 'Queixas de fadiga',
	Absenteeism: 'Absenteismo',
	'Musculoskeletal complaints': 'Queixas osteomusculares',
	'Complaints of mental overload': 'Queixas de esgotamento mental',
	'Complaints of irritability': 'Queixas de irritabilidade',
	'Nonconforming products': 'Produtos não conforme',
	'Low back pain complaints': 'Queixas de lombalgia',
	'Elbow pain': 'Dor de cotovelo',
	'Shoulder pain': 'Dor no ombro',
	Headache: 'Dor de cabeça',
	'Unexcused absences': 'Faltas não justificadas',
	'Neck pain': 'Dor de pescoço',
	'Wrist pain': 'Dor no punho',

	//Consequence
	Consequence: 'Consequência',
	'Severe with fatalities and serious injuries': 'Severo com mortes e lesões graves',
	'Temporary disability': 'Incapacidade temporária',
	'Injuries with leave': 'Lesões/dano com afastamentos',
	'Severe with possibility of death or disability': 'Grave com possibilidade de morte ou incapacidade',
	'Superficial injuries': 'Lesões/dano superficiais',
	'Catastrophic with numerous deaths': 'Catastrófico com inúmeras mortes',

	//Probability
	Probability: 'Probabilidade',
	'Most likely and expected outcome': 'Resultado mais provável e esperado',
	'Extremely remote possibility': 'Extremamente remota a possibilidade',
	'Practically impossible, never happened': 'Praticamente impossível, nunca ocorreu',
	'Unlikely, but it has happened': 'Pouco provável, mas já ocorreu',
	'Possible outcome': 'Resultado possível',
	'Rare but possible': 'Raro, porém, possível ',

	//Exhibition
	'Remotely (never occurred)': 'Remotamente (nunca ocorreu)',
	'Rarely (occurs in short bursts without definition)': 'Raramente (ocorre em curtos espaços sem definição)',
	'Irregular (once a month to once a year)': 'Irregular (uma vez ao mês até uma vez ao ano)',
	'Occasionally (once a week to once a month)': 'Ocasionalmente (uma vez na semana até uma vez ao mês)',
	'Frequent (at least once a day)': 'Frequente (pelo menos uma vez ao dia)',
	'Continues (several times a day)': 'Contínua (várias vezes ao dia)',
	'Remotely (>90% green)': 'Remotamente (>90% verde)',
	'Rarely (80 to 89% green)': 'Raramente (80 a 89% verde)',
	'Irregular (50 to 79% green)': 'Irregular (50 a 79% verde)',
	'Occasionally (30 to 49% green)': 'Ocasionalmente (30 a 49% verde)',
	'Frequent (10 to 29% green)': 'Frequente (10 a 29% verde)',
	'Continues (<9% green)': 'Contínua (<9% verde)',

	//Steps erros
	'Select the injuries': 'Selecione uma ou muitas lesões/agravos',
	'Select the consequence': 'Selecione a Consequência',
	'Select the probability': 'Selecione a Probabilidade',
	'Select the exhibition': 'Selecione a Exposição',
	"Some required steps wasn't filled": 'Dados obrigatórios não preenchidos',

	//Step 1
	Informations: 'Informações',
	'Select the sector': 'Selecione o setor',
	Analyst: 'Analista',
	'Insert the analyst': 'Insira um analista',
	Responsibility: 'Cargo/Função',
	'Insert the responsibility': 'Insira um cargo/função',
	'Insert the cell': 'Insira uma célula',
	'Insert the activity': 'Insira uma atividade',
	'Insert the workstation': 'Insira o posto de trabalho',
	'Enter the collection date': 'Insira a data de coleta',

	//Step 2
	'Work Conditions': 'Condições de trabalho',
	'Select the constraints perceived in the evaluated work condition':
		'Selecione as restrições percebidas na condição de trabalho avaliada',
	'Work schedule': 'Horário de trabalho',
	'Summary description of the place': 'Descrição sumária do local',
	'Simplified description of the expected task': 'Descrição simplificada da tarefa prevista',
	'Simplified description of the task performed': 'Descrição simplificada da tarefa realizada',

	//Step 3
	'Working population': 'População trabalhadora',
	'Working population percentages must sum up to 100%.':
		'As porcentagens da população trabalhadora devem somar 100%.',
	"Worker's verbalization": 'Verbalização dos trabalhadores',
	'Self-evaluation': 'Autoavaliação',
	'What is the level of stress perceived by the worker when performing the task?':
		'Qual é o nível de estresse percebido pelo trabalhador ao realizar a tarefa?',
	'Nothing stressful': 'Nada estressante',
	'Little stressful': 'Pouco estressante',
	'Not too stressful': 'Pouco estressante',
	'Working population must be greater than 0': 'A população de trabalhadores deve ser maior que 0',
	workers: 'trabalhadores',
	Stressful: 'Estressante',
	'Update the tool': 'Atualize a ferramenta',
	'Tool already set': 'Ferramenta já definida',
	'Tool not set yet': 'Ferramenta ainda não definida',
	'Very stressful': 'Muito estressante',
	'Extremely stressful': 'Extremamente estressante',

	//Step 4
	'Workday and concentration at work': 'Jornada e concentração no trabalho',
	'Working hours of more than 8 hours a day': 'Jornada de trabalho superior à 8h por dia',
	'Existence of long and frequent overtime hours of work':
		'Existência de longas e frequentes horas extras de trabalho',
	'Stays long time continuous operation': 'Permanece longo tempo de operação contínua',
	'Insufficient rest interval': 'Intervalo de descanso insuficiente',
	'Insufficient rest break': 'Intervalo de descanso insuficiente',
	'Insufficient rest days': 'Dias de descanso insuficientes',
	'Unbalanced concentrations of work in a day, week, month or year':
		'Concentrações desequilibradas de trabalho em um dia, semana, mês ou ano',
	'Unbalanced concentrations of work among workers': 'Concentrações desequilibradas de trabalho entre trabalhadores',
	'Insufficient rest between shifts (less than 11 hours)': 'Descanso insuficiente entre turnos (menos de 11 h)',
	'Remains long time continuous operation': 'Permanece longo tempo de operação contínua',

	//Step 5
	'Kind of work': 'Tipo de trabalho',
	'Lift and/or carry heavy objects': 'Levanta e/ou carrega objetos pesados',
	'Apply the tool': 'Aplique a ferramenta',
	'Load surveys': 'Carregar pesquisas',
	'Lifts and/or carries objects farther than 60 cm': 'Levanta e/ou carrega objetos mais distantes que 60 cm',
	'Performs tasks that require great strength': 'Realiza tarefas que requerem grande força',
	'Performs tasks that require pronounced pushing and pulling forces':
		'Realiza tarefas que exigem forças acentuadas para empurrar e puxar',
	'Performs repetitive work': 'Realiza trabalho repetitivo',
	'Performs work that requires frequent finger, hand, or arm movements':
		'Realiza trabalho que requer movimentos frequentes de dedo, mão ou braço',
	'Do intensive work with a keyboard or other input devices':
		'Realiza trabalho intensivo com um teclado ou outros dispositivos de entrada de dados',
	'Perform precision work': 'Realiza trabalho de precisão',
	'Performs activities with high visual requirements': 'Realiza atividades de requisitos visuais elevados',

	//Step 6
	'Postures and movements': 'Posturas e movimentos',
	'Stays in uncomfortable postures and movements': 'Permanece em posturas e movimentos desconfortáveis',
	'Performs continuous and/or highly frequent change in joint positions':
		'Realiza mudança contínua e/ou altamente frequente nas posições das articulações',
	'Stays in constrained posture for long duration': 'Permanece em postura restrita de longa duração',
	'Walk for long duration and/or long distance (on a horizontal surface as well as an inclined surface)':
		'Realiza caminhada de longa duração e/ou longa distância (em superfície horizontal bem como em uma superfície inclinada)',
	'Performs frequent stair climbing': 'Realiza subida de escada frequente',
	'Remains in a sedentary/standing position for a long time':
		'Permanece tempo prolongado em posição sedentária/de pé',
	'Postures requirements (Kinebot)': 'Exigências posturais (Kinebot)',

	//Step 7
	'Influence of workspace and task factors': 'Influência do espaço de trabalho e de fatores da tarefa',
	'Workspace is inadequate and forces an uncomfortable posture or limited movement':
		'O espaço de trabalho é inadequado e força uma postura desconfortável ou movimento limitado',
	'Workstation layout requires excessive movement or uncomfortable postures':
		'O leiaute da estação de trabalho exige movimento excessivo ou posturas desconfortáveis',
	'The heights, distances and dimensions of controls or work surfaces are inadequate':
		'As alturas, distâncias e dimensões dos comandos ou superfície de trabalho são inadequadas',
	'Anthropometry Table x Furniture (cm)': 'Tabela da Antropometria x Mobiliário (cm)',
	'Add information': 'Adicionar informações',
	'Found (cm)': 'Encontrado (cm)',
	'Foreseen (cm)': 'Previsto (cm)',
	'Enter a location': 'Qual a localização',
	'Enter what was found': 'Onde foi encontrado',
	'Insert predicted': 'Insira a previsão',
	'Performs handling of work objects above the shoulder or below the knee':
		'Realiza manuseio de objetos de trabalho acima do ombro ou abaixo do joelho',
	'The workspace forces the worker to maintain the same working posture':
		'O espaço de trabalho força o trabalhador a manter a mesma postura de trabalho',
	'Handles work objects that are difficult to handle and slippery':
		'Manuseia objetos de trabalho que sejam difíceis de manusear ou escorregadios',
	'Activity requires high-voltage contact or local pressure acting on the body':
		'Atividade exige alta-tensão de contato ou pressão local que age no corpo',

	//Step 8
	'Influence of psychosocial factors': 'Influência de fatores psicossociais',
	'Activity with mental overload or underload': 'Atividade com sobrecarga ou subcarga mental',
	'Work pace with time pressure and high demands': 'Ritmo de trabalho com pressão de tempo e altas demandas',
	'Presence of work-related stress': 'Presença estresse relacionado ao trabalho',
	'Reports of low job satisfaction': 'Relatos de baixa satisfação no trabalho',
	'Activity with lack of autonomy (low influence, low control)':
		'Atividade com falta de autonomia (baixa influência, controle baixo)',
	'Low social support': 'Baixo apoio social',

	//Step 9
	'Influence of environmental factors': 'Influência de fatores do meio ambiente',
	'Place with slippery and/or uneven floor': 'Local com piso escorregadio e/ou irregular',
	'There is exposure to whole body vibration (see ISO 2631)':
		'Existe exposição a vibração em todo o corpo (ver ISO 2631)',
	'Makes use of hand-arm vibration tools during work; (see ISO 5349)':
		'Faz uso de ferramentas de vibração mão-braço durante o trabalho (ver ISO 5349)',
	'Makes use of hand-arm vibration tools during work (see ISO 5349)':
		'Faz uso de ferramentas de vibração mão-braço durante o trabalho (ver ISO 5349)',
	'Performs work using vehicles that transmit vibration throughout the body':
		'Realiza trabalho usando veículos que transmitem vibração em todo o corpo',
	'Hot or cold working environment': 'Local ambiente de trabalho quente ou frio',
	'Location with background noise': 'Local com ruido de fundo ',

	//Step 10
	'Organizational influences': 'Influência organizacionais',
	'Production standards are not clear or understood by workers':
		'As normas de produção não são claras ou compreendidas pelos trabalhadores',
	'The operative mode descriptions are insufficient or wrong':
		'As descrições de modo operatório são insuficientes ou erradas',
	'The time to carry out the activities is inadequate': 'O tempo para realizar as atividades é inadequado',
	'The pace of work is accelerated': 'O ritmo de trabalho é acelerado',
	'The content of the tasks is different from the technical means available':
		'O conteúdo das tarefas é diferente dos meios técnicos disponíveis ',
	'Task with high cognitive demand': 'Tarefa com grande exigência cognitiva',

	// Results
	'Anthropometry Table': 'Tabela de antropometria',
	'Consolidate analysis': 'Consolidar análise',
	Deconsolidate: 'Desconsolidar',
	'Deconsolidate report': 'Desconsolidar relatório',
	'By deconsolidating, the report will be updated to revision JDS-D86 04/2025. Do you want to proceed?':
		'Ao desconsolidar, o relatório será atualizado para revisão JDS-D86 04/2025. Deseja prosseguir?',
	'Successfully consolidated analysis': 'Análise consolidada com sucesso',
	'Successfully deconsolidated analysis': 'Análise desconsolidada com sucesso',
	'Failed to generate the report': 'Falha ao gerar o relatório',
	'Failed to generate PDF': 'Falha ao gerar o PDF',

	'Cannot change a consolidated analysis': 'Não é possível alterar uma análise consolidada',
	'Comments successfully saved': 'Comentários salvos com sucesso',

	'Action plan deleted successfully': 'Plano de ação removido com sucesso',

	'Task deleted successfully': 'Tarefa removida com sucesso',
	'Task updated successfully': 'Tarefa atualizada com sucesso',

	'Ops... something happened!': 'Ops... algo aconteceu!',
	'It was not possible to save your information': 'Não foi possível salvar suas informações',

	Hazardous: 'Perigoso',
	'Movement by score (Kinebot/REBA)': 'Movimento por score (Kinebot/REBA)',
	'Cargo Handling (NIOSH)': 'Manuseio de carga (NIOSH)',
	'Manual Handling (KIM)': 'Operações de manuseio manual (KIM MHO)',
	'Push and Pull (KIM)': 'Empurrar e puxar (KIM PP)',
	'No more action plans available': 'Não há mais planos de ação disponíveis',
	'No more workstations available': 'Não há mais postos de trabalho disponíveis',

	'No task available': 'Não há tarefas disponíveis',
	day: 'dia',
	days: 'dias',

	Location: 'Localização',
	Found: 'Encontrado',
	Foreseen: 'Previsto',
	Condition: 'Condição',

	'NOT OK': 'NÃO OK',
	"Score's sum": 'Somatório',

	// Do not change due to AEP key - Influences the translation of action plans created by AEP
	'Trunk posture from Kinebot': 'Postura do tronco da Kinebot',
	'Trunk posture from kinebot': 'Postura do tronco da kinebot',
	'Neck posture from Kinebot': 'Postura do pescoço da Kinebot',
	'Neck posture from kinebot': 'Postura do pescoço da kinebot',
	'Left elbow posture from Kinebot': 'Postura do cotovelo esquerdo da Kinebot',
	'Left elbow posture from kinebot': 'Postura do cotovelo esquerdo da kinebot',
	'Right elbow posture from Kinebot': 'Postura do cotovelo direito da Kinebot',
	'Right elbow posture from kinebot': 'Postura do cotovelo direito da kinebot',
	'Left shoulder posture from Kinebot': 'Postura do ombro esquerdo da Kinebot',
	'Left shoulder posture from kinebot': 'Postura do ombro esquerdo da kinebot',
	'Right shoulder posture from Kinebot': 'Postura do ombro direito da Kinebot',
	'Right shoulder posture from kinebot': 'Postura do ombro direito da kinebot',

	'Failed to upload the file': 'Falha ao realizar o upload do arquivo',

	// Two-factor authentication
	// API Errors
	'Two-factor authentication not found': 'Autenticação em dois fatores não encontrada',
	'Already created two-factor authentication': 'Autenticação em dois fatores já criada',
	'Invalid token': 'Token inválido',
	'Token already validated': 'Token já validado',
	'Token not yet validated': 'Token não validado ainda',
	'Token expired': 'Token expirado',
	'Too early to resend email': 'Muito cedo para reenviar o e-mail',
	'Something went wrong checking token': 'Algo deu errado ao verificar o token',
	'Authentication type same as default': 'Tipo de autenticação é o mesmo do atual',
	'Authentication type through app already enabled': 'Autenticação pelo aplicativo já habilitada',
	'Two-factor authentication not enabled': 'Autenticação em dois fatores não habilitada',
	'Too many tries!': 'Muitas tentativas!',
	'Too many calls! Wait a moment to try again.': 'Muitas chamadas. Espere um momento e tente novamente.',
	'You are not authorized to access this resource': 'Você não tem permissão para usar esse recurso',

	// Hooks success message
	'Two-factor authentication generated successfully': 'Autenticação em dois fatores gerada com sucesso',
	'Two-factor authentication validated successfully': 'Autenticação em dois fatores validada com sucesso',
	'Two-factor authentication method changed successfully':
		'Método de autenticação em dois fatores alterado com sucesso',
	'Token sent successfully': 'Token enviado com sucesso',
	'Token resent successfully': 'Token reenviado com sucesso',
	'Authenticator app enabled successfully': 'Aplicativo de autenticação habilitado com sucesso',
	'Two-factor authentication deleted successfully': 'Autenticação em dois fatores deletada com sucesso',
	'Two-factor authentication reset successfully': 'Autenticação em dois fatores recuperada com sucesso',
	'Forced two-factor authentication enabled successfully':
		'Forçar autenticação em dois fatores habilitado com sucesso',
	'Forced two-factor authentication disabled successfully':
		'Forçar autenticação em dois fatores desabilitado com sucesso',

	// My Account
	'Force two-factor authentication to all users': 'Forçar autenticação em dois fatores para todos os usuários',
	'When activated, all users will be forced to activate two-factor authentication on login.':
		'Quando ativado, todos os usuários serão obrigados a ativar a autenticação em dois fatores ao fazer login.',
	'Two-factor authentication': 'Dois fatores de autenticação',
	'When activated, you will have to type a validation code every time you login.':
		'Quando ativado, você terá que digitar um código de validação toda vez que fizer o login.',
	'You can choose to receive your code by email or connect your authentication app with a QRCode.':
		'Você pode optar por receber o código por email ou conectar seu aplicativo de autenticação com um código QR.',

	// Actions
	'Reset 2FA': 'Redefinir',
	'Deactivate 2FA': 'Desativar',
	'You are about to reset your authentication method.': 'Você está prestes a redefinir seu método de autenticação.',
	'Select a new desired authentication type and insert one of your recovery token to perform this operation.':
		'Selecione um novo método desejado e insira um dos tokens de recuperação para realizar essa ação.',
	'Authentication method': 'Método',
	'Recovery token': 'Token de recuperação',
	'Authenticator app': 'Aplicativo',
	'You are about to deactivate your 2FA.': 'Você está prestes a desativar sua autenticação em dois fatores.',
	'Confirming this action will delete your two-factor authentication. Are you sure?':
		'Confirmando essa ação, você irá desativar sua autenticação em dois fatores. Tem certeza disso?',
	'Heads up! Closing now will delete the token you generated. Want to continue?':
		'Atenção! Fechar agora implica em apagar o token que acabou de gerar. Quer continuar?',
	'Generate Two-factor authentication': 'Gerar autenticação em dois fatores',
	'Select a method to generate your two-factor authentication':
		'Selecione um método para sua autenticação em dois fatores',
	'With this method, you will scan a QRCode so you can use your favorite authenticator app (such as Google Authenticator or Microsoft Authenticator). Then, all you have to do is type the code shown in your app when you login. This code changes every few seconds.':
		'Com esse método, você irá escanear um código QR com seu aplicativo de autenticação preferido (como Google Authenticator ou Microsoft Authenticator). Então, tudo que tem a fazer é digitar o código que aparecer no seu aplicativo quando fizer o login. Esse código se altera a cada poucos segundos',
	'You are about to generate your 2FA with your authenticator app.':
		'Você está prestes a gerar sua autenticação em dois fatores pelo método de aplicativo.',
	'Be sure to have your mobile phone with you ready to scan your code.':
		'Certifique-se de ter seu telefone celular pronto para escanear seu código.',
	'Validation code': 'Código para validação',
	'Enter the 6 digit code.': 'Digite o código de 6 dígitos',
	'Recovery tokens': 'Códigos de recuperação',

	"Here are your recovery codes, which will be requested should you need to recover your account. Keep in mind that they will not be accessible again after this moment, so it's crucial that you save them securely.":
		'Aqui estão seus códigos de recuperação, que serão solicitados caso precise recuperar sua conta. Tenha em mente que eles não estarão mais acessíveis após este momento, então é crucial que os salve de maneira segura.',

	"Can't close yet. Read the instructions.": 'Não pode fechar essa janela ainda. Leia as instruções.',
	"Your company has asked for all users to keep two-factor authentication enabled for security reasons. You'll be asked to activate it again on your next login. Want to deactivate it anyway?":
		'Sua empresa solicitou que todos os usuários mantenham a autenticação de dois fatores habilitada por motivos de segurança. Você será solicitado a ativá-la novamente no próximo login. Deseja desativá-la mesmo assim?',

	//Login
	'For protection reasons, we need that you validate your 2FA':
		'Por razões de segurança, precisamos que faça sua validação em dois fatores',
	'Your company is requesting that all users must have two-factor authentication enabled. Continue to activate yours and login.':
		'Sua companhia está solicitando que todos os usuários tenham validação em dois fatores habilitado. Continue para ativar a sua e fazer o login',

	Change: 'Mudar',
	Security: 'Segurança',
	'Account security settings': 'Configurações de segurança da conta',
	'Account information summary': 'Resumo das informações da conta',
	'Password must be at least 8 characters long': 'A senha deve ter pelo menos 8 caracteres',
	'The password must have a maximum of 20 characters': 'A senha deve ter no máximo 20 caracteres',
	'The password field is required': 'O campo senha é obrigatório',
	'Password field cannot be empty': 'Campo de senha não pode estar vazio',
	'The password must contain capital letters': 'A senha deve conter letras maiúsculas',
	'The password must contain lowercase letters': 'A senha deve conter letras minúsculas',
	'Password must contain numbers': 'A senha deve conter números',
	'The password must contain at least one special character': 'A senha deve conter pelo menos um caractere especial',

	// Risks Manager
	Set: 'Definir',
	'Severity not set': 'Severidade não definida',
	'Manage risks': 'Gerenciar riscos',
	'Manage risk categories': 'Gerenciar categorias de risco',
	'Risk category': 'Categoria do risco',
	'Risk damage': 'Dano',
	'Risk category not found': 'Categoria não encontrada',
	'Risk description not found': 'Descrição não encontrada',
	'Risk damage not found': 'Dano não encontrado',
	'Select a risk damage': 'Selecionar dano',
	'Current severity': 'Severidade atual',
	'Severity set successfully': 'Severidade definida com sucesso',
	'Create new risk category': 'Criar nova categoria',
	'Update category name': 'Atualizar nome da categoria',
	'Delete category': 'Apagar categoria',
	'Category updated successfully': 'Categoria atualizada com sucesso',
	'Category deleted successfully': 'Categoria removida com sucesso',
	'Damage created successfully': 'Dano criado com sucesso',
	'Category created successfully': 'Categoria criada com sucesso',
	'Risk description created successfully': 'Descrição criada com sucesso',
	'Data created successfully': 'Dado criado com sucesso',
	'Data updated successfully': 'Dado atualizado com sucesso',
	'Data deleted successfully': 'Dado removido com sucesso',
	'Create new company': 'Cria nova empresa',
	'Company updated successfully': 'Empresa atualizada com sucesso',
	'Company deleted successfully': 'Empresa removida com sucesso',
	'All risk descriptions related to it will be deleted. Do you wish to proceed?':
		'Todas as descrições de riscos relacionadas a ela serão deletadas. Tem certeza que deseja prosseguir?',
	'Manage risk description': 'Gerenciar descrições de risco',
	'Select a risk description': 'Selecionar descrição do risco',
	'Want to delete this description?': 'Deseja excluir esta descrição?',
	'Want to delete this damage?': 'Deseja excluir este dano?',

	// B.E.R.A. Report
	Files: 'Arquivos',
	'Custom report': 'Relatório personalizado',
	'Custom reports': 'Relatórios customizados',
	'Custom reports files': 'Arquivos de relatórios personalizados',
	'Basic Ergonomics Risk Assessment (B.E.R.A.)': 'Avaliação Básica de Riscos Ergonômicos (B.E.R.A.)',
	'General informations': 'Informações gerais',
	'General view': 'Visão geral',
	'Insert below the informations for the cycle': 'Insira abaixo as informações para o ciclo',
	Organization: 'Organização',
	'Operator evaluated': 'Operador avaliado',
	'Enter a report name': 'Insira o nome do relatório',
	'Enter a evaluator': 'Insira o avaliador',
	'Work center': 'Centro de trabalho',
	Evaluator: 'Avaliador',
	'Select below the video files referring to the tasks that make up the cycle':
		'Selecione abaixo os arquivos de vídeo referentes às tarefas que compõem o ciclo',
	Task: 'Tarefa',
	'Insert below the informations related to the selected video':
		'Insira abaixo as informações relacionadas ao vídeo selecionado',
	'Task list ID (TLID)': 'ID da lista de tarefas (TLID)',
	'Task time': 'Tempo da tarefa',
	'Has known injury?': 'Existe algum histórico de lesão nessa tarefa?',
	'There is no presence of "Too High" movements': 'Não há presença de movimentos "Muito Alto"',
	'Too High': 'Muito Alto',
	'Stress level': 'Nível de estresse',
	'Job element': 'Elemento de trabalho',
	'Insert job element': 'Inserir elemento de trabalho',
	'Total task duration': 'Duração total da tarefa',
	'Select the task': 'Selecione a tarefa',
	'Insert a task duration': 'Insira a duração da tarefa',
	'Elbow to Shoulder - 1075 to 1425 mm (42.2 to 56 in)': 'Cotovelo ao Ombro - 1075 a 1425 mm (42,2 a 56 pol.)',
	'Shoulder to top of head  > 60 deg shoulder flex - 1425 to 1730 mm (56 to 68 in)':
		'Ombro até o topo da cabeça > flexão do ombro a 60 graus - 1425 a 1730 mm (56 a 68 pol.)',
	'Overhead work - >  1730 mm (> 68 in)': 'Trabalho acima da cabeça - > 1730 mm (> 68 pol.)',
	'1 per task': '1 por tarefa',
	'1 per minute': '1 por minuto',
	'2 per minute': '2 por minuto',
	'>2 per minute': '>2 por minuto',
	'<10% of Task': '<10% da tarefa',
	'<25% of Task': '<25% da tarefa',
	'<33% of Task': '<33% da tarefa',
	'<50% of Task': '<50% da tarefa',
	'>50% of Task': '>50% da tarefa',
	'Too Low': 'Muito Baixo',
	'There is no presence of "Too Low" movements': 'Não há presença de movimentos "Muito Baixo"',
	'Elbow to standing grip - 1075 to 800 mm (42.2 to 31.3 in)':
		'Cotovelo ao punho em pé - 1075 a 800 mm (42,2 a 31,3 pol.)',
	'Grip to knee - 800 to 550 mm (31.3 to 21.8 in)': 'Punho ao joelho - 800 a 550 mm (31,3 a 21,8 pol.)',
	'Below knee - < 550 mm (<21.8 in)': 'Abaixo do joelho - <550 mm (<21,8 pol.)',
	'Well Below Knee <255 mm (<10 in)': 'Bem abaixo do joelho <255 mm (<10 pol.)',
	'Too Far': 'Muito Longe',
	'There is no presence of "Too Far" movements': 'Não há presença de movimentos "Muito Longe"',
	'<300 mm (<12 inches) in front of body': '<300 mm (<12 polegadas) à frente do corpo',
	'300<460 mm (12<18 inches) in front of body': '300<460 mm (12<18 polegadas) à frente do corpo',
	'460<610 mm (18<24 inches) in front of body': '460<610 mm (18<24 polegadas) à frente do corpo',
	'610<915 mm (24<36 inches) in front of body': '610<915 mm (24<36 polegadas) à frente do corpo',
	'>915 mm (>36 inches) in front of body': '>915 mm (>36 polegadas) à frente do corpo',
	'Select the stress level': 'Selecionar o nível de estresse',
	'Select the frequency': 'Selecionar a frequência',
	'Select the total task duration': 'Selecionar a duração total da tarefa',
	'Too Many': 'Muitas Vezes',
	'There is no presence of "Too Many" movements': 'Não há presença de movimentos "Muitas vezes"',
	'Striking parts': 'Ajuste de peças',
	'Hand activities': 'Atividades manuais',
	'Small hammer (<.2 kg, <.3 lb)': 'Martelo pequeno (<0,2 kg, <0,3 lb)',
	'Mallet Use (< 1 kg, < 2.2 lb)': 'Uso do martelo de madeira (<1 kg, <2,2 lb)',
	'Using hand as a hammer': 'Usar a mão como martelo',
	'Hammer Use (< 1 kg, < 2.2 lb)': 'Uso do martelo (<1 kg, <2,2 lb)',
	'Sledge Hammer Use (> 2 kg, >4.5 lb)': 'Uso do martelo grande (>2 kg, >4,5 lb)',
	'Light tap 1/cycle': 'Toque leve 1/ciclo',
	'<10 per hour': '<10 por hora',
	'>10 per hour': '>10 por hora',
	'>20 per hour': '>20 por hora',
	'>30 per hour': '>30 por hora',
	'Populate using tool': 'Popular usando ferramenta',
	'Job Strain Index <3': 'Índice de Tensão do Trabalho <3',
	'Job Strain Index 3-5': 'Índice de Tensão do Trabalho 3-5',
	'Job Strain Index 5-7': 'Índice de Tensão do Trabalho 5-7',
	'Job Strain Index 7-12': 'Índice de Tensão do Trabalho 7-12',
	'Job Strain Index >12': 'Índice de Tensão do Trabalho >12',
	'Select at least one option.': 'Selecione pelo menos uma opção.',
	'Too Much': 'Muito Pesado',
	'There is no presence of "Too Much" movements': 'Não há presença de movimentos "Muito pesado"',
	Lifting: 'Levantamento',
	'Push/Pull One Hand': 'Empurrar/Puxar com uma mão',
	'Push/Pull Two Hand': 'Empurrar/Puxar com duas mãos',
	'Push/Pull Cart': 'Empurrar/Puxar um carrinho',
	'Tool Weight <2.3 kg (<5 lb)': 'Peso da ferramenta <2,3 kg (<5 lb)',
	'Tool Weight <4.5 kg (<10 lb)': 'Peso da ferramenta <4,5 kg (<10 lb)',
	'Tool Weight >4.5 kg (>10 lb)': 'Peso da ferramenta >4,5 kg (>10 lb)',
	'Tool Weight >7 kg (>15 lb)': 'Peso da ferramenta >7 kg (>15 lb)',
	'One hand force <3.6 kg (<8 lb)': 'Força com uma mão <3,6 kg (<8 lb)',
	'One hand force >3.6 kg (>8 lb)': 'Força com uma mão >3,6 kg (>8 lb)',
	'One hand force >6.8 kg (>15 lb)': 'Força com uma mão >6,8 kg (>15 lb)',
	'One hand force >9 kg (>20 lb)': 'Força com uma mão >9 kg (>20 lb)',
	'One hand force >11.3 kg (>25 lb)': 'Força com uma mão >11,3 kg (>25 lb)',
	'Two hand force <6 kg (<13 lb)': 'Força com duas mãos <6 kg (<13 lb)',
	'Two hand force >6 kg (>13 lb)': 'Força com duas mãos >6 kg (>13 lb)',
	'Two hand force >10 kg (>22 lb)': 'Força com duas mãos >10 kg (>22 lb)',
	'Two hand force >15 kg (>33 lb)': 'Força com duas mãos >15 kg (>33 lb)',
	'Two hand force >18 kg (>40 lb)': 'Força com duas mãos >18 kg (>40 lb)',
	'Cart Push/Pull Initial <23 kg (< 50lb)': 'Empurrar/Puxar carrinho Inicial <23 kg (< 50 lb)',
	'Cart Push/Pull Initial >23 kg (> 50lb)': 'Empurrar/Puxar carrinho Inicial >23 kg (> 50 lb)',
	'Cart Push/Pull Initial >29.5 kg (> 65lb)': 'Empurrar/Puxar carrinho Inicial >29,5 kg (> 65 lb)',
	'Cart Push/Pull Initial >34 kg (>75 lb)': 'Empurrar/Puxar carrinho Inicial >34 kg (>75 lb)',
	'No noticeable vibration': 'Sem vibração perceptível',
	'Slight hand vibration': 'Leve vibração nas mãos',
	'Noticeable vibration of hand': 'Vibração perceptível na mão',
	'Vibration in arm': 'Vibração no braço',
	'Too Long': 'Muito Longa',
	'There is no presence of "Too Long" movements': 'Não há presença de movimentos "Muito Longo"',
	'Inadequate Clearance': 'Espaço Insuficiente',
	'Contact Stress': 'Estresse de Contato',
	'Limited Hand Clearance': 'Espaço Limitado para as Mãos',
	'Limited Whole Body Clearance': 'Espaço Limitado para o Corpo Inteiro',
	'Limited Finger Clearance': 'Espaço Limitado para os Dedos',
	'Limited Arm Clearance': 'Espaço Limitado para os Braços',
	'Limited Hand Clearance with Part': 'Espaço Limitado para as Mãos com Peça',
	'Contact Stress <20 sec': 'Estresse de Contato <20 seg',
	'Contact Stress >20 sec': 'Estresse de Contato >20 seg',
	'Contact Stress >30 sec': 'Estresse de Contato >30 seg',
	Severity: 'Severidade',
	Vulnerability: 'Probabilidade',
	'Risk Priority Number (RPN)': 'Número de Prioridade de Risco (RPN)',
	'Collection Date': 'Data de Coleta',
	'Known injuries': 'Lesões conhecidas',
	'Has no injury history': 'Não possui histórico de lesões',
	'Has known injury': 'Possui lesão conhecida',
	'Last update': 'Última atualização',
	'Show reports': 'Mostrar relatórios',
	'Hide reports': 'Esconder',
	'Create B.E.R.A. report': 'Criar relatório B.E.R.A.',
	'Total evaluated time': 'Tempo total avaliado',
	'Weighted RSI': 'RSI Ponderado',
	'Weighted RPN': 'RPN Ponderado',
	'Tasks analyzed': 'Tarefas analisadas',
	'Cycle summary': 'Resumo do ciclo',
	'Risk Factors': 'Fatores de risco',
	'Highest RPN': 'Maior RPN',
	'Five highest RPNs': 'Cinco maiores RPNs',
	'Highest Risk Factors': 'Maiores fatores de risco',
	'B.E.R.A. Result': 'Resultado B.E.R.A.',
	'ENS Result': 'Resultado ENS',
	'RPN Score': 'RPN',
	Position: 'Posição',
	'Task RPN': 'RPN da Tarefa',
	'Greater than': 'Maior que',
	'Greater than or equal': 'Maior ou igual a',
	'Less than': 'Menor que',
	'Less than or equal': 'Menor ou igual a',
	Between: 'Entre',
	Maximum: 'Máximo',
	Minimum: 'Mínimo',
	'Search by file name...': 'Pesquisar pelo nome do arquivo...',
	'Select at least one file': 'Selecione um arquivo pelo menos',
	Seconds: 'Segundos',
	'Finish B.E.R.A.': 'Finalizar B.E.R.A.',
	'Consolidate report': 'Consolidar relatório',
	'Report updated successfully': 'Relatório atualizado com sucesso',
	'B.E.R.A. deleted successfully': 'B.E.R.A. removido com sucesso',
	'B.E.R.A. report deleted successfully': 'Relatório B.E.R.A. removido com sucesso',
	Uncertain: 'Incerto',
	'Some risk': 'Algum risco',
	Extreme: 'Extremo',

	// S.E.R.A. Report
	'Safety Ergonomic Risk Assessment (S.E.R.A.)': 'Avaliação de Riscos em Segurança e Ergonomia (S.E.R.A.)',
	'Ergonomic - Biomechanical': 'Ergonômicos - Biomecânicos',
	'Ergonomic - Furniture and equipment': 'Ergonômicos - Mobiliário e equipamentos',
	'Ergonomic - Organizational': 'Ergonômicos - Organizacionais',
	'Ergonomic - Environmental': 'Ergonômicos - Ambientais',
	'Ergonomic - Psychosocial and cognitive': 'Ergonômicos - Psicossociais e cognitivos',
	'Working in awkward or uncomfortable postures for long periods':
		'Trabalho em posturas incômodas ou pouco confortáveis por longos períodos',
	'Sitting posture for long periods': 'Postura sentada por longos períodos',
	'Standing posture for long periods': 'Postura de pé por longos períodos',
	'Frequent commuting on foot during the workday': 'Frequente deslocamento a pé durante a jornada de trabalho',
	'Work with intense physical exertion': 'Trabalho com esforço físico intenso',
	'Lifting and manual transport of loads or volumes': 'Levantamento e transporte manual de cargas ou volumes',
	'Frequent pulling/pushing of loads or packages': 'Frequente ação de puxar/empurrar cargas ou volumes',
	'Frequent execution of repetitive movements': 'Frequente execução de movimentos repetitivos',
	'Handling tools and/or heavy objects for long periods':
		'Manuseio de ferramentas e/ou objetos pesados por longos períodos',
	'Requiring frequent use of force, pressure, gripping, flexion, extension, or twisting of body segments':
		'Exigência de uso frequente de força, pressão, preensão, flexão, extensão ou torção dos segmentos corporais',
	'Compression of body parts by hard or cornered surfaces':
		'Compressão de partes do corpo por superfícies rígidas ou com quinas',
	'Requiring frequent spinal flexions': 'Exigência de flexões de coluna vertebral frequentes',
	'Frequent use of pedals': 'Uso intenso de pedais',
	'Frequent use of levers': 'Uso intenso de alavancas',
	'Demand for frequent lifting of upper limbs':
		'Exigência de elevação frequente de membros superiores acima do ombro',
	'Handling or moving loads and volumes without a handle or with a “poor handle”':
		'Manuseio ou movimentação de cargas e volumes sem pega ou com “pega pobre”',
	'Exposure to localized vibrations (hand-arm)': 'Exposição a vibrações localizadas (mão-braço)',
	'Frequent use of stairs': 'Uso frequente de escadas',
	'Intensive work with a keyboard or other input devices':
		'Trabalho intensivo com teclado ou outros dispositivos de entrada de dados',
	'Makeshift workstation': 'Posto de trabalho improvisado',
	'Furniture without regulation means of adjustment': 'Mobiliário sem meios de regulagem de ajuste',
	'Equipment and/or machines without regulation means or without conditions of use':
		'Equipamentos e/ou máquinas sem meios de regulagem de ajuste ou sem condições de uso',
	'Unplanned/Unadapted workstation for sitting position':
		'Posto de trabalho não planejado/adaptado para a posição sentada',
	'Inappropriate seat': 'Assento inadequado',
	'Improper or missing seat backrest': 'Encosto do assento inadequado ou ausente',
	'Furniture or equipment without space to move body segments':
		'Mobiliário ou equipamento sem espaço para movimentação de segmentos corporais',
	'Work with the need to reach objects, documents, controls or any point beyond the ideal reach zones for the anthropometric characteristics of the worker':
		'Trabalho com necessidade de alcançar objetos, documentos, controles ou qualquer ponto além das zonas de alcance ideais para as características antropométricas do trabalhador',
	"Equipment or furniture not adapted to the worker's anthropometry":
		'Equipamentos ou mobiliários não adaptados à antropometria do trabalhador',
	'Work performed without predefined rest breaks': 'Trabalho realizado sem pausas pré-definidas para descanso',
	'Need to maintain intense work rhythms': 'Necessidade de manter ritmos intensos de trabalho',
	'Work with need for shift variation': 'Trabalho com necessidade de variação de turnos',
	Monotony: 'Monotonia',
	'Night work': 'Trabalho noturno',
	'Insufficient training to perform the task': 'Insuficiência de capacitação para execução da tarefa',
	'Work with strict use of production targets': 'Trabalho com utilização rigorosa de metas de produção',
	'Work paid by production': 'Trabalho remunerado por produção',
	'Work cadence imposed by a piece of equipment': 'Cadência do trabalho imposta por um equipamento',
	'Imbalance between work time and rest time': 'Desequilíbrio entre tempo de trabalho e tempo de repouso',
	'Working conditions with sound pressure levels outside comfort parameters':
		'Condições de trabalho com níveis de pressão sonora fora dos parâmetros de conforto',
	'Working conditions with effective temperature index outside the comfort parameters':
		'Condições de trabalho com índice de temperatura efetiva fora dos parâmetros de conforto',
	'Working conditions with air speed outside comfort parameters':
		'Condições de trabalho com velocidade do ar fora dos parâmetros de conforto',
	'Working conditions with air humidity outside comfort parameters':
		'Condições de trabalho com umidade do ar fora dos parâmetros de conforto',
	'Working conditions with inadequate daytime lighting': 'Condições de trabalho com Iluminação diurna inadequada',
	'Working conditions with inadequate night lighting': 'Condições de trabalho com Iluminação noturna inadequada',
	'Presence of reflections on screens, panels, glass, monitors or any surface':
		'Presença de reflexos em telas, painéis, vidros, monitores ou qualquer superfície',
	'Slippery and/or uneven floor': 'Piso escorregadio e/ou irregular',
	'Excessive stressful situations': 'Excesso de situações de estresse',
	'Situations of mental work overload': 'Situações de sobrecarga de trabalho mental',
	'Requiring a high level of concentration, attention and memory':
		'Exigência de alto nível de concentração, atenção e memória',
	'Working in conditions of difficult communication': 'Trabalho em condições de difícil comunicação',
	'Excessive hierarchical conflicts at work': 'Excesso de conflitos hierárquicos no trabalho',
	'Excessive emotional/affective demands at work': 'Excesso de demandas emocionais/afetivas no trabalho',
	'Harassment of any nature at work': 'Assédio de qualquer natureza no trabalho',
	'Work with divergent demands (divergent orders, mutually incompatible goals, demand for quality X quantity, among others)':
		'Trabalho com demandas divergentes (ordens divergentes, metas incompatíveis entre si, exigência de qualidade X quantidade, entre outras)',
	'Requirement to perform multiple tasks, with high cognitive demand':
		'Exigência de realização de múltiplas tarefas, com alta demanda cognitiva',
	'Job dissatisfaction': 'Insatisfação no trabalho',
	'Lack of autonomy at work': 'Falta de autonomia no trabalho',
	'Accidents and physical discomforts': 'Acidentes e desconfortos físicos',
	'Low performance': 'Baixo desempenho',
	'Physical or mental exhaustion': 'Exaustão física ou mental',
	'Adoption of inappropriate postures and movements': 'Adoção de posturas e movimentos inadequados',
	'Alteration in the circadian cycle, sleep disorders': 'Alteração no ciclo circadiano, distúrbios do sono',
	'Low visibility': 'Baixa visibilidade',
	'Compression of structures (tissues, tendons, ligaments and nerves) causing musculoskeletal disorders':
		'Compressão de estruturas (tecidos, tendões, ligamentos e nervos) causando distúrbios osteomusculares',
	Discomfort: 'Desconforto',
	'Discomfort in lower limbs (legs and feet)': 'Desconforto em membros inferiores (pernas e pés)',
	'Discomfort in upper limbs (arms and hands)': 'Desconforto em membros superiores (braços e mãos)',
	'Discomfort in upper limbs and spine': 'Desconforto em membros superiores e coluna vertebral',
	'Discomfort in the spine': 'Desconforto na coluna vertebral',
	'Discomfort in the lower limbs and spine': 'Desconforto nos membros inferiores e na coluna vertebral',
	'Development of musculoskeletal disorders': 'Desenvolvimento de distúrbios osteomusculares',
	'Difficulty concentrating, irritability': 'Dificuldade de concentração, irritabilidade',
	'Balance disorders, headache': 'Distúrbios de equilíbrio, cefaleia',
	'Musculoskeletal disorders in the spine': 'Distúrbios osteomusculares na Coluna Vertebral',
	'Musculoskeletal disorders in the upper limbs (Repetitive Strain Injury)':
		'Distúrbios osteomusculares nos membros superiores (Lesão por Esforço Repetitivo)',
	'Musculoskeletal disorders': 'Distúrbios osteomusculares',
	'Mental exhaustion and psychiatric disorders': 'Exaustão mental e distúrbios psiquiátricos',
	'Fatigue in lower limbs': 'Fadiga em membros inferiores',
	'Muscle fatigue and development of musculoskeletal disorders':
		'Fadiga muscular e desenvolvimento de distúrbios osteomusculares',
	'Fatigue in the legs and development of vascular disorders':
		'Fadiga nas pernas e desenvolvimento de distúrbios vasculares',
	'Fatigue, risk of falls': 'Fadiga, risco de quedas',
	'Excessive caloric expenditure, development of musculoskeletal disorders':
		'Gasto calórico excessivo, desenvolvimento de distúrbios osteomusculares',
	'Irritation of structures (tendons, ligaments and nerves) causing musculoskeletal disorders':
		'Irritação de estruturas (tendões, ligamentos e nervos) causando distúrbios osteomusculares',
	'Low back pain': 'Lombalgias',
	'Visualization impairment': 'Prejuízo na visualização',
	'Reflections, glare': 'Reflexos, ofuscamentos',
	'Stumbles, falls': 'Tropeços, quedas',
	'Exposure to whole-body vibration below action level':
		'Exposição à vibração de corpo inteiro abaixo do nível de ação',
	'Exposure to whole-body vibration above the tolerance limit':
		'Exposição à vibração de corpo inteiro acima do limite de tolerância',
	'Exposure to localized vibrations (hand-arm) above the tolerance limit':
		'Exposição a vibrações localizadas (mão-braço) acima do limite de tolerância',
	'Exposure to whole-body vibration at action level': 'Exposição à vibração de corpo inteiro no nível de ação',
	'Exposure to localized vibrations (hand-arm) at action level':
		'Exposição a vibrações localizadas (mão-braço) no nível de ação',
	'Exposure to localized vibrations (hand-arm) below action level':
		'Exposição a vibrações localizadas (mão-braço) abaixo do nível de ação',
	'Musculoskeletal disorders in the upper limbs': 'Distúrbios osteomusculares nos membros superiores',
	'Physical discomforts': 'Desconfortos físicos',
	'Accidents, physical or mental exhaustion': 'Acidentes, exaustão física ou mental',
	'Accidents, low performance': 'Acidentes, baixo desempenho',
	'Mental exhaustion': 'Exaustão mental',
	'Discomfort in upper/lower limbs and spine': 'Desconforto nos membros inferiores/superiores e na coluna vertebral',
	'Mental/physical exhaustion and psychiatric disorders': 'Exaustão física/mental e distúrbios psiquiátricos',
	'Adoption of unnecessary and inappropriate postures and movements.':
		'Adoção de posturas e movimentos desnecessários e inadequados',
	'1% to 10% of the cycle': '1% a 10% do ciclo',
	'11% to 20% of the cycle': '11% a 20% do ciclo',
	'21% to 30% of the cycle': '21% a 30% do ciclo',
	'31% to 50% of the cycle': '31% a 50% do ciclo',
	'51% to 75% of the cycle': '51% a 75% do ciclo',
	'76% to 100% of the cycle': '76% a 100% do ciclo',
	'[1] 1% to 10% of the cycle': '[1] 1% a 10% do ciclo',
	'[2] 11% to 20% of the cycle': '[2] 11% a 20% do ciclo',
	'[3] 21% to 30% of the cycle': '[3] 21% a 30% do ciclo',
	'[4] 31% to 50% of the cycle': '[4] 31% a 50% do ciclo',
	'[5] 51% to 75% of the cycle': '[5] 51% a 75% do ciclo',
	'[6] 76% to 100% of the cycle': '[6] 76% a 100% do ciclo',
	'Muscle fatigue/Discomfort': 'Fadiga muscular/desconforto',
	'First aid': 'Primeiro socorro',
	'Recordable injury': 'Histórico de lesão',
	'Recordable with surgery or restrictions': 'Histórico com cirurgia ou restrições',
	'Lost time - Missed work due to injury and/or hospitalization':
		'Tempo perdido - Falta ao trabalho devido a lesão e/ou hospitalização',
	Fatality: 'Fatalidade',
	'[1] Muscle fatigue/Discomfort': '[1] Fadiga muscular/desconforto',
	'[2] First aid': '[2] Primeiro socorro',
	'[3] Recordable injury': '[3] Histórico de lesão',
	'[4] Recordable with surgery or restrictions': '[4] Histórico com cirurgia ou restrições',
	'[5] Lost time - Missed work due to injury and/or hospitalization':
		'[5] Tempo perdido - Falta ao trabalho devido a lesão e/ou hospitalização',
	'[6] Fatality': '[6] Fatalidade',
	'Unlikely (never happened and there is no possibility)': 'Improvável (nunca ocorreu e não existe possibilidade)',
	'Remote (there is a possibility of this occurring once during the useful life of the equipment)':
		'Remota (existe a possibilidade de ocorrer 1 vez durante a vida útil do equipamento)',
	'Occasional (there is a possibility of this occurring more than once during the useful life of the equipment)':
		'Ocasional (existe a possibilidade de ocorrer mais de 1 vez durante a vida útil do equipamento)',
	'Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year)':
		'Provável (já há registro e existe a possibilidade de ocorrer 1 a 12 vezes no ano)',
	'Frequent (there is already a registration and there is the possibility of occurring more than once a month)':
		'Frequente (já há registro e existe a possibilidade de ocorrer mais de 1 vez ao mês)',
	'Certainly (there is already a record and there is the possibility of occurring daily)':
		'Certamente (já há registro e existe a possibilidade de ocorrer diariamente)',
	'[1] Unlikely (never happened and there is no possibility)':
		'[1] Improvável (nunca ocorreu e não existe possibilidade)',
	'[2] Remote (there is a possibility of this occurring once during the useful life of the equipment)':
		'[2] Remota (existe a possibilidade de ocorrer 1 vez durante a vida útil do equipamento)',
	'[3] Occasional (there is a possibility of this occurring more than once during the useful life of the equipment)':
		'[3] Ocasional (existe a possibilidade de ocorrer mais de 1 vez durante a vida útil do equipamento)',
	'[4] Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year)':
		'[4] Provável (já há registro e existe a possibilidade de ocorrer 1 a 12 vezes no ano)',
	'[5] Frequent (there is already a registration and there is the possibility of occurring more than once a month)':
		'[5] Frequente (já há registro e existe a possibilidade de ocorrer mais de 1 vez ao mês)',
	'[6] Certainly (there is already a record and there is the possibility of occurring daily)':
		'[6] Certamente (já há registro e existe a possibilidade de ocorrer diariamente)',
	'[1] Unlikely': '[1] Improvável',
	'[2] Remote': '[2] Remota',
	'[3] Occasional': '[3] Ocasional',
	'[4] Likely': '[4] Provável',
	'[5] Frequent': '[5] Frequente',
	'[6] Certainly': '[6] Certamente',
	'Reports status': 'Status dos relatórios',
	Uncompleted: 'Incompleto',
	'Show only uncompleted reports': 'Mostrar apenas análises incompletas',
	'Show only completed reports': 'Mostrar apenas análises finalizadas',
	'Show only reviewed reports': 'Mostrar apenas análises revisadas',
	'Created date': 'Data de criação',
	'Reviewed date': 'Data de revisão',
	'Review each task below': 'Faça a análise de cada tarefa abaixo',
	'Add report': 'Adiciona relatório',
	Specifications: 'Especificações',
	Specification: 'Especificação',
	'Existing prevention measures': 'Medidas existentes para prevenção',
	Category: 'Categoria',
	'Select the category': 'Selecione a categoria',
	'Risk description': 'Descrição do perigo',
	'Total risk descriptions': 'Total de descrições de risco',
	'Select the description': 'Selecione o perigo',
	Damage: 'Dano',
	'Select the damage': 'Selecione o dano',
	'Select the evaluator': 'Selecione o avaliador',
	'Select the exposure': 'Selecione a exposição',
	'Select the vulnerability': 'Selecione a probabilidade',
	'Select the severity': 'Selecione a severidade',
	'Select a severity': 'Selecione a severidade',
	'How many times is the operator exposed to risk in the work cycle?':
		'Quantas vezes o operador está exposto ao risco no ciclo de trabalho?',
	'What is the probability of an incident happening?': 'Qual é a probabilidade de um incidente acontecer?',
	'How severe could the injury be?': 'Quão grave pode ser a lesão?',
	Edit: 'Editar',
	'Create review': 'Fazer revisão',
	'Cycle results': 'Resultados do ciclo',
	Version: 'Versão',
	Review: 'Revisão',
	'Result S.E.R.A.': 'Resultado S.E.R.A.',
	'Original version date': 'Data da versão original',
	'Last review': 'Última revisão',
	'Analyzed reports': 'Atividades avaliadas',
	'Reviewed reports': 'Atividades revisadas',
	'Sum of RPN': 'Soma de RPNs',
	'Original version sum of RPN': 'Soma de RPNs da versão original',
	'Average RPN': 'RPN médio',
	'Analyzed tasks': 'Atividades avaliadas',
	'Reviewed at': 'Avaliado em',
	'Review date': 'Data de revisão',
	'Task review': 'Revisão da tarefa',
	'Select tasks below to review': 'Selecione as tarefas abaixo para revisão',
	'RPN and Priority': 'RPN e prioridade',
	Priority: 'Prioridade',
	'Create S.E.R.A. report': 'Criar relatório S.E.R.A.',
	'Go back to files selection': 'Voltar para a seleção de arquivos',
	'Action plans list': 'Lista de planos de ação',
	'S.E.R.A. action plans': 'Plano de ação S.E.R.A.',
	'Add action plan': 'Criar plano de ação',
	'General history': 'Histórico geral',
	'Tasks summary': 'Resumo das atividades',
	'Reviews history': 'Histórico de revisões',
	'Changed field': 'Campo alterado',
	'Original value': 'Valor original',
	'Reviewed value': 'Valor revisado',
	Reviewer: 'Revisor',
	Reviewed: 'Revisado',
	Hide: 'Esconder',
	Show: 'Mostrar',
	'Unlikely (never happened and there is no possibility) [1]':
		'Improvável (nunca ocorreu e não existe possibilidade) [1]',
	'Remote (there is a possibility of this occurring once during the useful life of the equipment) [2]':
		'Remota (existe a possibilidade de ocorrer 1 vez durante a vida útil do equipamento) [2]',
	'Occasional (there is a possibility of this occurring more than once during the useful life of the equipment) [3]':
		'Ocasional (existe a possibilidade de ocorrer mais de 1 vez durante a vida útil do equipamento) [3]',
	'Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year) [4]':
		'Provável (já há registro e existe a possibilidade de ocorrer 1 a 12 vezes no ano) [4]',
	'Frequent (there is already a registration and there is the possibility of occurring more than once a month) [5]':
		'Frequente (já há registro e existe a possibilidade de ocorrer mais de 1 vez ao mês) [5]',
	'Certainly (there is already a record and there is the possibility of occurring daily) [6]':
		'Certamente (já há registro e existe a possibilidade de ocorrer diariamente) [6]',
	Choose: 'Escolher',
	'Next file': 'Próximo arquivo',
	'No fields were changed': 'Nenhum campo alterado',
	'S.E.R.A. deleted successfully': 'S.E.R.A. removido com sucesso',

	// Liberty Mutual
	'Go back to report list': 'Voltar para a lista de relatórios',
	'Material Handling': 'Manuseio de Material',
	'Material handling': 'Manuseio de material',
	'Invalid request data': 'Dados inválidos para requisição',
	'Liberty Mutual report created successfully!': 'Relatório Liberty Mutual criado com sucesso',
	'Liberty Mutual report updated successfully!': 'Relatório Liberty Mutual atualizado com sucesso',
	'Liberty Mutual task not found': 'Atividade do Liberty Mutual não encontrada',
	'Return to task list': 'Retornar a lista de atividades',
	'End hand height lower than start hand height. Should it be Lower task?':
		"Altura final da mão menor que altura inicial. Deveria ser a tarefa 'Abaixar'?",
	'End hand height higher than start hand height. Should it be Lift task?':
		"Altura final da mão maior que altura inicial. Deveria ser a tarefa 'Levantar'?",
	'System of units not found': 'Sistema de unidades não encontrado',
	'Cannot be lower than start height': 'Não pode ser menor que altura inicial',
	'Cannot be higher than start height': 'Não pode ser maior que altura inicial',
	Movements: 'Movimentos',
	'Individually evaluate the movements present in the task':
		'Avalie individualmente os movimentos presentes na tarefa',
	'Liberty mutual report created successfully!': 'Relatório Liberty mutual criado com sucesso',
	'Liberty mutual report updated successfully!': 'Relatório Liberty mutual atualizado com sucesso',
	'Liberty mutual task not found': 'Atividade do Liberty mutual não encontrada',
	Lift: 'Levantar',
	Lifts: 'Levantamentos',
	lift: 'levantamento',
	lifts: 'levantamentos',
	Lower: 'Abaixar',
	Lowers: 'Abaixamentos',
	lowers: 'abaixamentos',
	lower: 'abaixamento',
	Push: 'Empurrar',
	Pushes: 'Empurrações',
	pushes: 'empurrações',
	push: 'empurração',
	Pull: 'Puxar',
	Pulls: 'Puxadas',
	pulls: 'puxadas',
	pull: 'puxada',
	Carry: 'Carregar',
	Carries: 'Carregamentos',
	carries: 'carregamentos',
	carry: 'carregamento',
	'System of unit': 'Sistema de unidades',
	'Select the system of unit': 'Selecione um sistema de unidades',
	'Select a system of unit': 'Selecione um sistema de unidades',
	'Select the movement of the task being evaluated': 'Selecione o movimento da tarefa sendo avaliada',
	'Insert the fields data for the selected task': 'Insira os dados dos campos para a atividade selecionada',
	'Start hand height': 'Altura inicial da mão',
	'End hand height': 'Altura final da mão',
	'Start hand distance': 'Distância inicial da mão',
	'End hand distance': 'Distância final da mão',
	'Initial force': 'Força inicial',
	'Sustained force': 'Força contínua',
	'Horizontal distance': 'Distância horizontal',
	'Vertical hand height': 'Altura vertical da mão',
	'Hand coupling': 'Pega',
	'Object weight': 'Peso do objeto',
	Weight: 'Peso',
	'Select an hand coupling': 'Selecione uma qualidade de pega',
	'Insert a start height': 'Insira uma altura inicial',
	'Insert an end height': 'Insira uma altura final',
	'Insert a start distance': 'Insira uma distância inicial',
	'Insert an end distance': 'Insira uma distância final',
	'Insert an object weight': 'Insira o peso do objeto',
	'Insert a frequency value': 'Insira a frequência',
	'Select a frequency interval': 'Insira o intervalo da frequência',
	'Insert an initial force': 'Insira uma força inicial',
	'Insert a sustained force': 'Insira uma força contínua',
	Initial: 'Inicial',
	Sustain: 'Contínua',
	'Insert an horizontal distance': 'Insira uma distância horizontal',
	'Insert a vertical hand height': 'Insira uma altura vertical da mão',
	'Select a task': 'Selecione uma atividade',
	'per hour': 'por hora',
	hour: 'hora',
	'per minute': 'por minuto',
	per: 'por',
	'Video duration': 'Duração',
	'Assessment date': 'Data de avaliação',
	'Activity is safe for': 'Atividade é segura para',
	'Initial state': 'Estado inicial',
	'End state': 'Estado final',
	Displacement: 'Deslocamento',
	Metric: 'Métrico',
	Imperial: 'Imperial',
	'Data entered for Start hand height and End hand height indicates that the task type is Lift, not Lower':
		'Valores inseridos para alturas inicial e final da mão indicam que a atividade é do tipo Levantar e não Abaixar',
	'Data entered for Start hand height and End hand height indicates that the task type is Lower, not Lift':
		'Valores inseridos para alturas inicial e final da mão indicam que a atividade é do tipo Abaixar e não Levantar',

	// API error messages
	'Internal Server Error': 'Erro interno do servidor',
	'You are unauthorized to access the requested resource': 'Você não está autorizado a acessar o recurso solicitado',
	'Check the header parameters entered': 'Verifique os parâmetros de cabeçalho inseridos',
	'Range risk not found': 'Faixa de risco não encontrada',
	'Failed to fetch risk tracks': 'Falha ao buscar faixas de risco',
	'Task not found': 'Tarefa não encontrada',
	'Task already exists': 'A tarefa já existe',
	'Cycle not found': 'Ciclo não encontrado',
	'Cycle already exists': 'O ciclo já existe',
	'Stress level not found': 'Nível de estresse não encontrado',
	'Frequency not found': 'Frequência não encontrada',
	'Total task duration not found': 'Duração total da tarefa não encontrada',
	'Evaluator not found': 'Avaliador não encontrado',
	'Exposure not found': 'Exposição não encontrada',
	'Vulnerability not found': 'Vulnerabilidade não encontrada',
	'Severity not found': 'Severidade não encontrada',
	'Severity already set to this risk damage': 'A severidade já foi definida para esse dano',
	'Custom report step key not found': 'Chave da etapa do relatório personalizado não encontrada',
	'Custom report step not found': 'Etapa do relatório personalizado não encontrada',
	'Custom report not found': 'Relatório personalizado não encontrado',
	'Bera step key result not found': 'Resultado da chave da etapa de Bera não encontrado',
	'Bera step key result already exists': 'O resultado da chave de etapa do Bera já existe',
	'Bera weighted average not found': 'Média ponderada do Bera não encontrada',
	'Bera weighted average already exists': 'A média ponderada do Bera já existe',
	'Bera report not found': 'Relatório Bera não encontrado',
	'Bera report already exists': 'O relatório Bera já existe',
	'Bera job summary not found': 'Bera job summary não encontrado',
	'Bera job summary result not found': 'Resultado do resumo do trabalho de Bera não encontrado',
	'Bera job summary already exists': 'Bera job summary already exists',
	'Sera report not found': 'Relatório Sera não encontrado',
	'Sera report already exists': 'O relatório do Sera já existe',
	'Sera summary not found': 'Sera summary não encontrado',
	'Sera summary already exists': 'O resumo do Sera já existe',
	'Sera summary review not found': 'Sera summary review não encontrado',
	'Sera summary review already exists': 'Sera summary review already exists',
	'Sector not found': 'Setor não encontrado',
	'Report data not found': 'Dados do relatório não encontrados',
	'File not found': 'Arquivo não encontrado',
	'Failed to read file': 'Falha ao ler o arquivo',
	'Failed to save file': 'Falha ao salvar o arquivo',
	'Master user not found': 'Usuário mestre não encontrado',
	'Potential customer not found': 'Cliente em potencial não encontrado',
	'Voucher not found': 'Voucher não encontrado',
	'Invalid voucher': 'Voucher inválido',
	'Invalid recurrence': 'Recorrência inválida',
	'Plan not found': 'Plano não encontrado',
	'Plan already canceled': 'Plano já cancelado',
	'Invalid subscription type': 'Tipo de assinatura inválido',
	'It is not possible to downgrade the annual plan': 'Não é possível fazer downgrade do plano anual',
	'Failed to decode payload': 'Falha ao decodificar a carga útil',
	'Plan expiration date not found': 'Data de expiração do plano não encontrada',
	'Document already registered': 'Documento já registrado',
	'Failed to create user plan': 'Falha ao criar plano de usuário',
	'Maximum registered users': 'Máximo de usuários registrados',
	'Failed to create user': 'Falha ao criar usuário',
	'User already registered': 'Usuário já registrado',
	'Organization not found': 'Empresa não encontrada',
	'Company not found': 'Planta industrial não encontrada',
	'Failed to create company': 'Falha ao criar a empresa',
	'Failed to create a user permission': 'Falha ao criar uma permissão de usuário',
	'Failed to send email': 'Falha ao enviar e-mail',
	'Failed to create storage bucket': 'Falha ao criar um bucket de armazenamento',
	'Failed to upload file to storage': 'Falha ao fazer upload de arquivo para o armazenamento',
	'Failed to download data': 'Falha ao fazer download de dados',
	'Failed to download file': 'Falha ao fazer dowload do arquivo',
	'Failed to delete file': 'Falha ao excluir arquivo',
	'Fail get information storage': 'Falha ao obter informações de armazenamento',
	'Failed to store data': 'Falha ao armazenar dados',
	'File sent for download': 'Arquivo enviado para download',
	'Reply queue communication failure': 'Falha na comunicação da fila de resposta',
	'Selected report not found': 'Relatório selecionado não encontrado',
	'Unauthorized requisition': 'Requisição não autorizada',
	'Authorization header is missing': 'O cabeçalho de autorização está faltando',
	'Failed to query the database': 'Falha ao consultar o banco de dados',
	'Calculation per second not found': 'Cálculo por segundo não encontrado',
	'Business information not found': 'Informações comerciais não encontradas',
	'Worker self evaluation not found': 'Autoavaliação do trabalhador não encontrada',
	'Action plan not found': 'Plano de ação não encontrado',
	'Failed to create an history': 'Falha ao criar um histórico',
	'Already created action plan': 'Plano de ação já criado',
	'Action plan task not found': 'Tarefa do plano de ação não encontrada',
	'Action plan history not found': 'Histórico do plano de ação não encontrado',
	'Preliminary analysis not found': 'Avaliação preliminar não encontrada',
	'Default step not found': 'Etapa padrão não encontrada',
	'Analysis step not found': 'Etapa de análise não encontrada',
	'Probabilty analysis not found': 'Análise de probabilidade não encontrada',
	'Consequence analysis not found': 'Análise de consequências não encontrada',
	'Exhibition analysis not found': 'Análise de exposição não encontrada',
	'Organization still has registered companies': 'A organização ainda tem empresas registradas',
	'Failed to create an organization': 'Falha ao criar uma empresa',
	'Workstation not found': 'Posto de trabalho não encontrado',
	'Custom report result not found': 'Resultado de relatório personalizado não encontrado',
	'Already created custom report result': 'Resultado de relatório personalizado já criado',
	'Custom report step key result not found': 'Resultado da chave da etapa do relatório personalizado não encontrado',
	'Already created custom report step key result': 'Resultado da chave da etapa do relatório personalizado já criado',
	'Failed to create custom report step key result':
		'Falha ao criar o resultado da chave da etapa do relatório personalizado',
	'Failed to update custom report step key result':
		'Falha ao atualizar o resultado da chave da etapa do relatório personalizado',
	'Custom report step key additional item result not found':
		'Resultado do item adicional da chave da etapa do relatório personalizado não encontrado',
	'Failed to create custom report step key additional item result':
		'Falha ao criar o resultado do item adicional da chave da etapa do relatório personalizado',
	'Failed to update custom report step key additional item result':
		'Falha ao atualizar o resultado do item adicional da chave da etapa do relatório personalizado',
	'Work condition result not found': 'Resultado da condição de trabalho não encontrado',
	'Already created work condition result': 'Resultado da condição de trabalho já criado',
	'Characteristic result not found': 'Resultado da característica não encontrado',
	'Already created characteristic result': 'Resultado da característica já criado',
	'Custom report sub step key not found': 'Chave da subetapa do relatório personalizado não encontrada',
	'Corrupted video': 'Vídeo corrompido',
	'Failed to read sent file': 'Falha ao ler o arquivo enviado',
	'Failed to create download url': 'Falha ao criar url de download',
	'File already queued': 'Arquivo já está em fila',
	'File already processed': 'Arquivo já processado',
	'Already registered user': 'Usuário já registrado',
	'Failed to create customer plan': 'Falha ao criar o plano do cliente',
	'Failed to create customer transaction': 'Falha ao criar a transação do cliente',
	'Customer transaction not found': 'Transação do cliente não encontrada',
	'Customer transaction already completed': 'Transação do cliente já concluída',
	'Product not found': 'Produto não encontrado',
	'Failed to create customer credits': 'Falha ao criar créditos de cliente',
	'Processed minutes limit reached': 'Limite de minutos processados atingido',
	'Invalid event': 'Evento inválido',
	'Not authorized': 'Não autorizado',
	'Customer not found': 'Cliente não encontrado',
	'Unregistered customer': 'Cliente não registrado',
	'Already registered customer': 'Cliente já registrado',
	'Failed to create customer': 'Falha ao criar o cliente',
	'Failed to update customer': 'Falha ao atualizar o cliente',
	'Report not found': 'Relatório não encontrado',
	'Already created report': 'Relatório já criado',
	'Failed to create report': 'Falha ao criar o relatório',
	'Failed to create report pdf': 'Falha ao criar relatório em pdf',
	'Failed to update report': 'Falha ao atualizar o relatório',
	'Custom report additional item option not found':
		'Opção de item adicional dO relatório personalizado não encontrada',
	'Error calculating custom report additional item result':
		'Erro ao calcular o resultado do item adicional do relatório personalizado',
	'Line not found': 'Linha não encontrada',
	'Failed to create file signature': 'Falha ao criar assinatura de arquivo',

	// Force Two-Factor
	'For security reasons, we need you to enable your two-factor validation':
		'Por razões de segurança, precisamos que ative sua validação em dois fatores',
	'Your company is requesting that all users have two-factor authentication enabled. Proceed to activate yours and login.':
		'Sua companhia está solicitando que todos os usuários tenham a autenticação em dois fatores habilitada. Continue para ativar a sua e fazer login.',
	Return: 'Voltar',

	// Integrations
	'Continue with Microsoft SSO': 'Continue com Microsoft SSO',
	Integrations: 'Integrações',
	'Built-in user groups': 'Grupos de usuários integrados',
	'Connect your Microsoft Azure AD users': 'Conecte seus usuários do Microsoft Azure AD',
	'Invitation sent': 'Convite enviado',
	'Microsoft Azure Active Directory - Users': 'Microsoft Azure Active Directory - Usuários',
	'Failed to load user groups': 'Falha ao carregar grupos de usuários',
	'User removed successfully!': 'Usuário removido com sucesso!',
	'Failed to remove user': 'Falha ao remover usuário',
	'Do you want to remove the user': 'Você deseja remover o usuário',
	'Failed to update user': 'Falha ao atualizar usuário',
	'Failed to load information': 'Falha ao carregar as informações',
	'Investigate and implement change': 'Investigar e implementar mudanças',
	'Implement changes': 'Implementar mudanças',
	Carriage: 'Carrinho de transporte',
	Barrow: 'Carrinho de mão',
	Conveyor: 'Transportador',
	Crane: 'Guindaste',

	//EWA-JDS-D86
	'Ergonomic workplace analysis': 'Avaliação Ergonômica Preliminar',
	'Select the right model for your analysis': 'Selecione o modelo adequado para sua avaliação',
	'Brazilian standard': 'Norma brasileira',
	'Brazilian standard and John Deere guidelines': 'Norma brasileira e diretrizes John Deere',
	'International standard': 'Norma Brasileira',
	'International standard and John Deere guidelines': 'Norma Brasileira e diretrizes John Deere',
	'ISO 20646': 'NR-17',
	'ISO 20646 + JDS-D86': 'NR-17 + JDS-D86',
	Unit: 'Unidade',
	'Evaluator name': 'Avaliador',
	Interviewer: 'Entrevistador',
	'Interviewee name': 'Entrevistado',
	'Select the restrictions perceived in the evaluated working condition':
		'Selecione as restrições percebidas na condição de trabalho avaliada',
	'Summary description of the site': 'Descrição sumária do local',
	'Simplified description of the planned task': 'Descrição simplificada da tarefa prevista',
	'Particularities / Production / Working regime': 'Particularidades / Produção / Regime de trabalho',
	'Select the Work schedule hours': 'Selecione o horário de trabalho',
	'Select the Sector': 'Selecione o setor',
	'Select the Unit': 'Selecione a unidade',
	'Select the Line': 'Selecione a linha',
	'Select the Collection date': 'Selecione a data de coleta',
	'Select the Evaluator name': 'Selecione o nome do avaliador',
	'Workday and concentration': 'Jornada e concentração',
	'Risk Index:': 'Índice de Risco:',
	'Check the tool for conducting risk assessments': 'Consulte a ferramenta para avaliação do risco',
	'Wrench length': 'Comprimento da chave',
	'Sum of RPNs': 'Soma dos RPNs',
	'Higher RPNs': 'Maiores RPNs',
	'Found at:': 'Encontrado em:',
	'Interviewer name': 'Entrevistador',
	'The movement is considered safe for': 'O movimento é considerado seguro para ',
	'of man': 'dos homens',
	'of woman': 'das mulheres',
	Movement: 'Movimento',
	'Movement by score (Kinebot/JDS)': 'Movimento por Score (Kinebot/JDS)',
	'Tool type': 'Tipo de ferramenta',
	'Movement type': 'Tipo de movimento',
	Dimension: 'Dimensão',
	'Range zone': 'Zona de alcance',
	'Command range': 'Alcance dos comandos',
	'Target condition': 'Condição-alvo',
	'Conditionally acceptable': 'Aceitável condicionalmente',
	'Actions must be implemented': 'Ações devem ser implementadas',
	'Impact frequency': 'Frequência do impacto',
	'Evaluation necessary': 'Avaliação necessária',
	'Evaluation not necessary': 'Avaliação não necessária',
	'Select the items you want to present in your document':
		'Selecione os itens que deseja apresentar em seu documento',
	'Criteria not evaluated': 'Critérios não avaliados',
	'Generate document': 'Gerar documento',
	'Analysis not consolidated!': 'Avaliação não consolidada!',
	'If you continue, the filled-in data will be saved but not taken into account in your dashboard':
		'Caso prossiga, os dados preenchidos serão salvos, mas não considerados em sua dashboard',
	Proceed: 'Prosseguir',
	'Material Handling (Liberty Mutual)': 'Manuseio de material (Liberty Mutual)',
	Tools: 'Ferramentas',
	Workday: 'Jornada e concentração',
	'Influence of workspace': 'Influência do espaço',
	'Influence of environment': 'Fatores do meio ambiente',
	"The risk assessment recommendation is based on the indicators in the JDS-92 guidelines. The color pattern follows the same pattern present in the document's tables.":
		'A recomendação de avaliação de risco é baseada nos indicadores presentes nas diretrizes da JDS-92. O padrão de cores segue o mesmo padrão presente em tabelas do documento.',
	"The risk assessment recommendation is based on the indicators in the JDS-86 guidelines. The color pattern follows the same pattern present in the document's tables.":
		'A recomendação de avaliação de risco é baseada nos indicadores presentes nas diretrizes da JDS-86. O padrão de cores segue o mesmo padrão presente em tabelas do documento.',
	'Not evaluated': 'Não avaliado',
	'Use of one-handed manual wrench': 'Uso de chave manual com uma mão',
	'Use of one-handed manual wrench with backup wrench': 'Uso de chave manual com uma mão com uso de chave auxiliar',
	'Use of two-handed manual wrench': 'Uso de chave manual com duas mãos',
	'Using power tools': 'Uso de ferramentas elétricas',
	'Performs work that requires frequent finger, hand or arm movements':
		'Realiza trabalho que requer movimentos frequentes de dedo, mão e braço',
	'Using an impact device': 'Uso de dispositivo de impacto',
	'Viewing area': 'Área de visualização',
	'Postural demands (JDS-D86)': 'Exigências posturais (JDS-D86)',
	'Workstation involves seated work (fixed height)': 'A estação de trabalho envolve trabalhar sentado (altura fixa)',
	'Workstation involves seated work (adjustable station)':
		'A estação de trabalho envolve trabalhar sentado (estação ajustável)',
	'Distances from controls or work surface are inadequate':
		'As distâncias dos comandos ou superfície de trabalho são inadequadas',
	'Workspace dimensions are too narrow': 'As dimensões dos espaços de trabalho são muito estreitas',
	'The dimensions and clearances of the controls or work surface with the hands are inadequate':
		'As dimensões e folgas dos comandos ou superfície de trabalho com as mãos são inadequadas',
	'Grip and hand strength': 'Força de aperto com as mãos',
	'Standing arm strength forces': 'Força de mão e braços',
	'Whole body vibration exposure': 'Exposição a vibração em todo o corpo',
	'Hand-arm vibration exposure for 8 hours': 'Exposição por 8 horas a vibração na mão e braço',
	'Hand-arm vibration exposure': 'Exposição à vibração na mão e braço',
	'Contact with very hot or very cold surfaces': 'Contato com superfície muito quente ou muito fria',
	'Exposure to hot or cold surfaces': 'Exposição a superficie quente ou fria',
	'Hammer Use (<.25 kg, <.5 lb)': 'Uso de martelo (<0,25 kg, <0.5 lb)',
	'Use of hammer/mallet (<1 kg, <2.2 lb)': 'Uso de martelo/macete (<1 kg, <2,2 lb)',
	'Use of hammer/mallet (>1 kg, >2.2 lb)': 'Uso de martelo/marreta (>1 kg, >2,2 lb)',
	'Using hand for striking part': 'Uso da mão para bater na peça',
	'Visual tasks >=10º above the horizontal line of the eye': 'Tarefas visuais ≥10º acima da linha horizontal do olho',
	'Visual tasks 0º to 10º above the horizontal line of the eye':
		'Tarefas visuais 0º a 10º acima da linha horizontal do olho',
	'Visual tasks 0º to 45º below the horizontal line of the eye':
		'Tarefas visuais 0º a 45º abaixo da linha horizontal do olho',
	'Visual tasks 45º to 60º below the horizontal line of the eye':
		'Tarefas visuais 45º a 60º abaixo da linha horizontal do olho',
	'Visual tasks >=60º below the horizontal line of the eye':
		'Tarefas visuais ≥60º abaixo da linha horizontal do olho',
	'Workstation height': 'Altura da estação de trabalho',
	'Precision task height': 'Altura da tarefa de precisão',
	'Writing and light assembly task height': 'Altura para escrever e tarefa de montagem leve',
	'Vertical height to the bottom of the work surface':
		'Altura vertical até a parte inferior da superfície de trabalho',
	'Horizontal knee (depth) clearance': 'Folga horizontal para joelhos (profundidade)',
	'Horizontal knee width clearance': 'Folga horizontal para largura do joelho',
	Horizontally: 'Horizontalmente',
	'Vertically for standing workstations': 'Verticalmente em pé',
	'Vertically for seated workstations': 'Verticalmente sentado',
	'Whole Body': 'Corpo inteiro',
	'Head (least favorable position)': 'Cabeça (posição menos favorável)',
	Leg: 'Perna',
	Foot: 'Pé',
	Arm: 'Braço',
	'Hand, Wrist, Fist': 'Mão, pulso, punho',
	Finger: 'Dedo',
	'One finger': 'Um dedo',
	'Two fingers': 'Dois dedos',
	'Empty hand, flat': 'Mão vazia e plana',
	'Empty hand, thumb tucked': 'Mão vazia, polegar dobrado',
	'Clenched hand, fist': 'Mão fechada, punho',
	'Hand plus 25 mm (1 in) object': 'Mão mais objeto de 25 mm (1 in)',
	'Hand plus X mm (in) object to wrist': 'Mão mais objeto de X mm (in) até o pulso',
	'Arm to elbow': 'Braço até o cotovelo',
	'Arm to Shoulder': 'Braço até o ombro',
	'Both Arms to Shoulder': 'Ambos os braços até o ombro',
	'Power grip force': 'Segurar com força',
	'Power grip press': 'Pressionar com força',
	'Pinch grip': 'Aperto como pinça',
	'Lateral pinch (key grip)': 'Pinça lateral (encaixe principal)',
	'Tip pinch grip': 'Aperto como pinça na ponta',
	'Hook grip': 'Aperto em gancho',
	'Push with index finger': 'Empurrar com dedo indicador',
	'Push with thumb': 'Empurrar com o dedão',
	'Wrist flexion or extension torque': 'Flexão do pulso ou torque de extensão',
	'Ulnar/Radial deviation': 'Desvio ulnar/radial',
	Screwdriving: 'Aparafusamento',
	'Push-Pull 1 hand (knee to shoulder)': 'Empurrar-puxar com 1 mão (joelho ao ombro)',
	'Push-Pull 1 hand (below knee or above shoulder)': 'Empurrar-puxar com 1 mão (abaixo do joelho ou acima do ombro)',
	'Up-Down 1 hand (knee to shoulder)': 'Para cima-para baixo com 1 mão (joelho ao ombro)',
	'Up-Down 1 hand (below knee or above shoulder)':
		'Para cima-para baixo com 1 mão (abaixo do joelho ou acima do ombro)',
	'Push-Pull 2 hands (knee to shoulder)': 'Empurrar-puxar com 2 mãos (joelho ao ombro)',
	'Push-Pull 2 hands (below knee or above shoulder)':
		'Empurrar-puxar com 2 mãos (abaixo do joelho ou acima do ombro)',
	'Up-Down 2 hands (knee to shoulder)': 'Para cima-para baixo com 2 mãos (joelho ao ombro)',
	'Up-Down 2 hands (below knee or above shoulder)':
		'Para cima-para baixo com 2 mãos (abaixo do joelho ou acima do ombro)',
	'Lateral force 2 hands (between knee and shoulder)': 'Força lateral com as 2 mãos (entre o joelho e o ombro)',
	'Lateral force 2 hands (above shoulder or below knee)':
		'Força lateral com as 2 mãos (acima do ombro ou abaixo do joelho)',
	'Lateral force 1 hand (between knee and shoulder)': 'Força lateral com 1 mão (entre o joelho e o ombro)',
	'Lateral force 1 hand (above shoulder or below knee)':
		'Força lateral com 1 mão (acima do ombro ou abaixo do joelho)',
	'Foot and leg force': 'Força de pés e pernas',
	'Ladders and clamps': 'Escadas e abraçadeiras',
	'Ladder usage': 'Uso de escadas',
	'Clamps usage': 'Uso de abraçadeiras',
	'Ladder is validated against national standards (e.g., ISO, ANSI, ABNT)?':
		'Escada está validada de acordo com normas nacionais (ex.: ISO, ANSI, ABNT)?',
	'Is there non-occasional load handling (>9kg)?': 'Há manuseio de carga (>9kg) de forma não ocasional?',
	'Used for regular production activities (excluding short-duration tasks)?':
		'Utiliza escada para atividades regulares de produção (exceto tarefas de curta duração)?',
	'< 35N (< 8 lb)': '< 35N (< 8 lb)',
	'> 35N (> 8 lb)': '> 35N (> 8 lb)',
	'> 50N (> 11 lb)': '> 50N (> 11 lb)',
	'> 130N (> 30 lb)': '> 130N (> 30 lb)',
	'Foot-operated switch – standing, heel on floor':
		'Interruptor acionado com o pé – em pé, com o calcanhar apoiado no chão',
	'Ankle pedal control, seated (accelerator)': 'Controle dos pedais com o tornozelo, sentado (acelerador)',
	'Clutch and brake pedals – normal operation': 'Pedais de embreagem e freio – operação normal',
	'Vertical movement': 'Movimento vertical',
	'Lateral and longitudinal movement': 'Movimento lateral e longitudinal',
	'Hand-arm Vibration A(eq) for 8-hr exposure': 'Vibração de mão-braço A(eq) por 8 horas de exposição',
	'Without gloves': 'Sem uso de luvas',
	'Assembly gloves': 'Luvas de montagem',
	'Welding gloves': 'Luvas de soldagem',
	'Viewing area in relation to the horizontal line at eye level':
		'Área de visualização em relação a linha horizontal da altura do olho',
	Height: 'Altura',
	Width: 'Largura',
	Diameter: 'Diâmetro',
	'Object dimension': 'Dimensão do objeto',
	'Reach zone': 'Zona de alcance',
	'Body part': 'Parte do corpo',
	'Minimum gap': 'Vão mínimo',
	Criterion: 'Critério',
	"Some required step wasn't filled": 'Alguma etapa obrigatória não foi preenchida',
	Unlikely: 'Improvável',
	Remote: 'Remota',
	Occasional: 'Ocasional',
	Likely: 'Provável',
	Frequent: 'Frequente',
	Certainly: 'Certamente',
	'Muscle fatigue/discomfort or near-miss accident': 'Fadiga muscular/desconforto ou quase acidente',
	'No absence': 'Sem ausência',
	'No absence with surgery or restriction': 'Nenhuma ausência com cirurgia ou restrição',
	'Absence - loss of work capacity and/or hospitalization':
		'Ausência - perda da capacidade de trabalho e/ou hospitalização',
	'>20 strikes per hour': '>20 batidas por hora',
	'<20 strikes per hour': '<20 batidas por hora',
	'>40 strikes per hour': '>40 batidas por hora',
	'1 strike per minute': '1 batida por minuto',
	'<10 strikes per hour': '<10 batidas por hora',
	'2 strikes per minute': '2 batidas por minuto',
	'< 2 light taps for alignment': '<2 batidas leves para alinhar',
	'The action of pulling/pushing loads or volumes with great effort':
		'Realiza tarefas que exigem forças acentuadas para empurrar e puxar',
	'Vision-guided tasks outside the primary viewing area (0° to 45°)':
		'Tarefas orientadas pela visão fora da área de visão primária (0° a 45°)',
	'Standing for long periods': 'Postura de pé por longos períodos',
	'Sitting for long periods (fixed height)': 'A estação de trabalho envolve trabalhar sentado (altura fixa)',
	'Sitting for long periods (adjustable station)':
		'A estação de trabalho envolve trabalhar sentado (estação ajustável)',
	'Exposure to whole-body vibration': 'Exposição à vibração de corpo inteiro',
	'Musculoskeletal strain on wrists and elbows': 'Tensão musculoesquelética nos pulsos e cotovelos',
	'Development of musculoskeletal disorders and/or eye fatigue':
		'Desenvolvimento de distúrbios musculoesqueléticos e/ou fadiga ocular',

	// JDS D86
	'Ergonomic evaluation': 'Avaliação ergonômica',
	'Frequent motions': 'Movimentos frequentes',
	'Excessive reaches': 'Alcances excessivos',
	'Lifting of heavy components and tools': 'Levantamento de componentes e ferramentas pesados',
	'Handling of bulky parts': 'Manuseio de peças volumosas',
	'Heavy exertions to install parts': 'Grande esforço para instalar as peças',
	'High forces to pull or push carts, baskets and containers':
		'Força extrema para puxar ou empurrar carrinhos, cestas e recipientes',
	'Contact stress': 'Tensão por contato',
	'Sharp edges are present': 'Há presença de cantos vivos',
	'The noise level is very high': 'O nível de ruído é muito alto',
	'Poor access or inadequate clearances': 'Difícil acesso ou folgas inadequadas',
	'Awkward or static postures': 'Posturas inadequadas',
	'Staying in a static posture for a long time': 'Permanece tempo prolongado em postura estática',
	'Video selection': 'Seleção de video',
	'Search for a file': 'Procure um arquivo',
	Revaluations: 'Reavaliações',
	'Last revaluation': 'Ultima reavalição',
	'New revaluation': 'Nova reavalição',
	Revaluation: 'Reavaliação',
	'General History': 'Histórico Geral',
	Crouching: 'Agachado',
	Kneeling: 'Ajoelhado',
	Standing: 'Em pé',
	'Time per episode': 'Tempo por episódio',
	'Frequency per hour': 'Frequência por hora',
	'Total time (in one day)': 'Tempo total (em um dia)',
	'Are you sure you want to delete the last revaluation': 'Tem certeza que deseja excluir a última reavalição',
	'Are you sure you want to delete the review': 'Tem certeza que deseja excluir a análise',
	'Delete report': 'Excluir relatório',
	'Delete the last revaluation': 'Excluir a última reavaliação',
	'JDS D86 last revaluation deleted successfully': 'JDS D86 reavalição excluída com sucesso',
	'Delete review': 'Excluir revisão',
	'You can delete the entire report or just the last revaluation':
		'Você pode excluir o relatório inteiro ou apenas a reavalição mais recente',
	'JDS D86 deleted successfully': 'JDS D86 excluído com sucesso',
	'Select the video file below for the task you want to analyze':
		'Selecione abaixo o arquivo de vídeo referente à tarefas que deseja analisar',
	Evaluation: 'Avaliação',
	'Generating a document': 'Gerando um documento',
	'The created document is being generated and will be downloaded':
		'O documento criado está sendo gerado e será baixado',
	'Noise level': 'Nível de ruído',
	'Select the Report name': 'Selecione o nome do relatório',

	//D92
	'Lifting tasks': 'Levantamento',
	'Push, pull and carry': 'Empurrar, puxar e carregar',
	'Handles work objects above the shoulder or below the knee':
		'Realiza manuseio de objetos de trabalho acima do ombro ou abaixo do joelho',
	'Shoulder moment calculator': 'Calculadora de momento para ombro',
	'Manual lifting (NIOSH)': 'Levantamento de cargas (NIOSH)',
	'Manual handling (KIM MHO)': 'Manuseio manual (KIM MHO)',
	'Lever Arm': 'Braço de alavanca',
	'Type of Task': 'Tipo de tarefa',
	'Material handling (Liberty Mutual)': 'Manuseio de material (Liberty Mutual)',
	'Use of manually operated carts': 'Uso de carrinhos movimentados manualmente',
	'Is the manual force to lift the car out of inertia less than 22kg?':
		'A força manual para retirar o carro da inércia é menor do que 22kg?',
	'Is the sustained hand force less than 11.5kg?': 'A força manual sustentada é menor do que 11,5kg?',
	'Is the diameter to fit the fingers larger than 30mm and smaller than 50mm?':
		'O diâmetro para encaixe dos dedos é maior do que 30mm e menor do que 50mm?',
	'Is the vertical handle between 900mm and 1225mm?': 'A alça vertical está entre 900mm e 1225mm?',
	'Is the width from one handle to the other larger than 400mm and smaller than 600mm?':
		'A largura de uma pega à outra é maior do que 400mm e menor do que 600mm?',
	'Is the caster in good condition?': 'O rodízio está em boa condição?',
	'Is the road in good condition?': 'O trajeto percorrido está em boa condição?',
	'Is the layout in good condition for moving the car, with enough space for maneuvering?':
		'O layout está em boa condição para movimentação do carro com espaços suficientes para manobras?',
	'Is the floor in good condition?': 'O piso está em boa condição?',
	'Handling load': 'Manuseio de carga',
	'Horizontal push or pull': 'Empurrar ou puxar horizontal',
	'Push or pull downward': 'Empurrar ou puxar para baixo',
	'Distance from the acromion to the center of the load (greatest distance)':
		'Distância do acrômio ao centro da carga (maior distância)',
	'Repetitions in a working day': 'Repetições em um dia de trabalho',
	'Apply when moving a part with a mass greater than 4.5 kg with one hand':
		'Aplicar quando há movimentação  de uma peça de massa maior que 4,5kg com uma mão',
	'Apply when moving a piece with a mass greater than 9kg with two hands in up to two steps':
		'Aplicar quando há movimentação  de uma peça de massa maior que 9kg com duas mãos em até dois passos',
	'Apply when there is movement in a critical scenario (e.g. bottom of a container)':
		'Aplicar quando há movimentação  em um cenário crítico (ex: fundo de um container)',
	'per work day': 'por dia',
	'Probability of Shoulder Outcome': 'Probabilidade de consequência para ombro',
	'The task should serve 75% of the female population': 'A tarefa deve atender 75% da população feminina',

	//  Back compressive force estimation
	'Back compressive force estimation': 'Estimativa da força de compressão lombar',
	"Person's weight": 'Peso da pessoa',
	'Person weight': 'Peso da pessoa',
	'Insert the person weight': 'Insira o peso da pessoa',
	"Person's height": 'Altura da pessoa',
	'Person height': 'Altura da pessoa',
	'Insert the person height': 'Insira a altura da pessoa',
	'Trunk angle to Horizontal': 'Ângulo do tronco em relação a horizontal',
	'Trunk angle to horizontal': 'Ângulo do tronco em relação a horizontal',
	'Insert a trunk angle': 'Insira o ângulo do tronco',
	'Load in hands': 'Carga sendo manuseada',
	'Insert the load in hands': 'Insira a carga sendo manuseada',
	'Horizontal distance from hands to low back': 'Distância horizontal das mãos à região lombar',
	'Insert a horizontal distance': 'Insira a distância horizontal',
	'Total compressive force': 'Força Compressiva Total',
	'Back compressive force estimation report updated successfully':
		'Estimativa de força de compressão foi atualizada com sucesso',
	'Creation date': 'Data de criação',
	"Enter the operator's activity-related data below": 'Insira abaixo os dados relacionados à atividade do operador',
	Dimensions: 'Dimensões',
	'Condition found': 'Condição encontrada',
	'Select the video files for the operations that make up the workstation below':
		'Selecione abaixo o arquivo de vídeo referente à tarefas que deseja analisar',
	'Are you sure you want to delete the evaluation': 'Tem certeza que deseja excluir a avalição',
	'Document generated!': 'Documento gerado!',
	'Work conditions': 'Condições de trabalho',
	'Influence of organizational factors': 'Influência organizacionais',
	'Activity created successfully': 'Atividade criada com sucesso',
	'Select EWA': 'Seleção de AEP',
	'Unable to load data': 'Não foi possível carregar os dados',

	// New Dashboard
	'No data available.': 'Não há dados.',
	'This page was not found.': 'Essa página não foi encontrada.',
	'Try Again': 'Tentar novamente',
	'Start date must be before end date': 'Data inicial deve ser antes da final',
	'End date must be after start date': 'Data final deve ser após a inicial',
	'Number of reports': 'Número de relatórios',
	'Unable to load custom reports': 'Não foi possível carregar os relatórios personalizados',
	'Actions created and resolved': 'Ações criadas e resolvidas',
	'Actions created': 'Ações criadas',
	'Delayed actions': 'Ações atrasadas',
	Late: 'Atrasados',
	'Not started': 'Não iniciadas',
	Total: 'Total',
	'Number of actions': 'Quantidade de ações',
	Variation: 'Variação',
	'Risk evolution': 'Evolução do risco',
	'Main risk category': 'Principal categoria de risco',
	"Sum of RPN of factors '6 too'": "Soma de RPN dos fatores '6 too'",
	'Too Many Times': 'Muitas Vezes',
	'Too Heavy': 'Muito Pesado',
	'Risk comparison between': 'Comparativo de risco entre',
	files: 'arquivos',
	workstations: 'postos de trabalho',
	lines: 'linhas',
	sectors: 'setores',
	'industrial sites': 'plantas industriais',
	'Comparison of': 'Comparação de',
	'with variation': 'com variação',
	'Percentile by gender': 'Percentil por gênero',
	'Male percentile': 'Percentil masculino',
	'Female percentile': 'Percentil feminino',
	'Reports generated': 'Relatórios gerados',
	'General overview': 'Visão geral',
	'Ergonomic Risk Management': 'Gestão de Riscos Ergonômicos',
	'Ergonomics Assessments Tools Status': 'Status das Ferramentas de Avaliação Ergonômica',
	'John Deere Enterprise Ergonomics Assessments Tools Status':
		'Status das Ferramentas de Avaliação Ergonômica da John Deere',
	'Checklist reports generated': 'Relatórios de checklist gerados',
	'Action plan status': 'Status dos planos de ação',
	'Start date': 'Data inicial',
	'End date': 'Data final',
	'Predetermined time frame': 'Espaço de tempo pré-determinado',
	Week: 'Semana',
	Months: 'Meses',
	'Highest incidence': 'Categoria de maior',
	category: 'incidência',
	'Granularity of information': 'Granularidade das informações',
	'Change date for all': 'Alterar data para todos',
	'Single period': 'Período único',
	'Compound period (comparative)': 'Período composto (comparativo)',
	'Period 1': 'Período 1',
	'Period 2': 'Período 2',
	Biomechanical: 'Biomecânico',
	quarter: 'trimestre',
	semester: 'semestre',
	Feb: 'Fev',
	Apr: 'Abr',
	May: 'Maio',
	Aug: 'Ago',
	Sep: 'Set',
	Oct: 'Out',
	Dec: 'Dez',
	to: 'até',
	'Slightly high': 'Ligeiramente elevado',
	'Substantially high': 'Substancialmente elevado',
	Torso: 'Tronco',
	'Exposure score of all body parts': 'Score de exposição de todos os seguimentos do corpo',
	'Exposure by body side': 'Exposição por lado do corpo',
	'Left side': 'Lado esquerdo',
	'Right side': 'Lado direito',
	'Investigate and implement changes': 'Investigar e implementar mudanças',
	'PEA (ISO 20646)': 'AEP (NR-17)',
	'PEA (ISO 20646 + JDS D86)': 'AEP (NR-17 + JDS D86)',
	Today: 'Hoje',
	'This week': 'Esta semana',
	'This month': 'Este mês',
	'This quarter': 'Este trimestre',
	'This semester': 'Este semestre',
	'This year': 'Este ano',
	'Last 7 days': 'Últimos 7 dias',
	'Last 30 days': 'Últimos 30 dias',
	'Last 3 months': 'Últimos 3 meses',
	'Last 6 months': 'Últimos 6 meses',
	'Last 12 months': 'Últimos 12 meses',
	'From the beginning': 'Desde o início',
	'Fiscal year (FY)': 'Ano fiscal (FY)',
	'Want to know more about Kinebot?': 'Quer saber mais sobre a Kinebot?',
	'Evidence removed': 'Evidência removida',
	'Attachment removed': 'Anexo removido',
	'Evidence updated successfully': 'Evidência atualizada com sucesso',
	'Attachment updated successfully': 'Anexo atualizado com sucesso',
	'Action plan attachment not found': 'Anexo do plano de ação não encontrado',
	'Action plan evidence not found': 'Evidência do plano de ação não encontrada',
	'Task removed successfully': 'Tarefa removida com sucesso',
	'Action plan updated': 'Plano de ação atualizado',
	'Selected action plans deleted successfully': 'Planos de ação selecionados excluídos com sucesso',
	'Failed to deleted selected action plans': 'Erro ao excluir planos de ação selecionados',
	'Drag or select the files you want to attach to your action plan':
		'Arraste ou selecione os arquivos que você deseja anexar ao seu plano de ação',
	'Are you sure you want to remove the attachment': 'Tem certeza que deseja remover o anexo',
	'Add description': 'Adicionar descrição',
	'File description': 'Descrição do arquivo',
	'Upload author': 'Autor de upload',
	'Attach files': 'Anexar arquivos',
	'Attach evidences': 'Anexar evidencias',
	'New action plan': 'Novo plano de ação',
	Sort: 'Ordenação',
	Board: 'Quadro',
	Table: 'Tabela',
	Notifications: 'Notificações',
	Responsable: 'Responsável',
	'Select the responsible': 'Selecione o responsável',
	'Create an action plan': 'Criar um plano de ação',
	'Action plan name': 'Nome do plano de ação',
	'Alphabetical A-Z': 'Alfabética A-Z',
	'Alphabetical Z-A': 'Alfabética Z-A',
	'Most recent': 'Mais recente',
	'Least recent': 'Mais antigo',
	'Nearest due date': 'Vencimento próximo',
	'Furthest due date': 'Vencimento distante',
	'Highest priority': 'Maior prioridade',
	'Lowest priority': 'Menor prioridade',
	'Highest investment': 'Maior investimento',
	'Lowest investiment': 'Menor investimento',
	'Attach new file': 'Anexar novo arquivo',
	'Action plan deleted': 'Plano de ação deletado',
	'Description changed': 'Descrição alterada',
	'Title changed': 'Título alterado',
	'Responsible changed': 'Responsável alterado',
	'Due date changed': 'Data de vencimento alterada',
	'Priority changed': 'Prioridade alterada',
	'Investment changed': 'Investimento alterado',
	'Attachment added': 'Anexo adicionado',
	'Evidence added': 'Evidência adicionada',
	'Task changed': 'Tarefa alterada',
	'Task removed': 'Tarefa removida',
	'Task added': 'Tarefa adicionada',
	'Task completed': 'Tarefa concluída',
	'Task uncompleted': 'Tarefa desconcluída',
	'Linked tool': 'Ferramenta vinculada',
	'Unlinked tool': 'Ferramenta desvinculada',
	'Comment added': 'Comentário adicionado',
	'Comment removed': 'Comentário removido',
	'Comment changed': 'Comentário alterado',
	'Error fetching responsible options': 'Erro ao buscar opções de responsável',
	'Are you sure you want to delete the selected items?': 'Tem certeza que deseja excluir os itens selecionados?',
	'Please select a priority': 'Selecione uma prioridade',
	'Please select a date': 'Selecione uma data',
	'Please select a responsible': 'Selecione um responsável',
	Evidences: 'Evidências',
	'Notification Control': 'Controle de notificações',
	'Follow up action plans created by me': 'Acompanhar planos de ação criados por mim',
	'Receive an e-mail when the status of the action plan changes':
		'Receber e-mail quando o status do plano de ação for alterado',
	'Receive e-mail when tasks are completed': 'Receber e-mail quando tarefas forem concluídas',
	'Follow up on action plans assigned to me': 'Acompanhar planos de ação atribuídos a mim',
	'Receive an e-mail when a new action plan is assigned to me':
		'Receber e-mail quando um novo plano de ação for atribuído a mim',
	'Receive an e-mail when the due date is near': 'Receber e-mail quando a data de vencimento estiver próxima',
	Unknown: 'Desconhecido',
	'Select the due date': 'Selecione a data de vencimento',
	By: 'Por',
	'Investment value': 'Valor de investimento',
	'EWA JDS-D86': 'AEP + JDS-D86',
	'Open action plan': 'Abrir plano de ação',
	Low: 'Baixa',
	Medium: 'Média',
	High: 'Alta',
	'Action plans updated successfully': 'Planos de ação atualizados com sucesso',
	'Attachments - Images': 'Anexos - Imagens',
	'Attachments - Other files': 'Anexos - Outros arquivos',
	'Completed tasks': 'Tarefas concluídas',
	'Tasks not completed': 'Tarefas não concluídas',
	'Edit history': 'Histórico de edições',
	'Categorization of the urgency of action plan resolution':
		'Categorização da urgência de resolução do plano de ação',
	'Expected cost of the action plan': 'Expectativa de custo do plano de ação',
	Exporting: 'Exportando',
	'There are tasks that have not been saved.': 'Existem tarefas que não foram salvas.',
	'Tools updated successfully': 'Ferramentas atualizadas com sucesso',
	'Enter the action plan name': 'Insira o nome do plano de ação',
	'Description of the file': 'Descrição do arquivo',
	'Failed to upload file': 'Falha ao carregar o arquivo',
	'File uploaded successfully': 'Arquivo carregado com sucesso',
	'Failed to load attachments': 'Falha ao carregar anexos',
	'You are activating sandbox mode.': 'Você está ativando o modo sandbox.',
	'From now on, no actions will be recorded in the official environment.':
		'A partir de agora, nenhuma ação será registrada no ambiente oficial.',
	'Use the area for simulations.': 'Utilize a área para simulações.',
	'You are activating sandbox mode. From now on, no actions will be recorded in the official environment - use the area for simulations.':
		'Você está ativando o modo sandbox. A partir de agora, nenhuma ação será registrada no ambiente oficial - utilize a área para simulações.',
	'You are exiting sandbox mode.': 'Você está saindo do modo sandbox.',
	'All actions that have not been applied will be lost.': 'Todas as ações que não foram aplicadas serão perdidas.',
	'You are exiting sandbox mode. All actions that have not been applied will be lost.':
		'Você está saindo do modo sandbox. Todas as ações que não foram aplicadas serão perdidas.',
	'Exit without applying': 'Sair sem aplicar',
	'To production': 'Para Produção',
	'To sandbox': 'Para Sandbox',
	'New report': 'Novo relatório',
	'Video upload': 'Upload de vídeo',
	'Apply all': 'Aplicar tudo',
	'For the application of the report in the official environment, the following items will also be applied':
		'Para a aplicação do relatório no ambiente oficial, os seguintes itens também serão aplicados:',
	'Apply report in the official environment': 'Aplicar relatório no ambiente oficial',
	Update: 'Atualizar',
	'Error on send report': 'Erro ao enviar relatório',
	'Report sent successfully': 'Relatório enviado com sucesso',
	'Error on exists report': 'Erro ao verificar existência do relatório',
	'Error on logout': 'Erro ao sair',
	'Data extraction': 'Extração de dados',
	'Action Plans': 'Planos de ação',
	'Initial date': 'Data inicial',
	'Final date': 'Data final',
	Included: 'Incluído',
	'Not included': 'Não incluído',
	Both: 'Ambos',
	'Would you like to receive email notifications when the extractions are available?':
		'Você gostaria de receber notificações por email quando as extrações estiverem disponíveis?',
	'Do you want to disable email notifications?': 'Você deseja desativar as notificações por email?',
	'Do you want to delete the selected extractions?': 'Você deseja excluir as extrações selecionadas?',
	'Notifications disabled successfully': 'Notificações desabilitadas com sucesso!',
	'Notifications enabled successfully': 'Notificações habilitadas com sucesso!',
	'Error disabling notifications': 'Erro ao desabilitar notificações!',
	'Error enabling notifications': 'Erro ao habilitar notificações!',
	'General information': 'Informações gerais',
	'Choose the hierarchy and period for data collection. These selections will determine the content available for extraction.':
		'Escolha a hierarquia e período para a coleta das informações. Essas seleções determinarão o conteúdo disponível para extração.',
	'Start reference date': 'Data inicial de referência',
	'End reference date': 'Data final de referência',
	'Date ': 'Data',
	'By file': 'Por arquivo',
	'By hierarchy': 'Por hierarquia',
	'From template': 'Por modelo',
	'New extraction': 'Nova extração',
	'Name is required': 'Nome é obrigatório',
	'Company is required': 'Empresa é obrigatória',
	'Do you want to delete the extraction': 'Deseja excluir a extração',
	'No content available': 'Nenhum conteúdo disponível',
	Content: 'Conteúdo',
	'Download CSV': 'Baixar CSV',
	'Reference start date': 'Data inicial de referência',
	'Reference end date': 'Data final de referência',
	'Show extraction': 'Mostrar extração',
	'Download extraction': 'Baixar extração',
	'Edit extraction': 'Editar extração',
	'Delete extraction': 'Excluir extração',
	'By template': 'Por modelo',
	'Error fetching total created custom reports': 'Erro ao buscar total de relatórios personalizados criados',
	'Review action plans': 'Verificar planos de ação',
	'Do you want to extract the action plans from the report(s)?':
		'Deseja extrair os planos de ação do(s) relatório(s)?',
	'Showing the available tools in': 'Exibindo as ferramentas disponíveis em',
	report: 'relatório',
	'Deselect all': 'Desselecionar todos',
	'Select one or more tools for extraction. If desired, you can proceed without including tools in the extraction.':
		'Selecione uma ou mais ferramentas para extração. Se desejado, você pode prosseguir sem incluir ferramentas na extração.',
	'General Information': 'Informações Gerais',
	'Number of attachments': 'Quantidade de anexos',
	'Number of evidences': 'Quantidade de evidências',
	'Completion date': 'Data de finalização',
	Source: 'Origem',
	'Source and information of action plans': 'Origem e informações dos planos de ação',
	'The extraction will include action plans from the following sources:':
		'A extração incluirá os planos de ação das seguintes origens:',
	'Select the information from the action plans you want to include in the extraction:':
		'Selecione as informações dos planos de ação que deseja incluir na extração:',
	'Set as template': 'Definir como modelo',
	'The extraction contains the following information:': 'A extração contém as seguintes informações:',
	'Content of action plans:': 'Conteúdo dos planos de ação:',
	Extraction: 'Extração',
	'has been added to the queue and will be available for download on the home page soon':
		'foi adicionada à fila e estará disponível para download na página inicial em breve',
	'Go to home page': 'Ir para página inicial',
	'Could not create extraction': 'Não foi possível criar a extração',
	'please try again': 'por favor tente novamente',
	'Select the information you want to include in the extraction:':
		'Selecione as informações que deseja incluir na extração',
	'Data Extraction CSV file created successfully! Download in progress.':
		'Arquivo CSV da extração de dados criado com sucesso! Download em andamento.',
	'Unable to download the data extraction file. Please try again.':
		'Não foi possível baixar o arquivo de extração de dados. Por favor, tente novamente.',
	Pending: 'Pendente',
	'In progress': 'Em progresso',
	Failed: 'Falhou',
	'Content:': 'Conteúdo:',
	'Action plans content:': 'Conteúdo dos planos de ação:',
	'No report selected': 'Nenhum relatório selecionado',
	'No action plan is linked to this extraction': 'Nenhum plano de ação está vinculado a esta extração',
	'Select the action plans sources and information to include in the extraction.':
		'Selecione as fontes e informações dos planos de ação que deseja incluir na extração.',
	'Select one or more origins for extracting action plans. If desired, you can proceed without including action plans in the extraction.':
		'Selecione uma ou mais fontes para extrair os planos de ação. Se desejar, você pode prosseguir sem incluir planos de ação na extração.',
	'Select a report category for extraction. You can proceed without including a report in the extraction if you wish.':
		'Selecione uma categoria de relatório para extração. Se desejado, você pode prosseguir sem incluir um relatório na extração.',
	'Initial reference date': 'Data inicial de referência',
	'Final reference date': 'Data final de referência',
	'Select the reports you want to include in the extraction':
		'Selecione os relatórios que deseja incluir na extração',
	'Search for a report': 'Pesquisar por um relatório',
	Selected: 'Selecionado(s)',
	'Extraction template name': 'Nome do modelo de extração',
	'By model': 'Por modelo',
	'Choose model': 'Escolha o modelo',
	'Select the desired model and edit the necessary information to create a new extraction':
		'Selecione o modelo desejado e edite as informações necessárias para criar uma nova extração',
	'Use template': 'Usar modelo',
	'The report has been successfully added to the data extraction':
		'Relatório adicionado com sucesso à extração de dados',
	'Failed to add the report to the data extraction': 'Erro ao adicionar o relatório à extração de dados',
	'The report has been successfully removed from the data extraction':
		'Relatório(s) removido(s) com sucesso da extração de dados',
	'Failed to remove the report from the data extraction': 'Erro ao remover o relatório da extração de dados',
	'Data extraction updated successfully': 'Extração de dados atualizada com sucesso',
	'Error updating data extraction': 'Erro ao atualizar a extração de dados',
	'Select the files you want to include in the extraction': 'Selecione os arquivos que deseja incluir na extração',
	'Please select at least one file': 'Selecione pelo menos um arquivo',
	'The extraction contains the following information': 'A extração contém as seguinte informações',
	'Action Plan': 'Plano de ação',
	'Industrial site is required': 'Planta industrial é obrigatória',
	'action plans': 'planos de ação',
	'Extraction deleted successfully': 'Extração excluída com sucesso',
	'Extractions deleted successfully': 'Extrações excluídas com sucesso',
	'Failed to delete extraction': 'Erro ao excluir a extração',
	'Do you want to delete the extraction model': 'Deseja excluir o modelo de extração',
	'Status updated successfully': 'Status atualizado com sucesso',
	'Error updating status': 'Erro ao atualizar o status',
	'Notifications disabled successfully!': 'Notificações desabilitadas com sucesso!',
	'Notifications enabled successfully!': 'Notificações habilitadas com sucesso!',
	'Error updating notification preferences': 'Erro ao atualizar as preferências de notificações',
	'The tools listing shows the number of reviews available in each category.':
		'A listagem de ferramentas informa a quantidade de avaliações disponíveis em cada categoria.',
	'Origin not specified': 'Origem não especificada',
	'Due date ': 'Prazo de vencimento',
	'Data extraction model created successfully': 'Modelo de extração de dados criado com sucesso',
	'Error creating data extraction model': 'Erro ao criar o modelo de extração de dados',
	Displaying: 'Exibindo',
	'Data extraction created successfully': 'Extração de dados criada com sucesso',
	'Download unavailable - extraction not completed': 'Download indisponível - extração não concluída',

	// Resolution 886
	'Resolution 886': 'Resolução 886',
	'Job position': 'Cargo',
	'Written work procedure': 'Procedimento escrito de trabalho',
	'Early manifestation': 'Manifestação precoce',
	'Symptom location': 'Localização de sintoma',
	'Evaluation name': 'Nome da avaliação',
	Training: 'Treinamento',
	'Worker name': 'Nome do trabalhador',
	'Number of workers': 'Número de trabalhadores',
	Workers: 'Trabalhadores',
	'Create new version': 'Criar nova versão',
	'View versions': 'Ver versões',
	Download: 'Baixar',
	'New evaluation': 'Nova avaliação',
	'Select line': 'Selecione a linha',
	'Select workstation': 'Selecione o posto de trabalho',
	'Select sector': 'Selecione o setor',
	'Select work center': 'Selecione o centro de trabalho',
	"Worker's name": 'Nome do trabalhador',
	Versions: 'Versões',
	'Do you want to delete the Initial Version of the evaluation':
		'Tem certeza que deseja excluir a versão inicial da avaliação',
	'Do you want to delete the evaluation': 'Tem certeza que deseja excluir a avaliação',
	'and all its versions': 'e todas as suas versões',
	'Once a new review is created, the current version will no longer be editable. Do you wish to continue?':
		'Uma vez criada uma nova revisão, a versão atual já não será editável. Deseja continuar?',
	'Enter the data related to the evaluation.': 'Insira os dados relacionados à avaliação.',
	'Worker(s) name': 'Nome do(s) trabalhador(es)',
	'Workers number': 'Número de trabalhadores',
	'Responsible of the Occupational Medicine Service': 'Responsável pelo Serviço de Medicina do Trabalho',
	'Responsible for the Hygiene Service and Security': 'Responsável pelo Serviço de Higiene e Segurança',
	Employer: 'Contratante',
	'Identify tasks and carry out their evaluation.': 'Identificar tarefas e realizar a sua avaliação.',
	'Select a worker': 'Selecione um trabalhador',
	'Please enter a worker': 'Insira um trabalhador',
	'Add worker': 'Adicionar trabalhador',
	'Enter the workers number': 'Insira o número de trabalhadores',
	'Enter the workers name': 'Insira o nome do(s) trabalhador(es)',
	'select a work center': 'Selecione um centro de trabalho',
	'Enter a symptom location': 'Insira uma localização de sintoma',
	'Tolerable risk': 'Risco tolerável',
	'Unacceptable risk': 'Risco não tolerável',
	'Each task corresponds to a specific administrative or engineering measure. Modify the person responsible and the due date, and keep the “Administrative” or “Engineering” prefix when modifying the task name. To create new tasks, always identify them with the corresponding measure prefix in the title.':
		'Cada tarefa corresponde a uma medida específica de administração ou engenharia. Modifique o responsável e a data de vencimento, e mantenha o prefixo “Administrativo” ou “Engenharia” quando modificar o nome da tarefa. Para criar novas tarefas, sempre identifique-as com o prefixo correspondente na título.',
	Engineering: 'Engenharia',
	'Video Selection': 'Seleção de vídeo',
	'Select the videos corresponding to the tasks that will be evaluated':
		'Selecione os vídeos correspondentes às tarefas que serão avaliadas',
	'Evaluation Resolution 886': 'Avaliação Resolução 886',
	Showing: 'Mostrando',
	'Risk evaluation': 'Avaliação de risco',
	'Select the risk level:': 'Selecione o nível de risco:',
	'The risk factor can be evaluated using the NIOSH tool:':
		'O fator de risco pode ser avaliado utilizando a ferramenta NIOSH:',
	ErgonomicTool886: 'O fator de risco pode ser avaliado utilizando a ferramenta {{tool_name}}:',
	'Load lifting': 'Levantamento de carga',
	'Observations:': 'Observações:',
	Observations: 'Observações',
	'Watch video': 'Ver vídeo',
	'Hand-arm vibration': 'Vibração de mão e braço',
	Transport: 'Transporte',
	'Repetitive movements': 'Movimentos repetitivos',
	'Thermal comfort': 'Conforto térmico',
	'Whole body vibration': 'Vibração corporal',
	'Push / pull': 'Empurrar / puxar',
	'Forced posture': 'Postura forçada',
	'Evaluation of risk factors': 'Avaliação de fatores de risco',
	'Select the risk factor to carry out the evaluation. Factors not evaluated will be considered a tolerable risk.':
		'Selecione o fator de risco para realizar a avaliação. Fatores não avaliados serão considerados um risco tolerável.',
	'Evaluation not started': 'Avaliação não iniciada',
	Evaluate: 'Avaliar',
	'Initial evaluation of risk factors': 'Avaliação inicial de fatores de risco',
	'Fill out the following information.': 'Preencha as seguintes informações.',
	'Indicate the time of exposure to the risk factor (in percentage)':
		'Indique o tempo de exposição ao fator de risco (em porcentagem)',
	'This value will be added to the total exposure time to the Risk Factor.':
		'Este valor será adicionado ao tempo total de exposição ao Fator de Risco.',
	obligatorily: 'obrigatoriamente',
	moderate: 'moderado',
	'not tolerable': 'não tolerável',
	'Identify if the task of the job position involves': 'Identifique se a tarefa do cargo envolve',
	'Safety and hygiene responsible': 'Responsável por segurança e higiene',
	'Occupational doctor': 'Médico do trabalho',
	'Safety and hygiene responsible created successfully': 'Responsável por segurança e higiene criado com sucesso',
	'Error on create safety and hygiene responsible': 'Erro ao criar responsável por segurança e higiene',
	'Safety and hygiene responsible updated successfully': 'Responsável por segurança e higiene atualizado com sucesso',
	'Error on update safety and hygiene responsible': 'Erro ao atualizar responsável por segurança e higiene',
	'Safety and hygiene responsible destroyed successfully': 'Responsável por segurança e higiene deletado com sucesso',
	'Error on destroy safety and hygiene responsible': 'Erro ao deletar responsável por segurança e higiene',
	'Occupational doctor created successfully': 'Médico do trabalho criado com sucesso',
	'Error on create occupational doctor': 'Erro ao criar médico do trabalho',
	'Occupational doctor updated successfully': 'Médico do trabalho atualizado com sucesso',
	'Error on update occupational doctor': 'Erro ao atualizar médico do trabalho',
	'Occupational doctor destroyed successfully': 'Médico do trabalho deletado com sucesso',
	'Error on destroy occupational doctor': 'Erro ao deletar médico do trabalho',
	'Select a responsible': 'Selecione um responsável',
	'Enter a workers number': 'Insira o número de trabalhadores',
	'Please select a written work procedure': 'Existência de um procedimento escrito de trabalho',
	'Please select a training': 'Existência de um treinamento',
	'Please select a early manifestation': 'Existência de uma manifestação precoce',
	'Please enter a workers number': 'Por favor insira o número de trabalhadores',
	'Please select a worker': 'Por favor selecione o(s) trabalhador(es)',
	'Please select a workstation': 'Por favor selecione o posto de trabalho',
	'Please enter an evaluation name': 'Por favor insira o nome da avaliação',
	'Please select a responsible of the occupational medicine service':
		'Por favor selecione um responsável pelo serviço de medicina do trabalho',
	'Please select a responsible for the hygiene service and security':
		'Por favor selecione um responsável pelo serviço de higiene e segurança',
	'Please select an employer': 'Por favor selecione um contratante',
	'Please enter a job position': 'Por favor insira o cargo',
	'Please select an evaluator': 'Por favor selecione um avaliador',
	'Please enter a symptom location': 'Por favor insira uma localização de sintoma',
	'Please select a line': 'Por favor selecione uma linha',
	'Please select a sector': 'Por favor selecione um setor',
	'Please select a company': 'Por favor selecione uma empresa',
	'Please select a industrial site': 'Por favor selecione uma planta industrial',
	'Lift and lower': 'Levantar e baixar',
	'Step 1: Identify if the task of the job position involves': 'Passo 1: Identificar se a tarefa do cargo envolve',
	'Step 2: Determine the risk level': 'Passo 2: Determinar o nível de risco',
	'Determine the risk level': 'Determinar o nível de risco',
	'Lifting and/or lowering loads weighing more than 2 kg and up to 25 kg?':
		'Levantamento e/ou abaixamento de cargas com peso superior a 2 kg e até 25 kg?',
	'Does the worker perform lifting/lowering operations daily and cyclically with a frequency of ≥ 1 per hour or ≤ 360 per hour? (If done sporadically, indicate "No")':
		'O trabalhador realiza operações de levantamento/abaixamento diária e ciclicamente com frequência de >= 1 por hora ou <= 360 por hora? (Se feito esporadicamente, indicar "Não")',
	'Lifting and/or lowering loads weighing more than 25 kg?':
		'Levantamento e/ou abaixamento de cargas com peso superior a 25 kg?',
	'Does the worker lift, hold, and deposit the load exceeding 30 cm above shoulder height with their hands?':
		'O trabalhador levanta, segura e deposita a carga ultrapassando 30 cm acima da altura dos ombros com as mãos?',
	'Does the worker lift, hold, and deposit the load more than 80 cm horizontally from the midpoint between the ankles?':
		'O trabalhador levanta, segura e deposita a carga a mais de 80 cm horizontalmente do ponto médio entre os tornozelos?',
	'Between lifting and depositing the load, does the worker twist or bend their waist more than 30º to either side (or both) from the sagittal plane?':
		'Entre o levantamento e o depósito da carga, o trabalhador torce ou flexiona a cintura mais de 30º para qualquer lado (ou ambos) do plano sagital?',
	'Do the loads have irregular shapes, are difficult to grasp, deform, or have movement inside?':
		'As cargas possuem formatos irregulares, são difíceis de agarrar, se deformam ou possuem movimento interno?',
	'Does the worker lift, hold, and deposit the load with one arm?':
		'O trabalhador levanta, segura e deposita a carga com um braço?',
	'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?':
		'O trabalhador apresenta algum sinal precoce das doenças mencionadas no Artigo 1 desta Resolução?',

	// Manual load push and pull
	'Manual load push and pull': 'Empurrar e puxar carga manual',
	'Are cyclical tasks performed daily, with a frequency of ≥ 1 movement per day? (If sporadic, indicate “No”)':
		'Tarefas cíclicas são realizadas diariamente, com frequência de >= 1 movimento por dia? (Se esporádico, indicar "Não")',
	'Does the worker move by pushing and/or pulling an object over a distance greater than 60 meters?':
		'O trabalhador se move empurrando e/ou puxando um objeto por uma distância superior a 60 metros?',
	'Are objects (bags, boxes, furniture, machines, etc.) pushed or pulled cyclically with a force measured with a dynamometer exceeding 34 kg?':
		'Objetos (sacolas, caixas, móveis, máquinas, etc.) são empurrados ou puxados ciclicamente com força medida por dinamômetro superior a 34 kg?',
	'Is an initial effort required to push the rolling object measured with a dynamometer >= 12 kg for men or 10 kg for women?':
		'É necessário um esforço inicial para empurrar o objeto com rodas medido com dinamômetro >= 12 kg para homens ou 10 kg para mulheres?',
	'Is an initial effort required to pull the rolling object measured with a dynamometer >= 10 kg for men or women?':
		'É necessário um esforço inicial para puxar o objeto com rodas medido com dinamômetro >= 10 kg para homens ou mulheres?',
	'Is the rolling object pushed and/or pulled with difficulty (the sliding surface is uneven, there are ramps to go up or down, there are breaks or obstacles in the path, wheels in poor condition, poorly designed handle, etc.)?':
		'O objeto com rodas é empurrado e/ou puxado com dificuldade (a superfície de deslizamento é irregular, há rampas para subir ou descer, há quebras ou obstáculos no caminho, rodas em más condições, cabo mal projetado, etc.)?',
	'Can the rolling object not be pushed and/or pulled with both hands, and if allowed, is the hand support at an uncomfortable height (above the chest or below the waist)?':
		'O objeto com rodas não pode ser empurrado e/ou puxado com ambas as mãos, e se permitido, o apoio das mãos está em altura desconfortável (acima do peito ou abaixo da cintura)?',
	'In the act of pushing and/or pulling, is the initial effort required significantly maintained once the object is in motion (is there wheel jamming, jerking, or lack of uniform sliding)?':
		'No ato de empurrar e/ou puxar, o esforço inicial necessário é mantido significativamente uma vez que o objeto está em movimento (há travamento das rodas, solavancos ou falta de deslizamento uniforme)?',
	'Does the worker push or pull the rolling object using only one hand?':
		'O trabalhador empurra ou puxa o objeto com rodas usando apenas uma mão?',
	'Error creating report': 'Erro ao criar relatório',
	'Error updating report': 'Erro ao atualizar relatório',
	'Manual load transport': 'Transporte manual de cargas',
	'Manually transporting loads weighing more than 2 kg and up to 25 kg?':
		'Transportando manualmente cargas com peso superior a 2 kg e até 25 kg?',
	'Does the worker move while manually holding the load over a distance greater than 1 meter?':
		'O trabalhador se movimenta segurando manualmente a carga por uma distância superior a 1 metro?',
	'Is it performed daily in a cyclical manner? (if sporadic, indicate "No")':
		'É realizado diariamente de forma cíclica? (se esporádico, indicar "Não")',
	'Is manual transport of loads over a distance greater than 20 meters?':
		'O transporte manual de cargas é realizado por uma distância superior a 20 metros?',
	'Is manual transport of loads weighing more than 25 kg?':
		'O transporte manual de cargas com peso superior a 25 kg?',
	'Under normal lifting conditions, does the worker transport the load between 1 and 10 meters with a cumulative mass (the product of mass by frequency) greater than 10,000 kg during the usual workday?':
		'Em condições normais de levantamento, o trabalhador transporta a carga entre 1 e 10 metros com uma massa cumulativa (o produto da massa pela frequência) superior a 10.000 kg durante a jornada de trabalho habitual?',
	'Under normal lifting conditions, does the worker transport the load between 10 and 20 meters with a cumulative mass (the product of mass by frequency) greater than 6,000 kg during the usual workday?':
		'Em condições normais de levantamento, o trabalhador transporta a carga entre 10 e 20 metros com uma massa cumulativa (o produto da massa pela frequência) superior a 6.000 kg durante a jornada de trabalho habitual?',
	'Standing position': 'Posição em pé',
	'Does the job require standing for 2 consecutive hours or more without the possibility of sitting?':
		'O trabalho exige permanecer em pé por 2 horas consecutivas ou mais sem a possibilidade de sentar?',
	'Does the job involve standing for 3 consecutive hours or more without the possibility of sitting and with limited mobility (walking no more than 100 meters/hour)?':
		'O trabalho envolve permanecer em pé por 3 horas consecutivas ou mais sem a possibilidade de sentar e com mobilidade limitada (caminhando não mais que 100 metros/hora)?',
	'Does the job involve standing for 2 consecutive hours or more without the possibility of sitting or moving, or with limited mobility, lifting and/or transporting loads > 2 kg?':
		'O trabalho envolve permanecer em pé por 2 horas consecutivas ou mais sem a possibilidade de sentar ou se mover, ou com mobilidade limitada, levantando e/ou transportando cargas > 2 kg?',
	'Are tasks performed with prolonged standing in environments where temperature and humidity exceed legally permissible limits and require physical activity?':
		'As tarefas são realizadas com permanência prolongada em pé em ambientes onde a temperatura e umidade excedem os limites legalmente permitidos e exigem atividade física?',
	'Repetitive movements of upper limbs': 'Movimentos repetitivos de membros superiores',
	'Performing daily, one or more tasks using the upper limbs for 4 or more hours during the regular workday in a cyclical manner (continuously or alternately)?':
		'Realizando diariamente, uma ou mais tarefas utilizando os membros superiores por 4 ou mais horas durante a jornada de trabalho regular de forma cíclica (contínua ou alternadamente)?',
	'Are the upper limbs active for more than 40% of the total work cycle time?':
		'Os membros superiores ficam ativos por mais de 40% do tempo total do ciclo de trabalho?',
	'Is there an effort greater than moderate at 3 on the Borg Scale, for more than 6 seconds and more than once per minute?':
		'Há um esforço maior que moderado no nível 3 da Escala de Borg, por mais de 6 segundos e mais de uma vez por minuto?',
	'Is there an effort greater than 7 on the Borg scale?': 'Há um esforço maior que 7 na escala de Borg?',
	'Does the worker show any early manifestations of the diseases mentioned in Article 1 of this Resolution?':
		'O trabalhador apresenta alguma manifestação precoce das doenças mencionadas no Artigo 1 desta Resolução?',
	'Adopting forced postures regularly during the workday, with or without applying force. (Occasional postures should not be considered)?':
		'Adotando posturas forçadas regularmente durante a jornada de trabalho, com ou sem aplicação de força. (Posturas ocasionais não devem ser consideradas)?',
	'Is the neck in extension, flexion, lateralization, and/or rotation?':
		'O pescoço está em extensão, flexão, lateralização e/ou rotação?',
	'Are the arms above shoulder level or with movements of supination, pronation, or rotation?':
		'Os braços estão acima do nível dos ombros ou com movimentos de supinação, pronação ou rotação?',
	'Are the wrists and hands in flexion, extension, ulnar or radial deviation?':
		'Os punhos e mãos estão em flexão, extensão, desvio ulnar ou radial?',
	'Is the waist in flexion, extension, lateralization, and/or rotation?':
		'A cintura está em flexão, extensão, lateralização e/ou rotação?',
	'Are the lower limbs working in a kneeling or squatting position?':
		'Os membros inferiores trabalham em posição ajoelhada ou agachada?',
	'Working with tools that produce vibrations (jackhammer, drill, screwdrivers, polishers, grinders, others)?':
		'Trabalhando com ferramentas que produzem vibrações (martelo pneumático, furadeira, chaves de fenda, polidores, esmerilhadeiras, outros)?',
	'Holding pieces with hands while they are being machined?':
		'Segurando peças com as mãos enquanto estão sendo usinadas?',
	'Holding levers, steering wheels, etc. that transmit vibrations?':
		'Segurando alavancas, volantes, etc. que transmitem vibrações?',
	'Does the vibration value exceed the limits established in Table I, in the section corresponding to Hand-Arm Vibration, Annex V, Resolution MTEySS N° 295/03?':
		'O valor de vibração excede os limites estabelecidos na Tabela I, na seção correspondente à Vibração Mão-Braço, Anexo V, Resolução MTEySS N° 295/03?',
	'Are uncomfortable temperatures perceived in the workplace for performing tasks?':
		'Temperaturas desconfortáveis são percebidas no local de trabalho para a execução de tarefas?',
	'Is any part of the body resting under pressure against a tool, work surface, machine tool, or parts and materials?':
		'Alguma parte do corpo está apoiada sob pressão contra uma ferramenta, superfície de trabalho, máquina-ferramenta ou peças e materiais?',
	'Does the worker rest their wrist, forearm, armpit, thigh, or another body segment on a sharp or edged surface?':
		'O trabalhador apoia o punho, antebraço, axila, coxa ou outro segmento corporal em uma superfície afiada ou com bordas?',
	'Does the worker use hand tools or manipulate parts that press on their fingers and/or dominant hand palm?':
		'O trabalhador usa ferramentas manuais ou manipula peças que pressionam os dedos e/ou a palma da mão dominante?',
	'Does the worker perform percussion movements on parts or tools?':
		'O trabalhador realiza movimentos de percussão em peças ou ferramentas?',
	'Borg Scale': 'Escala de Borg',
	'No effort': 'Nenhum esforço',
	'Very low effort, barely perceptible': 'Esforço muito baixo, apenas perceptível',
	'Very weak effort': 'Esforço muito fraco',
	'Weak / light effort': 'Esforço fraco / leve',
	'Moderate / regular effort': 'Esforço moderado / regular',
	'Somewhat strong effort': 'Esforço um pouco forte',
	'Strong effort': 'Esforço forte',
	'Very strong effort': 'Esforço muito forte',
	'Extremely strong effort': 'Esforço extremamente forte',
	'The level of risk is tolerable, so no measures are required. However, a preventive evaluation can be conducted on the next page if requested by any of the responsible parties.':
		'O nível de risco é tolerável, portanto nenhuma medida é necessária. No entanto, uma avaliação preventiva pode ser conduzida na próxima página se solicitada por qualquer uma das partes responsáveis.',
	'The risk level is not tolerable; therefore, a risk evaluation by a professional knowledgeable in ergonomics is required. Proceed to the next page to conduct the evaluation':
		'O nível de risco não é tolerável; portanto, é necessária uma avaliação de risco por um profissional conhecedor em ergonomia. Prossiga para a próxima página para conduzir a avaliação.',
	Step: 'Passo',
	'Select an evaluator': 'Selecione um avaliador',
	'Select an employer': 'Selecione um contratante',
	'Please enter an evaluator': 'Por favor insira um avaliador',
	'Please enter an employer': 'Por favor insira um contratante',
	'Select activity': 'Selecione uma atividade',
	'Enter activity name': 'Insira o nome da atividade',
	'Are you sure you want to delete the action plan': 'Tem certeza que deseja excluir o plano de ação?',
	'Please develop action plans for all not tolerable and moderate risks before proceeding':
		'Por favor, desenvolva planos de ação para todos os riscos não toleráveis e moderados antes de prosseguir',
	'Answer the previous questions, create and review the action plans (corrective and preventive measures)':
		'Responda às questões anteriores, crie e revise os planos de ação (medidas corretivas e preventivas)',
	'General preventive measures': 'Medidas preventivas gerais',
	'The worker(s), supervisor(s), engineer(s), and management related to the workstation have been informed about the risk associated with the task of developing MSD':
		'O(s) trabalhador(es), supervisor(es), engenheiro(s), e gerente(s) relacionados ao posto de trabalho foram informados sobre o risco associado à tarefa de desenvolver TME',
	'The worker(s) and supervisor(s) related to the workstation have been trained on identifying symptoms related to the development of MSD':
		'O(s) trabalhador(es) e supervisor(es) relacionados ao posto de trabalho foram treinados para identificar sintomas relacionados ao desenvolvimento de TME',
	'The worker(s) and supervisor(s) related to the workstation have been trained on the measures and/or procedures to prevent the development of MSD':
		'O(s) trabalhador(es) e supervisor(es) relacionados ao posto de trabalho foram treinados para identificar sintomas relacionados ao desenvolvimento de TME',
	'Specific corrective and preventive measures': 'Medidas corretivas e preventivas específicas',
	'Action plans must be developed for risks classified as moderate and not tolerable.':
		'Os planos de ação devem ser desenvolvidos para riscos classificados como moderados e não toleráveis.',
	'View previous evaluation': 'Ver avaliação anterior',
	'General Preventive Measures': 'Medidas Preventivas Gerais',
	'Specific administrative corrective and preventive measure':
		'Medida corretiva e preventiva específica administrativa',
	'Specific engineering corrective and preventive measure': 'Medida corretiva e preventiva específica de engenharia',
	'Identification of risk factors': 'Identificação de fatores de risco',
	'Total exposure time': 'Tempo de exposição total',
	'Risk level': 'Nível de risco',
	'Follow-up on preventive measures': 'Acompanhamento de medidas preventivas',
	'Implementation Date (Engineering Measure)': 'Data de implementação (Medida de engenharia)',
	'Implementation Date (Administrative Measure)': 'Data de implementação (Medida administrativa)',
	'Due date': 'Data de vencimento',
	'Lifting and lowering': 'Levantamento e abaixamento',
	'Not tolerable risk': 'Risco não tolerável',
	'Evaluation completed': 'Avaliação concluída',
	'Please identify the tasks and evaluate them before continuing':
		'Por favor, identifique as tarefas e avalie-as antes de continuar',
	'This field is required': 'Este campo é requerido',
	'Enter your observations': 'Insira suas observações',
	'Please select one or more videos before continuing': 'Por favor, selecione um ou mais vídeos antes de continuar',
	'Insert a title': 'Inserir um título',
	'Select priority': 'Selecionar prioridade',
	'Please select a response': 'Por favor, selecione uma resposta',
	'Date of initial version': 'Data da versão inicial',
	'Name of evaluation': 'Nome da avaliação',
	'Location of the symptom': 'Localização do sintoma',
	'Activity (task)': 'Atividade (tarefa)',
	'Work position': 'Posto de trabalho',
	'Task Name': 'Nome da tarefa',
	'Select responsible': 'Selecionar responsável',
	'Task Name is required': 'O nome da tarefa é requerido',
	'Attach file': 'Anexar arquivo',
	'Edit action plan': 'Editar plano de ação',
	'Hand - arm vibration': 'Vibração mão - braço',
	'Name of worker(s)': 'Nome do(s) trabalhador(es)',
	'Use previous files': 'Usar arquivos anteriores',
	filesQuantity: 'Por favor, selecione {{qty}} arquivos antes de continuar',
	'Review not started': 'Revisão não iniciada',
	'Review completed': 'Revisão finalizada',
	Evaluated: 'Avaliado',
	'Is the result of using the Fanger Comfort Curve outside the comfort zone?':
		'O resultado do uso da Curva de Conforto de Fanger está fora da zona de conforto?',
	'No data': 'Nenhum dado',
	Finished: 'Finalizado',
	'Not finished': 'Não finalizado',
	'Does the vibration value exceed the limits established in Table I, in the section corresponding to Hand-Arm Vibration, Annex V, Resolution MTEySS N° 295/03':
		'O valor de vibração excede os limites estabelecidos na Tabela I, na seção correspondente à Vibração Mão-Braço, Anexo V, Resolução MTEySS N° 295/03',
	'Risk Factor / Version': 'Fator de risco',
	'Lifting loads': 'Levantamento de cargas',
	ErgonomicVibrationTools886: 'Classificação de risco por vibração definida na norma {{tool_name}}:',
	'Fill out the complete JDS-D86': 'Preencha o JDS-D86 completo',
	'Edit on JDS-D86': 'Editar no JDS-D86',
	'Invalid workers number':
		'Número de trabalhadores inválido, o número de trabalhadores deve ser igual ao número de trabalhadores selecionados.',
	'Initial version': 'Versão inicial',
	'Fill tool': 'Preencher a ferramenta',
	'Fill tool on JDS-D86': 'Preencher no JDS-D86',
	EvaluationErgonomicRisk886:
		' A ferramenta {{ergonomic_tool_name}} pode ser utilizada como suporte técnico na avaliação.',
	'Backup tool:': 'Ferramenta de backup:',
	'Vibration risk classification (JDS-D86)': 'Classificação de risco por vibração (JDS-D86)',
	'You must consolidate the last review before creating a new version':
		'Você deve consolidar a última revisão antes de criar uma nova versão',
	'You must consolidate the last review before downloading the PDF':
		'Você deve consolidar a última revisão antes de baixar o PDF',
	'Error: Report file not found': 'Erro: Arquivo do relatório não encontrado',
	'PDF downloaded successfully': 'PDF baixado com sucesso',
	'Error downloading PDF. Please try again.': 'Erro ao baixar PDF. Tente novamente.',
	'Download PDF Report': 'Baixar Relatório PDF',
	'Action plans must be developed obligatorily for risks classified as moderate and not tolerable.':
		'Os planos de ação devem ser desenvolvidos para riscos classificados como moderados e não toleráveis.',
	'Technical support': 'Suporte técnico',
	'Deconsolidate the report': 'Desconsolidar o relatório',
	'Report consolidated successfully': 'Relatório consolidado com sucesso',
	'Report desconsolidated successfully': 'Relatório desconsolidado com sucesso',
	'Worker created successfully': 'Trabalhador criado com sucesso',
	'Employer created successfully': 'Contratante criado com sucesso',
	'Overview of risk factors': 'Visão geral dos fatores de risco',

	// ROSA - Rapid Office Strain Assessment
	'Generate action plan': 'Gerar plano de ação',
	Section: 'Seção',
	'Create actions to address the problems encountered': 'Crie ações para resolver os problemas encontrados',
	'Create actions to address the problems encountered.': 'Crie ações para resolver os problemas encontrados.',
	'Pre-set specific characteristics': 'Pre-definir características específicas',
	Chair: 'Cadeira',
	'Monitor and Phone': 'Monitor e Telefone',
	'Mouse and Keyboard': 'Mouse e Teclado',
	'Peripherals and Monitor': 'Periféricos e Monitor',
	'Final score': 'Pontuação final',
	'Analysis date': 'Data de análise',
	'Enter the date of analysis': 'Insira a data de análise',
	'Please enter a report name': 'Por favor, insira um nome de relatório',
	'Enter the data related to the new analysis below': 'Insira os dados relacionados ao novo análise abaixo',
	'Other elements': 'Outros elementos',
	'New element': 'Novo elemento',
	Priority: 'Prioridade',
	Provide: 'Fornecer',
	'Failed to create elements': 'Falha ao criar elementos',
	'Required elements': 'Elementos necessários',
	'Prioritize the required elements': 'Priorize os elementos necessários',
	Maintenance: 'Manutenção',
	'Overall results': 'Resultados gerais',
	'Upload image': 'Upload de imagem',
	'Upload images of the activity being evaluated': 'Upload de imagens da atividade sendo avaliada',
	Image: 'Imagem',
	Images: 'Imagens',
	'Do you really want to delete this image?': 'Você realmente deseja excluir esta imagem?',
	'Add file': 'Adicionar arquivo',
	'General information': 'Informações gerais',

	CHANGE: 'MUDAR',
	MAINTENANCE: 'MANUTENÇÃO',
	PROVIDE: 'FORNECER',
	Change: 'Mudar',

	'Knees at 90°': 'Pernas em 90°',
	'Very low - Knee angle < 90°': 'Muito baixo - Ângulo do joelho < 90°',
	'Very high - Knee angle > 90º': 'Muito alto - Ângulo do joelho > 90º',
	'No foot contact with the floor': 'Sem contato de pé com o chão',
	'Insufficient space at the bottom of the desk - No leg mobility':
		'Espaço insuficiente no fundo da mesa - Sem mobilidade das pernas',
	'Not adjustable': 'Não ajustável',
	'Approximately 8 centimeters of space between the knee and the edge of the seat or chair':
		'Aproximadamente 8 centímetros de espaço entre o joelho e a borda do assento ou cadeira',
	'Very long - Less than 8 centimeters of space': 'Muito longo - Menos de 8 centímetros de espaço',
	'Very short - More than 8 centimeters spacing': 'Muito curto - Mais de 8 centímetros de espaço',
	'Elbows supported in line with the shoulder - Shoulders relaxed':
		'Cotovelos apoiados na linha com o ombro - Ombros relaxados',
	'Very high (Shoulders shrugged) / Low (Unsupported arms)':
		'Muito alto (Ombros encolhidos) / Baixo (braços não apoiados)',
	'Very hard or damaged surface': 'Superfície muito dura ou danificada',
	'Very wide': 'Muito ampla',
	'Adequate lumbar support - Chair reclines between 95° and 110º':
		'Suporte lombar adequado - Cadeira reclina entre 95° e 110º',
	'No lumbar support or lumbar support not positioned on the lower back':
		'Sem suporte lombar ou suporte lombar não posicionado no fundo',
	'Backrest angle too far back (greater than 110º) or angle too far forward (less than 95º)':
		'Ângulo do encosto muito longe de trás (maior que 110º) ou ângulo muito longe para frente (menor que 95º)',
	'Without backrest or lumbar support (e.g. on a stool or leaning forward)':
		'Sem encosto ou suporte lombar (ex: em uma cadeira ou agachar para frente)',
	'Very high work surface (shrugged shoulders)': 'Superfície de trabalho muito alta (ombros encolhidos)',
	'Backless back - Non-adjustable': 'Encosto de trás - Não ajustável',
	'Length or distance measured with the arm (40 to 75 cms) / Screen at eye level':
		'Medida de comprimento ou distância medida com o braço (40 a 75 cms) / Tela no nível do olho',
	'Very low (Below 30º)': 'Muito baixo (Abaixo de 30º)',
	'Far away': 'Muito longe',
	'Very high (Neck in extension)': 'Muito alto (Pescoço em extensão)',
	'Neck rotated more than 30º': 'Pescoço rotacionado mais de 30º',
	'Glare on the screen': 'Brilho na tela',
	'No use of lecterns or document holders, if required':
		'Sem uso de púlpitos ou guardadores de documentos, se necessário',
	'Headphones with microphones, one hand on the phone and neutral neck posture':
		'Microfones com fones, uma mão no telefone e postura de pescoço neutro',
	'Too far for the range (More than 30cms separation)': 'Muito distante para a faixa (Mais de 30cms de separação)',
	'Holding the phone with the neck and shoulder': 'Segurar o telefone com o pescoço e o ombro',
	'No hands-free option': 'Sem opção de não utilizar as mãos',
	'Mouse in line with shoulder': 'Mouse na linha com o ombro',
	'Reaching for the mouse / Arm in abduction': 'Alcançar o mouse / Braço em abdução',
	'Mouse and keyboard on surfaces of different levels': 'Mouse e teclado em superfícies de diferentes níveis',
	'Gripper grip on the mouse': 'Aperto de garra no mouse',
	'Wrist rest in front of the mouse': 'Descanso do pulso na frente do mouse',
	'Wrists straight - Shoulders relaxed': 'Pulsos diretos - Ombros relaxados',
	'Wrists extended - Keyboard at positive angle ( > 15º Extension of wrists)':
		'Pulsos estendidos - Teclado no ângulo positivo ( > 15º Extensão dos pulsos)',
	'Deviation of the wrists during transcription or typing': 'Desvio dos pulsos durante a transcrição ou digitação',
	'Keyboard too high, shoulders shrugged': 'Teclado muito alto, ombros encolhidos',
	'Reaching for items or objects overhead': 'Alcançar itens ou objetos sobre o cabo',
	'Non-adjustable keyboard platform': 'Plataforma de teclado não ajustável',

	'Element deleted successfully': 'Elemento excluído com sucesso',
	'Image deleted successfully': 'Imagem excluída com sucesso',
	'Rosa report updated successfully!': 'Relatório Rosa atualizado com sucesso!',
	'Fail to save the comments': 'Falha ao salvar os comentários',
	'Error save duration!': 'Erro ao salvar a duração',
	'Error save element!': 'Erro ao salvar o elemento',
	'Image updated successfully': 'Imagem atualizada com sucesso',
	'Image Upload': 'Upload de imagem',
	'Upload images of the evaluated activities': 'Carregue imagens das atividades avaliadas',

	'Select options for category': 'Selecione opções para a categoria',
	'Select one element of the first line of subcategory': 'Selecione um elemento da primeira linha da subcategoria',
	chair: 'cadeira',

	'Chair height': 'Altura da cadeira',
	'Seat depth': 'Profundidade do assento',
	Armrests: 'Apoios de braço',
	'Seat backrest': 'Encosto do assento',
	Mouse: 'Mouse',
	Keyboard: 'Teclado',
	Monitor: 'Monitor',
	Phone: 'Telefone',

	'Final score ROSA': 'Pontuação final ROSA',
	'Scoring by section': 'Pontuação por seção',

	'Chair Height': 'Altura da cadeira',
	'Seat Depth': 'Profundidade do assento',
	'Seat Backrest': 'Encosto do assento',

	Footrest: 'Encostos de pé',
	'Fixed monitor base': 'Base de monitor fixa',
	'Portable monitor stand': 'Apoio de monitor portátil',
	'Channeling cables': 'Canaletas',
	Headband: 'Faixa de cabeça',
	'Priority level of the demand, being 1 medium priority and 2 high priority.':
		'Nível de prioridade da demanda, sendo 1 de prioridade média e 2 de prioridade alta.',

	'Low priority': 'Baixa prioridade',
	'Medium priority': 'Média prioridade',
	'High priority': 'Alta prioridade',
	'Select a priority': 'Selecione uma prioridade',
	'Administrative activities analysis': 'Análise de atividades administrativas',
	'Do you really want to delete this element?': 'Você realmente deseja excluir este elemento?',

	'Select the items you want to present in your document':
		'Selecione os itens que você deseja apresentar no seu documento',
	'Filling details': 'Preenchimento de detalhes',
	'Image description': 'Descrição da imagem',
	'Generate document': 'Gerar documento',
	Filename: 'Nome do arquivo',

	'Task already exist': 'Tarefa já existe',
	'Task not created': 'Tarefa não foi criada',

	'The ROSA image is meant for workstations rather than employees.':
		'A imagem do ROSA é destinada a postos de trabalho e não a empregados.',

	'Action plan generated': 'Plano de ação gerado',
	'Edit action plan': 'Editar plano de ação',
	'Delete action plan': 'Excluir plano de ação',
	'Are you sure you want to delete this action plan?': 'Tem certeza que deseja excluir este plano de ação?',
	'New action plan': 'Novo plano de ação',
	'Add a new task': 'Adicionar uma nova tarefa',
	Tasks: 'Tarefas',
	Responsible: 'Responsável',
	Deadline: 'Prazo',
	'Select action': 'Selecione a ação',
	'Select priority': 'Selecione a prioridade',
	Action: 'Ação',
	'Successfully consolidated analysis': 'Análise consolidada com sucesso',
	'Successfully deconsolidated analysis': 'Análise desconsolidada com sucesso',
	'Consolidate analysis': 'Consolidar análise',
	Deconsolidate: 'Desconsolidar',
	'Download PDF': 'Baixar PDF',
	Duration: 'Duração',
	'Seat depth': 'Profundidade do assento',
	'Seat pan depth': 'Profundidade do assento',
	'Section A': 'Seção A',
	'Section B': 'Seção B',
	'Section C': 'Seção C',
	'Section D': 'Seção D',
	'Seat backrest': 'Encosto do assento',
	Back: 'Voltar',
	Next: 'Próximo',
	Close: 'Fechar',
	Results: 'Resultados',
	Line: 'Linha',
	'Select a line': 'Selecione uma linha',
	'Task not created': 'Tarefa não foi criada',
	'Category value not found': 'Valor da categoria não encontrado',
	'Failed to update frame': 'Falha ao atualizar frame',
	'Frames not created': 'Falha ao criar frames',
	'Frame not found': 'Frame não encontrado',
	'Frame not updated': 'Frame não atualizado',
	'Frame updated successfully': 'Frame atualizado com sucesso',
	'There is frames not evaluated': 'Existem frames não avaliados',

	// OWAS
	'Highest score': 'Pontuação mais alta',
	'Analysis date': 'Data de análise',
	'Activity description': 'Descrição da atividade',
	productivity: 'produtividade',
	'Number of exposed': 'Número de expostos',
	'Capture interval': 'Intervalo de captura',
	'in seconds': 'em segundos',
	'Enter the report name': 'Insira o nome do relatório',
	'Enter the sector': 'Insira o setor',
	'Enter the activity': 'Insira a atividade',
	'Enter the evaluator': 'Insira o avaliador',
	'Enter the analysis date': 'Insira a data de análise',
	'Enter the activity description': 'Insira a descrição da atividade',
	'Number of exposed must be greater than 0': 'Número de expostos deve ser maior que 0',
	'Enter the capture interval': 'Insira o intervalo de captura',
	'Set the time interval, in seconds, for capturing video frames.':
		'Defina o intervalo de tempo, em segundos, para a captura de quadros de vídeo.',

	'Report deconsolidated successfully': 'Relatório desconsolidado com sucesso',
	'Report consolidated but PDF not generated': 'Relatório consolidado, mas PDF não gerado',

	'Description of the activity': 'Descrição da atividade',
	'Overall task risk': 'Risco geral da atividade',
	Explanation: 'Explicação',
	'No action required': 'Nenhuma ação necessária',
	'Normal and natural posture without harmful effects on the musculoskeletal system':
		'Postura normal e natural sem efeitos prejudiciais ao sistema musculoesquelético',
	'Corrective actions required in the near future': 'Ações corretivas necessárias em um futuro próximo',
	'Posture with the possibility of causing damage to the musculoskeletal system':
		'Postura com possibilidade de causar efeitos prejudiciais ao sistema musculoesquelético',
	'Corrective actions are required as soon as possible': 'Ações corretivas são necessárias o mais rápido possível',
	'Posture with harmful effects on the musculoskeletal system':
		'Postura com efeitos prejudiciais ao sistema musculoesquelético',
	'Corrective actions need to be taken immediately': 'Ações corretivas precisam ser tomadas imediatamente',
	'The load caused by this posture has extremely harmful effects on the musculoskeletal system':
		'A carga causada por essa postura tem efeitos extremamente prejudiciais ao sistema musculoesquelético',
	'Tasks with the most serious risks': 'Tarefas com os riscos mais graves',
	'Risk of the tasks': 'Risco das tarefas',
	'Manual tools': 'Ferramentas manuais',
	'Category 1': 'Categoria 1',
	'Category 2': 'Categoria 2',
	'Category 3': 'Categoria 3',
	'Category 4': 'Categoria 4',
	'Risk by segment and exposure time': 'Risco por segmento e tempo de exposição',
	'Upper limbs': 'Membros superiores',
	'Lower limbs': 'Membros inferiores',
	'Computer vision identified the positions of each task, review and add the required information':
		'A visão computacional identificou as posições de cada tarefa, revisou e adicionou as informações necessárias',
	'Search for a task': 'Pesquisar uma tarefa',
	'All tasks': 'Todas as tarefas',
	'Tasks not analyzed': 'Tarefas não analisadas',
	'Task name': 'Nome da tarefa',
	'Overall risk of the task': 'Risco geral da tarefa',
	'The colors shown do not refer to the OWAS tool.': 'As cores mostradas não se referem à ferramenta OWAS.',
	'Computer vision does not detect back twisting.': 'A visão computacional não detecta a torção das costas.',
	Straight: 'Ereta',
	Bent: 'Inclinada',
	'Straight and rotated': 'Ereta e torcida',
	'Bent and rotated': 'Inclinada e torcida',
	'Two arms down': 'Dois braços para baixo',
	'One arm up': 'Um braço para cima',
	'Two arms up': 'Dois braços para cima',
	Sitting: 'Sentado',
	'Standing on two straight legs': 'De pé com ambas as pernas esticadas',
	'Standing on one straight legs': 'De pé com o peso de uma das pernas esticadas',
	'Standing or squatting on two flexed legs': 'De pé ou agachado com ambos os joelhos flexionados',
	'Standing or squatting on one bent leg': 'De pé ou agachado com um dos os joelhos flexionados',
	Walking: 'Andando',
	'Task risk': 'Risco de tarefa',
	'Less than 10kg': 'Menos de 10 quilos',
	'Between 10kg and 20kg': 'Entre 10 e 20 quilos',
	'More than 20kg': 'Mais de 20 quilos',
	'Select the task name': 'Selecione o nome da tarefa',
	'Enter the manual tools': 'Insira as ferramentas manuais',
	'Failed to create a new task': 'Falha ao criar uma nova tarefa',
	'Capture interval should be less than the file duration':
		'O intervalo de captura deve ser menor que a duração do vídeo',
	'5 and 6': '5 e 6',
	'7, 8 and 9': '7, 8 e 9',
	'Due date': 'Data de vencimento',
	'Lifting and transportation': 'Levantamento e transporte',
	'Load transport in pairs?': 'Transporte de carga em pares?',
	'Workday duration': 'Duração do dia de trabalho',
	'Activity duration': 'Duração da atividade',
	'Select an activity': 'Selecione uma atividade',
	'Please select an activity': 'Por favor, selecione uma atividade',
	'Collect date': 'Data de coleta',
	'The field requires an answer': 'O campo requer uma resposta',
	'To proceed, please fill in all required information':
		'Para prosseguir, por favor, preencha todas as informações obrigatórias',
	'Women:': 'Mulheres:',
	'Men:': 'Homens:',
	'Start/End': 'Início/Término',
	'End/Start': 'Término/Início',
	'KIM LHC: Manual lifting, holding, and carrying of loads':
		'KIM LHC: Levantamento, sustentação e transporte manual de cagas',
	'Work Organization': 'Organização do trabalho',
	'Work Organization': 'Organização do trabalho',
	'Work organization': 'Organização do trabalho',
	'Partial result': 'Resultado parcial',
	Unfavorable: 'Desfavorável',
	'Frequent variation of the physical load situation due to other activities (including other types of physical load) / without a rigid sequence of heavy physical loads within a single type of physical load during a single working day':
		'Variação frequente da situação de carga física devido a outras atividades (incluindo outros tipos de carga física) / sem uma sequência rígida de cargas físicas elevadas dentro de um mesmo tipo de carga física durante um único dia de trabalho',
	'Rare variation of the physical load situation due to other activities (including other types of physical load) / occasional sequence of heavy physical loads within a single type of physical load during a single working day':
		'Variação rara da situação de carga física devido a outras atividades (incluindo outros tipos de carga física) / sequência ocasional de cargas físicas elevadas dentro de um mesmo tipo de carga física durante um único dia de trabalho',
	'No or almost no variation of the physical load situation due to other activities (including other types of physical load) / frequent sequence of heavy physical loads within a single type of physical load during a single working day, with simultaneous load peaks':
		'Nenhuma ou quase nenhuma variação da situação de carga física devido a outras atividades (incluindo outros tipos de carga física) / sequência frequente de cargas físicas elevadas dentro de um mesmo tipo de carga física durante um único dia de trabalho, com picos de carga simultâneos',
	Result: 'Resultado',
	Results: 'Resultados',
	'KIM LHC: Manual Lifting, Holding and Carrying': 'KIM LHC: Levantamento, sustentação e transporte manual de cargas',
	'General information': 'Informações gerais',
	'Error loading result': 'Erro ao carregar resultado',
	'Unknown error': 'Erro desconhecido',
	'No data available': 'Nenhum dado disponível',
	'CLIENT LOGO': 'LOGO CLIENTE',
	Yes: 'Sim',
	No: 'Não',
	Comment: 'Comentário',
	'Add your comments here': 'Adicione seus comentários aqui',
	'Transporting cargo in pairs': 'Transporte de carga em pares',
	'Inclined weight': 'Peso inclinado',
	Posture: 'Postura',
	Frequency: 'Frequência',
	'Body posture': 'Postura corporal',
	'Work organization / time distribution': 'Organização do trabalho / distribuição temporal',
	'Collection date:': 'Data de coleta:',
	'Report date:': 'Data do relatório:',
	'Transporting cargo in pairs:': 'Transporte de carga em pares:',
	'Work day duration:': 'Duração do dia de trabalho:',
	'Activity duration:': 'Duração da atividade:',
	minutes: 'minutos',
	'CLIENT LOGO': 'LOGO CLIENTE',
	'Client Logo': 'Logo do cliente',
	'Score for men': 'Pontuação para homens',
	'Score for women': 'Pontuação para mulheres',
	'Probability of physical overload': 'Probabilidade de sobrecarga física',
	'Possible health consequences': 'Possíveis consequências à saúde',
	Measures: 'Medidas',
	'Low risk': 'Risco baixo',
	'Slightly elevated risk': 'Risco ligeiramente elevado',
	'Substantially elevated risk': 'Risco substancialmente elevado',
	'High risk': 'Risco alto',
	'Score by category': 'Pontuação por categoria',
	'Close all': 'Fechar tudo',
	'Score:': 'Pontuação:',
	'Score men:': 'Pontuação homem:',
	'Score women:': 'Pontuação mulher:',
	Frequency: 'Frequência',
	'Load weight': 'Peso da carga',
	'Cargo handling conditions': 'Condições de manuseio de carga',
	'Body posture': 'Postura corporal',
	'Unfavorable working conditions': 'Condições de trabalho desfavoráveis',
	'Work organization / time distribution': 'Organização do trabalho / distribuição temporal',
	'Up to 300 times per activity and work shift': 'Até 300 vezes por atividade e turno de trabalho',
	'Between 300 and 1500 times per activity and work shift':
		'Entre 300 e 1500 vezes por atividade e turno de trabalho',
	'More than 1500 times per activity and work shift': 'Mais de 1500 vezes por atividade e turno de trabalho',
	'Effective load:': 'Peso efetivo:',
	'The effective load weight corresponds to the physical effort actually exerted. When tilting a box, 50% of the weight is applied when transporting in pairs, 60% affects each person':
		'*O peso efetivo da carga corresponde ao esforço físico realmente exercido. Ao inclinar uma caixa, 50% do peso é aplicado ao transportar em duplas, 60% afeta cada pessoa',
	'Transport in pairs': 'Transporte em duplas',
	'The load can be handled close to the body': 'A carga pode ser manuseada próxima ao corpo',
	'The load cannot be handled close to the body': 'A carga não pode ser manuseada próxima ao corpo',
	'The load is temporarily handled with one hand and/or asymmetrically, with unequal weight distribution between both hands':
		'A carga é manuseada temporariamente com uma das mãos e/ou de forma assimétrica, com distribuição desigual do peso entre as duas mãos',
	'Start/End': 'Início/Término',
	'End/Start': 'Término/Início',
	'Frequent or constant twisting and/or lateral bending of the trunk identifiable':
		'Torção e/ou inclinação lateral frequente ou constante do tronco identificável',
	'Load center and/or hands frequently or constantly away from the body':
		'Centro de carga e/ou mãos frequentemente ou constantemente afastados do corpo',
	'Arms frequently or constantly elevated, with hands between elbow and shoulder level':
		'Braços frequentemente ou constantemente elevados, com as mãos entre o nível do cotovelo e do ombro',
	'Hands frequently or constantly above shoulder height':
		'Mãos frequentemente ou constantemente acima da altura dos ombros',
	'No unfavorable condition marked': 'Nenhuma condição desfavorável marcada',
	'Up to': 'Até',
	'times per activity and work shift': 'vezes por atividade e turno de trabalho',
	'with load inclination': 'com inclinação da carga',
	'transported in pairs': 'transportado em dupla',
	'Effective weight': 'Peso efetivo',
	'The effective weight is the adjusted load weight used in the risk score calculation':
		'O peso efetivo é o peso da carga ajustado utilizado no cálculo da pontuação de risco',
	'No unfavorable conditions reported': 'Não há condições desfavoráveis reportadas',
	'No work organization data available': 'Não há dados de organização do trabalho disponíveis',
	'No additional posture factors reported': 'Não há fatores adicionais de postura reportados',
	'Restricted: Rare variation of the physical load situation due to other activities (including other types of physical load) / occasional sequence of high physical loads within the same type of physical load during a single working day':
		'Restrito: Variação rara da situação de carga física devido a outras atividades (incluindo outros tipos de carga física) / sequência ocasional de cargas físicas elevadas dentro de um mesmo tipo de carga física durante um único dia de trabalho',
	'Significantly restricted: Rare variation of the physical load situation due to other activities (including other types of physical load) and occasional sequence of high physical loads within the same type of physical load during a single working day':
		'Significativamente restrito: Variação rara da situação de carga física devido a outras atividades (incluindo outros tipos de carga física) e sequência ocasional de cargas físicas elevadas dentro de um mesmo tipo de carga física durante um único dia de trabalho',
	'Industrial site': 'Planta industrial',
	'Deadline:': 'Prazo:',
	View: 'Visualizar',
	'Please enter the title': 'Por favor, insira o título',
	'Please select a responsible user': 'Por favor, selecione um responsável',
	'Please select the due date': 'Por favor, selecione o prazo',
	'Action plan priority level': 'Nível de prioridade do plano de ação',
	'Estimated investment range': 'Faixa de investimento estimada',
	'No action plan created': 'Nenhum plano de ação criado',
	of: 'de',
	'Task responsible is required': 'Responsável pela tarefa é obrigatório',
	'Task title is required': 'Título da tarefa é obrigatório',
	'New task': 'Nova tarefa',
	Doing: 'Em andamento',
	Done: 'Concluído',
	Showing: 'Mostrando',
	Risk: 'Risco',
	'Enter the data related to the new analysis below': 'Insira os dados relacionados à nova análise abaixo',
	'Report name is required': 'Nome do relatório é obrigatório',
	'Organization is required': 'Organização é obrigatória',
	'Select an organization': 'Selecione uma organização',
	'Evaluator is required': 'Avaliador é obrigatório',
	'Analysis date is required': 'Data da análise é obrigatória',
	'Create report': 'Criar relatório',
	'Saving...': 'Salvando...',
	'Please select an organization': 'Selecione uma organização',
	Activities: 'Atividades',
	'Select the activities that will compose your EWA': 'Selecione as atividades que irão compor sua AET',
	'All activities': 'Todas as atividades',
	'Selected activities': 'Atividades selecionadas',
	'Evaluate the activities that compose your analysis': 'Avalie as atividades que compõem sua análise',
	'Detail the analysis': 'Detalhe a análise',
	'Analysis exceeds limit number of characters': 'Análise excede o limite de caracteres',
	'Coming soon': 'Em breve',
	'Created by': 'Criado por',
	'Last consolidation by': 'Última consolidação por',
	'Last consolidation date': 'Data da última consolidação',
	'N/A': 'N/A',
	'Detail the conclusion': 'Detalhe a conclusão',
	'Conclusion exceeds limit number of characters': 'Conclusão excede o limite de caracteres',
	'Risk matrix': 'Matriz de risco',
	'Image Upload': 'Upload de imagem',
	'Demand and method': 'Demanda e método',
	'Inform demand and the method used in the evaluation': 'Informe demanda e o método utilizado na avaliação',
	Demand: 'Demanda',
	'Detail the demands of the analysis': 'Detalhe as demandas da análise',
	'Demand exceeds limit number of characters': 'Demanda excede o limite de caracteres',
	'Select the method of the analysis': 'Selecione o método da análise',
	Public: 'Público',
	Custom: 'Personalizado',
	'Detail the method of the analysis': 'Detalhe o método da análise',
	'Method exceeds limit number of characters': 'Método excede o limite de caracteres',
	'Use pre-existing model as basis for new model': 'Use modelo existente como base para um novo modelo',
	'Enter the method name': 'Informe o nome do método',
	'Give a new name for the template': 'Dê um novo nome para o modelo',
	'Do you really want to delete the template': 'Você realmente deseja excluir o modelo',
	'Select the working conditions and job characteristics fields you wish to enter':
		'Selecione os campos de condições de trabalho e características do posto de trabalho que deseja informar',
	'Working Conditions': 'Condições de trabalho',
	'Characteristic information is linked to the activity with the worst risk':
		'A informação de características está vinculada à atividade com pior risco',
	'Working conditions information is linked to the activity with the highest risk':
		'A informação de condições de trabalho está vinculada à atividade com maior risco',
	'Working hours': 'Horas de trabalho',
	'Insert the working hours': 'Insira as horas de trabalho',
	'Insert the working minutes': 'Insira os minutos de trabalho',
	'Simplified description of the performed task': 'Descrição simplificada da tarefa realizada',
	'What level of stress does the worker perceive when carrying out the task?':
		'Qual é o nível de estresse percebido pelo trabalhador ao realizar a tarefa?',
	'Self-assessment of stress level': 'Autoavaliação do nível de estresse',
	'Workers verbalization': 'Verbalização dos trabalhadores',
	'Error creating method': 'Erro ao criar método',
	'Error updating method': 'Erro ao atualizar método',
	'Error deleting method': 'Erro ao excluir método',
	'Kinebot Method': 'Método Kinebot',
	'<p>This EWA was built using the Kinebot platform, which is a system that includes movement assessment using computer vision algorithms for movement evaluations, and allows for the implementation of PEA (Preliminary Ergonomic Assessment) and EWA according to ABNT ISO/TS 20646:2017 standard, covering the following aspects:</p><ul><li>Work schedule and concentration</li><li>Type of work</li><li>Postures and movements</li><li>Influence of workspace and task factors</li><li>Influence of psychosocial factors</li><li>Influence of environmental factors</li><li>Influence of organizational factors</li></ul><br><h3><strong>Demand Analysis</strong></h3><p>Initially, demand analysis was performed where the factors that demanded the need for EWA implementation were observed, as well as the possible causative factors that deserved attention and analysis.</p><br><h3><strong>Selection of Evaluated Aspects</strong></h3><p>After analyzing the demand, the Preliminary Ergonomic Assessments (PEAs) of activities related to this Ergonomic Work Analysis (EWA) were selected. Among all evaluated aspects, those correlated with the EWA demand were also chosen.</p><br><h3><strong>Ergonomic Assessment</strong></h3><p>To map movements and conduct the kinesiological study of postures and movements, the Kinebot platform was used. This computer vision system assists in human movement measurement processes. Using machine learning resources, a branch of artificial intelligence study, Kinebot employs algorithms that allow identifying patterns in data, building models, and performing assessments of postural and movement demands for each activity.</p><p>According to the demand and evaluated aspects, the following ergonomic tools were used:</p><ul><li>Repetitiveness assessment:<ul><li>Revised Strain Index</li></ul></li><li>Postural demands assessment:<ul><li>RULA (Rapid Upper Limb Assessment)</li><li>REBA (Rapid Entire Body Assessment)</li></ul></li><li>Load handling and transport:<ul><li>NIOSH / ISO 11228</li><li>KIM-MHO - Tool handling assessment</li><li>KIM-PP - Push and pull assessment</li><li>Liberty Mutual - Load handling assessment</li></ul></li></ul><br><h3><strong>Data Collection</strong></h3><p>Data were collected during workplace visits, through filming activities, observing aspects of work organization, workplace, equipment, load handling, and postures used, guided interviews were conducted with workers from each evaluated activity, the interview is conducted to avoid worker embarrassment, who are questioned about work routine and organization, operating methods, and general information about performed activities.</p><br><h3><strong>Image Collection</strong></h3><p>Image collection was performed through photos and videos demonstrating the main characteristics of the analyzed workstations and to enable the use of the Kinebot platform.</p>':
		'<p>Esta AET foi construída utilizando a plataforma Kinebot, que é um sistema que inclui avaliação de movimentos por algoritmos de visão computacional e permite a realização de PEA (Avaliação Ergonômica Preliminar) e AET segundo a norma ABNT ISO/TS 20646:2017, contemplando:</p><ul><li>Jornada e concentração de trabalho</li><li>Tipo de trabalho</li><li>Posturas e movimentos</li><li>Influência de fatores do posto e da tarefa</li><li>Influência de fatores psicossociais</li><li>Influência de fatores ambientais</li><li>Influência de fatores organizacionais</li></ul><br><h3><strong>Análise da demanda</strong></h3><p>Inicialmente, foi realizada a análise de demanda, observando os fatores que motivaram a AET e os possíveis fatores causadores que mereciam atenção.</p><br><h3><strong>Seleção dos aspectos avaliados</strong></h3><p>Após a análise da demanda, foram selecionadas as Avaliações Ergonômicas Preliminares (AEPs) das atividades relacionadas a esta AET. Entre todos os aspectos avaliados, foram escolhidos aqueles correlacionados à demanda.</p><br><h3><strong>Avaliação ergonômica</strong></h3><p>Para mapear movimentos e conduzir o estudo cinesiológico de posturas e movimentos, utilizou-se a plataforma Kinebot. Esse sistema de visão computacional auxilia na medição de movimentos. Com recursos de aprendizado de máquina, a Kinebot identifica padrões, gera modelos e realiza avaliações das exigências posturais e de movimento de cada atividade.</p><p>De acordo com a demanda e os aspectos avaliados, foram usadas as seguintes ferramentas ergonômicas:</p><ul><li>Avaliação de repetitividade:<ul><li>Strain Index Revisado</li></ul></li><li>Avaliação de exigências posturais:<ul><li>RULA (Rapid Upper Limb Assessment)</li><li>REBA (Rapid Entire Body Assessment)</li></ul></li><li>Manuseio e transporte de cargas:<ul><li>NIOSH / ISO 11228</li><li>KIM-MHO - Avaliação de manuseio de ferramentas</li><li>KIM-PP - Avaliação de empurrar e puxar</li><li>Liberty Mutual - Avaliação de manuseio de cargas</li></ul></li></ul><br><h3><strong>Coleta de dados</strong></h3><p>Os dados foram coletados em visitas ao posto de trabalho, filmando atividades, observando organização do trabalho, ambiente, equipamentos, manuseio de cargas e posturas. Foram conduzidas entrevistas guiadas com trabalhadores, evitando constrangimento, sobre rotina, organização, métodos operacionais e informações gerais das atividades.</p><br><h3><strong>Coleta de imagens</strong></h3><p>A coleta de imagens foi feita com fotos e vídeos das principais características dos postos analisados para possibilitar o uso da plataforma Kinebot.</p>',
	'Item filter': 'Filtro de itens',
	'Select the items you want to make up your EWA': 'Selecione os itens que irão compor sua AET',
	'Please select at least one criteria for each activity': 'Selecione pelo menos um critério para cada atividade',
	'Upload image': 'Upload de imagem',
	'Upload images of the activity being evaluated': 'Upload de imagens da atividade sendo avaliada',
	Image: 'Imagem',
	'Add file': 'Adicionar arquivo',
	Section: 'Seção',
	Criteria: 'Critérios',
	'Selected items': 'Itens selecionados',
	'Type of work': 'Tipo de trabalho',
	'Activity risk': 'Risco da atividade',
	'Recommended weight limit': 'Limite de peso recomendado',
	'Lifting index': 'Índice de levantamento',

	'Select a hand coupling': 'Selecione uma qualidade de pega',
	'of men': 'dos homens',
	'of women': 'das mulheres',
	'Action plans created': 'Planos de ação criados',
	'Force transfer': 'Transferência de força',
	'Force exerted (Left)': 'Força exercida (Esquerda)',
	'Force exerted (Right)': 'Força exercida (Direita)',
	'Uploaded by': 'Enviado por',

	'Physical overload is unlikely': 'Sobrecarga física é improvável',
	'No health risks are expected': 'Riscos a saúde não são esperados',
	'No action is required': 'Nenhuma medida é necessária',

	'Possible for less resilient individuals': 'É possível para pessoas menos resilientes',
	'Fatigue, low-level adaptation issues that can be compensated during down time':
		'Fadiga, problemas de adaptação de baixo grau que podem ser compensados ​​durante o tempo livre',
	'For less resilient individuals, workplace redesign and other preventive measures may be helpful':
		'Para pessoas menos resilientes, o redesign do local de trabalho e outras medidas preventivas podem ser úteis',

	'Physical overload is also possible even for normally resilient individuals':
		'A sobrecarga física também é possível mesmo para pessoas normalmente resistentes',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'Distúrbios (dor), possivelmente incluindo disfunções, reversíveis na maioria dos casos, sem manifestação morfológica',
	'Workplace redesign measures and other preventive measures must be considered':
		'Devem ser consideradas medidas de redesign do posto de trabalho e outras medidas de prevenção',

	'Physical overload is likely': 'Sobrecarga física provável',
	'More pronounced disorders and/or dysfunctions, with structural damage of pathological relevance':
		'Distúrbios e/ou disfunções mais acentuados, com danos estruturais de relevância patológica',
	'Workplace redesign measures are necessary. Other preventive measures must be considered':
		'Medidas de redesign do posto de trabalho são necessárias. Outras medidas de prevenção devem ser consideradas',

	'Duration of the workday': 'Duração do dia de trabalho',
	'Duration of the activity': 'Duração da atividade',
	'Activity duration cannot be greater than day duration':
		'A duração da atividade não pode ser maior que a duração do dia',
	'Men score': 'Pontuação homens',
	'Women score': 'Pontuação mulheres',
	'The movement can occur in both directions; postures may indicate the beginning or end of the operation. When there are multiple postures in the same option, they all represent the same condition.':
		'O movimento pode ocorrer em ambas as direções; as posturas podem indicar início ou término da operação. Quando houver várias posturas na mesma opção, todas representam a mesma condição.',
	'Video file': 'Arquivo de vídeo',
	'No ENS Workstations': 'Postos de trabalho não ENS',
	'ENS Workstations': 'Postos de trabalho ENS',
	ENS: 'ENS',
	'No ENS': 'Não ENS',
	'Not Evaluated': 'Não avaliado',
	'Ergonomic Neutral Station': 'Estação Neutra Ergonômica',
	'Workstations with an RPN equal to or less than 15 are classified as ENS.':
		'Postos de trabalho com RPN igual ou menor que 15 são classificados como ENS.',
	'Workstations with an RPN greater than 15 are classified as non-ENS.':
		'Postos de trabalho com RPN maior que 15 são classificados como não ENS.',
	'New activity name': 'Novo nome de atividade',
	'New sector name': 'Novo nome de setor',
	'New line name': 'Novo nome de linha',
	'New workstation name': 'Novo nome de posto de trabalho',
	'New evaluator name': 'Novo nome de avaliador',

	'The dimensions and clearances of the controls or work surface are inadequate (unified)':
		'As dimensões e folgas dos comandos ou superfície de trabalho são inadequadas',
	'The workstation involves working squatting or kneeling':
		'A estação de trabalho envolve trabalhar agachado ou ajoelhado',
	'The highest level of shelves and flow rack is inadequate for vertical reach':
		'O nível mais alto das prateleiras e flow rack é inadequado para alcance vertical',
	'Highest shelf height': 'Altura da prateleira mais alta',
	'Empty container top height (KLT, Tote)': 'Altura da parte superior do recipiente vazio (KLT, Tote)',

	Action: 'Ação',
	Position: 'Posição',
	'Use of gloves': 'Uso de luvas',
	Height: 'Altura',
	Width: 'Largura',
	Diameter: 'Diâmetro',

	'Flat empty hand': 'Mão vazia, plana',
	'Empty hand, bent thumb': 'Mão vazia, polegar dobrado',
	'Clenched fist': 'Mão cerrada, punho',
	'Hand plus 25 mm object': 'Mão mais objeto de 25 mm',
	'Hand plus X mm object up to the wrist': 'Mão mais objeto de X mm até o pulso',
	'Arm to shoulder': 'Braço até o ombro',
	'Both arms to shoulder': 'Ambos os braços até o ombro',
	'Leg width': 'Largura da perna',
	'Foot clearance': 'Folga para os pés',

	Kneeling: 'Ajoelhado',
	Squatting: 'Agachado',

	'With one hand': 'Com uma mão',
	'With two hands': 'Com duas mãos',

	'For one-handed lifts above 3 kg, the KIM LHC is recommended. For two-handed lifts above 4.5 kg, the KIM LHC and NIOSH are recommended.':
		'Para levantamentos com 1 mão, acima de 3kg, recomenda-se o KIM LHC. Para levantamentos com duas mãos, acima de 4,5kg, recomenda-se o KIM LHC e NIOSH.',
	Handling: 'Manuseio',
	'Occasional reach to retrieve parts, tools, or small objects < 1 kg (2.2 lb), which presents no risk to the process or to the object being handled':
		'Alcance ocasional para recuperar peças, ferramentas ou objetos pequenos < 1 kg (2,2 lb), que não apresenta risco no processo e no objeto que está sendo manuseado'
};

Object.assign(dictionary, {
	'Include all employees in this line': 'Incluir todos os funcionários desta linha',
	'Eligible employees': 'Funcionários elegíveis',
	'Employee code': 'Código do funcionário',
	'Selected rows will be excluded from the invitation': 'As linhas selecionadas serão excluídas do convite',
	'Only selected rows will be invited': 'Somente os funcionários selecionados serão convidados',
	'Create HSE-IT survey': 'Criar levantamento HSE-IT',
	'Survey identifier': 'Identificação do levantamento',
	'Anonymous survey': 'Levantamento anônimo',
	'Notify participants by email': 'Notificar participantes por e-mail',
	'Participants with an email address will receive their survey invitation':
		'Participantes com e-mail receberão o convite do levantamento',
	'Create survey': 'Criar levantamento',
	'Employees imported': 'Funcionários importados',
	'Import CSV or XLSX': 'Importar CSV ou XLSX',
	'Download template': 'Baixar modelo',
	'Review employee import': 'Revisar importação de funcionários',
	Import: 'Importar',
	'Name, employee code and line are required. Dates use YYYY-MM-DD.':
		'Nome, matrícula e linha são obrigatórios. Datas no formato AAAA-MM-DD.',
	Row: 'Linha',
	Field: 'Field',
	Error: 'Erro',
	'Create employee': 'Cadastrar funcionário',
	Employee: 'Employee',
	'Delete employee?': 'Excluir funcionário?',
	Surveys: 'Levantamentos',
	'Risk matrix category': 'Categoria da matriz de risco',
	'General survey action plan': 'Plano de ação geral do levantamento',
	Questions: 'Questões',
	Question: 'Pergunta',
	Mean: 'Mean',
	Answers: 'Respostas',
	Benchmark: 'Benchmark',
	Interpretation: 'Interpretação',
	Anonymous: 'Anônimo',
	'Notifications queued': 'Notificações enfileiradas',
	Participants: 'Participants',
	'Notify selected participants': 'Notificar participantes selecionados',
	'Notified at': 'Notificado em',
	'Use 1 to 6 for each factor, or zero for every factor to leave the risk unassessed':
		'Use de 1 a 6 em cada fator, ou zero em todos para deixar o risco sem avaliação',
	'Notify pending participants': 'Notificar participantes pendentes',
	'Close this survey?': 'Encerrar este levantamento?',
	'Complete survey': 'Encerrar levantamento',
	Ongoing: 'Ongoing',
	'Survey type': 'Tipo de levantamento',
	Identified: 'Identificada',
	'Completion start date': 'Conclusão a partir de',
	'Completion end date': 'Conclusão até',
	'Apply filters': 'Aplicar filtros',
	'Clear filters': 'Limpar filtros',
	'Try again': 'Tentar novamente',
	'Access denied': 'Acesso negado',
	'Select an industrial site to continue': 'Selecione uma unidade para continuar',
	Psychosocial: 'Psicossocial',
	Employees: 'Funcionários',
	'Something went wrong': 'Algo deu errado',
	'Generate PIN': 'Gerar PIN',
	'Check your email for the PIN': 'Confira o PIN no seu e-mail',
	'Start survey': 'Iniciar levantamento',
	'Thank you for completing the survey': 'Obrigado por responder ao levantamento',
	'Your answers are saved as you progress': 'Suas respostas são salvas conforme você avança',
	'Your answer could not be saved. Retry before continuing.':
		'Não foi possível salvar sua resposta. Tente novamente antes de continuar.',
	'Submit survey': 'Enviar levantamento',
	'After submitting, your answers cannot be changed.': 'Após o envio, suas respostas não poderão ser alteradas.',
	'At work, different groups make demands on me that are difficult to reconcile':
		'No trabalho, diferentes grupos exigem de mim, coisas difíceis de conciliar',
	'I have impossible deadlines to meet': 'Tenho prazos impossíveis de serem cumpridos',
	'I have to work very hard': 'Tenho que trabalhar muito intensamente',
	'I need to put some tasks aside because I have too many things to do':
		'Preciso deixar de lado algumas tarefas porque tenho coisas demais para fazer',
	"I can't take enough breaks": 'Não consigo fazer pausas suficientes',
	'I am under pressure to work for long stretches': 'Sou pressionado para trabalhar por longos períodos',
	'I have to work very fast': 'Tenho que trabalhar muito rápido',
	'I suffer absurd time pressures': 'Sofro pressões de tempo absurdas',
	'I can decide when to take a break': 'Posso decidir quando fazer uma pausa',
	'I can set my own work pace': 'Posso decidir sobre meu ritmo de trabalho',
	'I can decide how to approach my work': 'Posso escolher como fazer meu trabalho',
	'I can choose what to do at work': 'Posso escolher o que fazer no trabalho',
	'I have some decision-making power over my way of working':
		'Tenho algum poder de decisão sobre a minha maneira de trabalhar',
	'My work schedule can be flexible': 'Meu horário de trabalho pode ser flexível',
	'I am subject to personal harassment in the form of verbal or behavioral abuse':
		'Estou sujeito a assédio pessoal na forma de palavras ou comportamentos rudes',
	'There is friction or animosity among coworkers': 'Existe atrito ou animosidade entre os colegas de trabalho',
	'I am subject to uncomfortable situations or pressures at work': 'Estou sujeito a constrangimentos no trabalho',
	'Work relationships are tense': 'Os relacionamentos no trabalho são tensos',
	'I know clearly what is expected of me at work': 'Sei claramente o que é esperado de mim no trabalho',
	'I know how to do my job': 'Sei como fazer para executar o meu trabalho',
	'I am aware of my responsibilities and duties': 'Estou ciente quais são os meus deveres e responsabilidades',
	"I am familiar with my department's goals": 'Eu conheço as metas e objetivos do meu departamento',
	"I understand how my work aligns with the organization's objectives":
		'Compreendo como o meu trabalho se integra com os objetivos da organização',
	'I have ample opportunities to ask leadership about changes at work':
		'Tenho oportunidades suficientes para questionar as chefias sobre mudanças no trabalho',
	'The team is always involved in discussions about changes at work':
		'A equipe é sempre consultada sobre mudanças no trabalho',
	'When changes occur at work, I am informed about how they will work in practice':
		'Quando ocorrem mudanças no trabalho, sou esclarecido de como elas funcionarão na prática',
	'I receive feedback on the work I do': 'Recebo retorno sobre os trabalhos que realizo',
	'I can rely on my immediate supervisor for support in resolving work issues':
		'Posso falar com meu chefe imediato sobre algo que me incomodou no trabalho',
	'I can discuss with my immediate supervisor something that concerns me at work':
		'Posso contar com a ajuda do meu chefe imediato para resolver problemas do trabalho',
	'I receive support when performing emotionally demanding tasks':
		'Recebo apoio quando realizo trabalho que pode ser emocionalmente desgastante',
	'My immediate supervisor motivates me at work': 'Meu chefe imediato me motiva no trabalho',
	'When the work gets tough, my colleagues help me': 'Se o trabalho fica difícil, meus colegas me ajudam',
	'I get the help and support I need from my colleagues': 'Recebo a ajuda e o apoio necessário dos meus colegas',
	'I am treated with the respect I deserve by my colleagues': 'Sou respeitado como eu mereço pelos meus colegas',
	'My colleagues are willing to listen to my work-related issues':
		'Meus colegas estão dispostos a ouvir meus problemas relacionados ao trabalho',
	Never: 'Nunca',
	Rarely: 'Raramente',
	Sometimes: 'Às vezes',
	Often: 'Frequentemente',
	Always: 'Sempre',
	Demands: 'Demanda',
	'Management support': 'Apoio chefia',
	'Peer support': 'Apoio dos colegas',
	Relationships: 'Relacionamentos',
	gender: 'Gênero',
	role: 'Cargo',
	education: 'Escolaridade',
	'work shift': 'Turno',
	'employee code': 'Matrícula',
	email: 'E-mail',
	'birth date': 'Data de nascimento',
	'admission date': 'Data de admissão',
	'birth date start': 'Nascimento a partir de',
	'birth date end': 'Nascimento até',
	'admission date start': 'Admissão a partir de',
	'admission date end': 'Admissão até',
	severity: 'Severidade',
	exposure: 'Exposição',
	probability: 'Probabilidade',
	MALE: 'Masculino',
	FEMALE: 'Feminino',
	OTHER: 'Outro',
	ongoing: 'Em andamento',
	completed: 'Concluída',
	alphabetical_asc: 'Nome crescente',
	alphabetical_desc: 'Nome decrescente',
	highest_load: 'Maior carga',
	lowest_load: 'Menor carga'
});

Object.assign(dictionary, {
	'Compare results': 'Comparar resultados',
	'Group by': 'Agrupar por',
	Compare: 'Compare',
	'Order by': 'Ordenar por',
	Order: 'Ordem'
});

Object.assign(dictionary, {
	'Save a category assessment to link an action plan':
		'Salve a avaliação de uma categoria para vinculá-la a um plano de ação',
	'HSE risk level': 'Nível de risco HSE',
	'low-stress-risk': 'Baixo risco de estresse',
	'medium-stress-risk': 'Risco médio de estresse',
	'moderate-stress-risk': 'Risco moderado de estresse',
	'high-stress-risk': 'Alto risco de estresse'
});
Object.assign(dictionary, {
	'CSV or XLSX, up to 10000 employees and 20 MB': 'CSV ou XLSX, até 10000 funcionários e 20 MB',
	'Reading employee file': 'Lendo arquivo de funcionários',
	'Validating employee records': 'Validando registros de funcionários',
	'Importing employee records': 'Importando registros de funcionários',
	'Employee files must be 20 MB or smaller': 'O arquivo de funcionários deve ter no máximo 20 MB',
	'A file can contain at most 10000 employees': 'Um arquivo pode conter no máximo 10000 funcionários',
	'Unable to read employee file': 'Não foi possível ler o arquivo de funcionários',
	'Unable to start the employee file reader. Please try again.':
		'Não foi possível iniciar a leitura do arquivo. Tente novamente.'
});
Object.assign(dictionary, {
  "Employees management": "Gestão de funcionários",
  "employees selected": "funcionários selecionados",
  "Questionnaires": "Questionários",
  "The questionnaire consists of 35 questions distributed across seven dimensions": "O questionário contém 35 perguntas distribuídas em sete dimensões",
  "Review the current HSE-IT questions and their answer options before creating this survey.": "Revise as perguntas HSE-IT e as opções de resposta antes de criar o levantamento.",
  "Unable to load questionnaire": "Não foi possível carregar o questionário",
  "The personalized email message is too long": "A mensagem de e-mail personalizada está muito longa",
  "Create new survey": "Criar novo levantamento",
  "Application limit date": "Data limite de aplicação",
  "Select the tool for the survey": "Selecione a ferramenta para o levantamento",
  "View surveys": "Visualizar questionários",
  "Survey description": "Descrição do levantamento",
  "Notify employees": "Notificar funcionários",
  "Personalized email message": "Mensagem personalizada para e-mail",
  "View message layout": "Visualizar layout de mensagem",
  "Message layout": "Visualização da mensagem",
  "Survey link": "Link do levantamento",
  "Included in the invitation": "Incluído no convite",
  "Update employee": "Atualizar funcionário",
  "Employee email": "E-mail do funcionário",
  "Employee name": "Nome do funcionário",
  "Education": "Nível de escolaridade",
  "Employee role": "Cargo do funcionário",
  "Admission date": "Data de admissão",
  "Work shift": "Turno de trabalho",
  "Birth date": "Data de nascimento",
  "Feminine": "Feminino",
  "Masculine": "Masculino",
  "Other": "Outro",
  "Import employee list": "Importar lista de funcionários",
  "Choose file": "Escolher arquivo",
  "To import a list of employees, select a file in CSV or XLSX format. The spreadsheet must contain the following columns:": "Para importar funcionários, selecione um arquivo CSV ou XLSX. A planilha deve conter as seguintes colunas:",
  "Required": "Obrigatório",
  "Export model": "Exportar modelo",
  "Optional": "Opcional",
  "Edit employee": "Editar funcionário",
  "Delete employee": "Excluir funcionário",
  "Ordination": "Ordenação",
  "Name Z–A": "Nome Z–A",
  "Newest": "Mais recente",
  "Search name or employee code": "Pesquisar nome ou código do funcionário",
  "Birth date from": "Data de nascimento inicial",
  "Birth date to": "Data de nascimento final",
  "Admission date from": "Data de admissão inicial",
  "Admission date to": "Data de admissão final",
  "Comparative results": "Resultados comparativos",
  "General": "Geral",
  "Select groups to compare": "Selecione os grupos para comparar",
  "Completed Surveys": "Levantamentos concluídos",
  "Result (risk matrix)": "Resultado (matriz de risco)",
  "No completed surveys": "Nenhum levantamento concluído",
  "Surveys on time": "Levantamentos no tempo",
  "Final result": "Resultado final",
  "Performance relative to the comparative sample": "Desempenho em relação à amostra comparativa",
  "The comparative sample is the HSE benchmark for 2025.": "A amostra comparativa usa a referência HSE de 2025.",
  "Category / Evaluation": "Categoria / Avaliação",
  "Alphabetical A–Z": "Alfabética A–Z",
  "Alphabetical Z–A": "Alfabética Z–A",
  "Highest load": "Maior carga",
  "Lowest load": "Menor carga",
  "Search by name": "Pesquisar por nome",
  "Completion Date": "Data de conclusão",
  "Employees count": "Número de funcionários",
  "Answered surveys": "Avaliações respondidas",
  "Participation": "Participação",
  "All categories": "Todas as categorias",
  "Search category or question": "Pesquisar categoria ou pergunta",
  "Not Assessed": "Não avaliado",
  "View questions by category": "Ver questões por categoria",
  "Final results": "Resultados finais",
  "Survey link copied to clipboard": "Link do levantamento copiado para a área de transferência",
  "Failed to copy survey link": "Falha ao copiar link do levantamento",
  "Copy link": "Copiar link",
  "QR Code": "QR Code",
  "Delete survey?": "Excluir o levantamento?",
  "Delete survey": "Excluir levantamento",
  "Favorable": "Favorável",
  "Neutral": "Neutro",
  "Legend for the categories": "Legenda para as categorias",
  "Legend for the category": "Legenda para a categoria",
  "Relationship": "Relacionamento",
  "Relationship responses are shown separately so reports of bullying or harassment remain visible.": "As respostas sobre relacionamentos são mostradas separadamente para manter visíveis os relatos de assédio.",
  "Link copied": "Link copiado",
  "Complete survey?": "Concluir o levantamento?",
  "Survey": "Levantamento",
  "Evaluated Hierarchy": "Hierarquia avaliada",
  "Share": "Compartilhar",
  "Copy survey link": "Copiar link do levantamento",
  "Show QR code": "Mostrar código QR",
  "Highest risk (risk matrix)": "Maior risco (matriz de risco)",
  "Add New Survey": "Criar novo levantamento",
  "Creation date (newest)": "Data de criação mais recente",
  "Creation date (oldest)": "Data de criação mais antiga",
  "Newest completion date": "Data de conclusão mais recente",
  "Oldest completion date": "Data de conclusão mais antiga",
  "Name A–Z": "Nome A–Z",
  "Search survey": "Pesquisar levantamento",
  "Survey Type": "Tipo de levantamento",
  "Non-anonymous": "Não anônimo",
  "Creation date from": "Data de criação inicial",
  "Creation date to": "Data de criação final",
  "Completion date from": "Data de conclusão inicial",
  "Completion date to": "Data de conclusão final",
  "Survey QR code": "Código QR do levantamento",
  "Hello! Welcome to your psychosocial evaluation.": "Olá! Bem-vindo à sua avaliação psicossocial.",
  "Enter the employee code": "Insira o código do funcionário",
  "Access evaluation": "Acessar avaliação",
  "Review your answers. Click on any question to edit.": "Revise suas respostas. Clique sobre a questão para editar.",
  "Not answered": "Não respondida",
  "LUCCA, Sergio Roberto de; SOBRAL, Renata Cristina. Aplicação de instrumento para o diagnóstico dos fatores de risco psicossociais nas organizações. Campinas: Universidade Estadual de Campinas, 2017": "LUCCA, Sergio Roberto de; SOBRAL, Renata Cristina. Aplicação de instrumento para o diagnóstico dos fatores de risco psicossociais nas organizações. Campinas: Universidade Estadual de Campinas, 2017",
  "Scroll to bottom": "Rolagem para baixo",
  "Access PIN": "PIN de acesso",
  "Questionnaire": "Questionário",
  "Filling progress": "Progresso de preenchimento",
  "Indicate the frequency of the following statements on the scale:": "Assinale dentro da escala qual a frequência das seguintes afirmações:",
  "Your answers have been saved": "Suas respostas foram salvas",
  "Survey completed successfully!": "Sua avaliação foi concluída!",
  "Save answers": "Salvar respostas"
});
Object.assign(dictionary, {
  "Ongoing Surveys": "Levantamentos em andamento",
  "Risk classification is carried out using the method of Willian T. Fine.": "A classificação de risco é feita a partir do método Willian T. Fine.",
  "Biggest risk found": "Maior risco encontrado",
  "Unassessed": "Não avaliado"
});
Object.assign(dictionary, {
  "Add Employee": "Adicionar funcionário",
  "Added least recently": "Menos recentemente adicionado",
  "Alphabetical": "Alfabética",
  "Complete university education": "Ensino superior completo",
  "Create a new education title": "Criar um novo título de educação",
  "Create a new work shift": "Criar um novo turno de trabalho",
  "Enter the employee name": "Insira o nome do funcionário",
  "Import file": "Importar arquivo",
  "Invalid email": "E-mail inválido",
  "Line 1": "Linha 1",
  "Longest service in the company": "Maior tempo de empresa",
  "Morning": "Matutino",
  "Most recently added": "Mais recentemente adicionado",
  "Shortest service in the company": "Menor tempo de empresa",
  "Want to": "Deseja",
  "the employee": "o funcionário"
});
Object.assign(dictionary, {
  "Optimal sample size": "Tamanho ideal da amostra",
  "Trust level reached": "Atingiu o nível de confiança",
  "Trust level not reached": "Não atingiu o nível de confiança",
  "Favorable health situation": "Situação favorável para a saúde",
  "Intermediate situation": "Situação intermediária",
  "Health risk": "Risco para a saúde",
  "Legend for the dimension": "Legenda para a dimensão",
  "Never/almost never": "Nunca/quase nunca",
  "Default": "Padrão",
  "Highest favorable": "Maior situação favorável",
  "Highest neutral": "Maior situação intermediária",
  "Highest risk": "Maior situação de risco",
  "Result by question": "Resultado por questão",
  "Highest load found": "Maior carga encontrada",
  "Lowest load found": "Menor carga encontrada",
  "Your score is below the 25th percentile, which suggests that your employees perceptions are more negative than in 25% of organizations.": "Sua pontuação está abaixo do 25º percentil, o que sugere que as percepções de seus colaboradores são mais negativas do que em 75% das organizações.",
  "Your score is between the 25th and 75th percentile, suggesting that your employees perceptions are in line with the middle group (50%).": "Sua pontuação está entre o 25º e o 75º percentil, sugerindo que as percepções de seus colaboradores estão alinhadas com o grupo intermediário (50%).",
  "Your score is above the 75th percentile, which suggests that your employees perceptions are more positive than in 75% of organizations.": "Sua pontuação está acima do 75º percentil, o que sugere que as percepções de seus colaboradores são mais positivas do que em 75% das organizações.",
  "In Relationship, the score is presented in response categories. This is because answers like “sometimes” may indicate bullying or harassment, and any report of such behavior must be considered serious by the organization.": "Em Relacionamento, a pontuação é apresentada em categorias de resposta. Isso porque respostas como “às vezes” podem indicar bullying ou assédio, e qualquer denúncia de tais comportamentos deve ser considerada grave pela organização.",
  "The comparative sample corresponds to a benchmark carried out in 2025 by the Health and Safety Executive (HSE), in the United Kingdom, with 165 private sector organizations.": "A amostra comparativa corresponde a um benchmark realizado em 2025 pela Health and Safety Executive (HSE), no Reino Unido com 165 organizações do setor privado.",
  "Average score (survey)": "Nota média (levantamento)",
  "Average score (benchmark)": "Nota média (amostra comparativa)",
  "Average survey score": "Nota média do levantamento",
  "Average benchmark score": "Nota média do benchmark",
  "25th percentile": "25º percentil",
  "75th percentile": "75º percentil",
  "Totally disagree / Never": "Discordo Totalmente / Nunca",
  "Disagree / Rarely": "Discordo / Raramente",
  "Neutral / Sometimes": "Neutro / Às vezes",
  "Agree / Often": "Concordo / Frequentemente",
  "Totally agree / Always": "Concordo Totalmente / Sempre",
  "Average": "Média",
  "Duty": "Cargo",
  "Management Support": "Apoio chefia",
  "Colleagues Support": "Apoio colegas"
});
Object.assign(dictionary, {
	"Number of Surveys": "Quantidade de levantamentos",
	"The displayed risk corresponds to the highest risk found among the categories, according to the method of Willian T. Fine.": "O risco exibido corresponde ao maior risco encontrado entre as categorias, a partir do método Willian T. Fine.",
	"Highest favorable risk": "Maior risco favorável",
	"Highest neutral risk": "Maior risco neutro",
	"Highest unfavorable risk": "Maior risco desfavorável",
	"Overall average": "Média geral",
	"Hierarchy/ Category": "Hierarquia/ Categoria",
	"Reference period": "Período referência",
	"Severe and Imminent Risk": "Risco grave e iminente"
});
Object.assign(dictionary, {
  "Classification": "Classificação",
  "Marked response": "Resposta assinalada",
  "Enter the survey identifier": "Insira a identificação do levantamento",
  "Select the application limit date": "Selecione a data limite de aplicação",
  "Enter the survey description": "Insira a descrição do levantamento",
  "Preview of the layout": "Visualização prévia do layout",
  "Usage recommendations": "Recomendações de uso",
  "Its validation study can be accessed": "Seu estudo de validação pode ser acessado",
  "here": "aqui",
  "The questionnaire consists of 35 questions distributed across seven dimensions:": "O questionário é composto por 35 questões distribuídas em sete dimensões:",
  "Filling": "Preenchimento",
  "Each dimension is measured with 3 to 8 questions using one of two 5-point Likert scales:": "Cada dimensão é mensurada com 3 a 8 questões utilizando uma de duas escalas Likert de 5 pontos:",
  "Never and Rarely / Frequently and Always": "Nunca e Raramente / Frequentemente e Sempre",
  "(1) Never": "(1) Nunca",
  "(2) Rarely": "(2) Raramente",
  "(3) Sometimes": "(3) Às vezes",
  "(4) Frequently": "(4) Frequentemente",
  "(5) Always": "(5) Sempre",
  "(1) Strongly disagree": "(1) Discordo totalmente",
  "(2) Disagree": "(2) Discordo",
  "(3) Neutral": "(3) Neutro",
  "(4) Agree": "(4) Concordo",
  "(5) Strongly agree": "(5) Concordo totalmente",
  "The HSE-IT is an internationally validated instrument for assessing psychosocial risks in the workplace, including workload, leadership support, role clarity, and interpersonal relationships. Developed by the UK government, it is one of the most comprehensive tools for understanding the collective psychosocial environment. Kinebot selected the HSE-IT for its robustness and ease of large-scale application, making it ideal for organizations aiming to identify group-level risks and implement systemic improvements.": "O HSE-IT é um instrumento validado internacionalmente que avalia os riscos psicossociais no ambiente organizacional, como sobrecarga de trabalho, apoio da liderança, clareza de papel e relacionamentos interpessoais. Desenvolvido pelo governo britânico, é uma das ferramentas mais completas para entender o ambiente psicossocial coletivo. A Kinebot escolheu o HSE-IT por sua robustez e facilidade de aplicação em larga escala, sendo indicado para organizações que desejam identificar fatores que afetam grupos ou setores inteiros e implementar ações coletivas de melhoria.",
  "The result of each dimension corresponds to the incidence of the three available classifications and is obtained from the count of all employees' responses, classifying them as favorable, neutral, or unfavorable. The classification of results requires interpretation factor by factor, because the values can have different meanings depending on the dimension.": "O resultado de cada dimensão corresponde à incidência das três classificações disponíveis e é obtido a partir da contabilização das respostas de todos os funcionários, classificando-as como favoráveis, neutro ou desfavoráveis. A classificação dos resultados pressupõe a interpretação fator a fator, isso porque, os valores podem ter sentidos distintos conforme a dimensão.",
  "The \"Relationships\" dimension measures the occurrence of specific and serious events. Since any report of bullying or harassment behavior must be considered serious by the organization, its risk will directly reflect the occurrence of the response options: \"Strongly disagree/Never\", \"Disagree/Rarely\", \"Neutral/Sometimes\", \"Agree/Frequently\" and \"Strongly agree/Always\".": "A dimensão \"Relacionamento\" mede a ocorrência de eventos específicos e graves. Como qualquer denúncia de comportamentos como bullying ou assédio deve ser considerada grave pela organização, seu risco exibirá diretamente a ocorrência das opções de resposta: \"Discordo totalmente/Nunca\", \"Discordo/Raramente\", \"Neutro/Às vezes\", \"Concordo/Frequentemente\" e \"Concordo totalmente/Sempre\".",
  "Select between 2 and 5 groups": "Selecione entre 2 e 5 grupos"
});
Object.assign(dictionary, {
	"Questions by category": "Perguntas por categoria",
	"Please fill all fields before finishing the survey.": "Preencha todos os campos antes de finalizar o levantamento.",
	"HSE-IT": "HSE-IT",
	"Empty file": "Arquivo vazio",
	"Choose a CSV or XLSX file": "Escolha um arquivo CSV ou XLSX",
	"Unclosed quoted CSV field": "Campo do CSV com aspas não fechadas",
	"No worksheet found": "Nenhuma planilha encontrada",
	"File reading cancelled": "Leitura do arquivo cancelada",
	"Access your test through your credentials.": "Acesse seu teste por meio das suas credenciais.",
	"To access your test, generate an automatic PIN.": "Para acessar seu teste, gere um PIN automático.",
	"No registered email was found to send the PIN. It was generated and filled automatically.": "Nenhum e-mail cadastrado foi encontrado para enviar o PIN. Ele foi gerado e preenchido automaticamente.",
	"Totally disagree": "Discordo totalmente",
	"Disagree": "Discordo",
	"Agree": "Concordo",
	"Totally agree": "Concordo totalmente",
	"Employee not found": "Colaborador não encontrado",
	"Invalid employee data": "Dados do colaborador inválidos",
	"Employee code already exists in this company": "Código do colaborador já existe nesta empresa",
	"Required text field": "Campo de texto obrigatório",
	"Expected text": "Texto esperado",
	"Text exceeds the maximum length": "O texto excede o tamanho máximo",
	"Invalid gender": "Gênero inválido",
	"Expected valid YYYY-MM-DD date": "Data válida esperada no formato AAAA-MM-DD",
	"Line not found in this company": "Linha não encontrada nesta empresa",
	"Line name is ambiguous; provide sector_name or line_id": "Nome da linha ambíguo; informe sector_name ou line_id",
	"Workstation not found or ambiguous within selected line": "Posto de trabalho não encontrado ou ambíguo na linha selecionada",
	"Employee code already exists in company or import": "Código do colaborador já existe na empresa ou na importação",
	"Employee email already exists": "E-mail do colaborador já existe",
	"Anonymous participant completion cannot be filtered": "A conclusão de participantes anônimos não pode ser filtrada",
	"Anonymous surveys do not use a PIN": "Levantamentos anônimos não usam PIN",
	"Answer all questions before submitting": "Responda todas as perguntas antes de enviar",
	"Identity filters are unavailable for anonymous survey results": "Filtros de identidade não estão disponíveis para resultados de levantamentos anônimos",
	"Invalid PIN": "PIN inválido",
	"Invalid invitation": "Convite inválido",
	"Invalid participant": "Participante inválido",
	"Invalid question option": "Opção de pergunta inválida",
	"Line does not belong to the company": "A linha não pertence à empresa",
	"PIN expired or already used": "PIN expirado ou já utilizado",
	"Participant not found": "Participante não encontrado",
	"Please wait before requesting another PIN": "Aguarde antes de solicitar outro PIN",
	"Responsible user must have active access to this company": "O usuário responsável deve ter acesso ativo a esta empresa",
	"Risk matrix must belong to the survey; factors must all be zero or between 1 and 6": "A matriz de risco deve pertencer ao levantamento; os fatores devem ser todos zero ou entre 1 e 6",
	"Select at least one employee": "Selecione pelo menos um colaborador",
	"Session expired or invalid": "Sessão expirada ou inválida",
	"Survey already submitted": "Levantamento já enviado",
	"Survey expiration must be in the future": "A expiração do levantamento deve ser no futuro",
	"Survey is closed or expired": "O levantamento está encerrado ou expirado",
	"Survey is completed": "O levantamento está concluído",
	"Survey not found": "Levantamento não encontrado",
	"Survey or action plan not found": "Levantamento ou plano de ação não encontrado",
	"Survey results are available once the survey is completed": "Os resultados do levantamento ficam disponíveis após sua conclusão",
	"The maximum number of responses for this survey has been reached": "O número máximo de respostas deste levantamento foi atingido",
	"This survey has not yet received responses and it is not possible to close it.": "Este levantamento ainda não recebeu respostas e não é possível encerrá-lo.",
	"This survey requires employee identification": "Este levantamento exige a identificação do colaborador",
	"Workstation does not belong to the line": "O posto de trabalho não pertence à linha"
});
Object.assign(dictionary, {
	"Download report": "Baixar relatório",
	"Failed to export evaluations": "Falha ao exportar as avaliações",
	"Export CSV": "Exportar CSV",
	"responses": "respostas",
	"Report generated successfully!": "Relatório gerado com sucesso!"
});
Object.assign(dictionary, {
	"Export": "Exportar",
	"PDF": "PDF",
	"Export PDF": "Exportar PDF",
	"Filtered visualization": "Visualização filtrada",
	"reflects the filters and sortings applied to the sections of results.": "reflete os filtros e ordenações aplicados às seções de resultados.",
	"Default visualization": "Visualização padrão",
	"displays the initial visualization.": "exibe a visualização inicial.",
	"Visualization": "Visualização",
	"Visualization info": "Informações de visualização",
	"Survey created successfully!": "Levantamento criado com sucesso!"
});
Object.assign(dictionary, {
	"Survey completed successfully": "Levantamento concluído com sucesso",
	"Participation deleted successfully": "Participação excluída com sucesso",
	"Survey deleted successfully": "Levantamento excluído com sucesso"
});
Object.assign(dictionary, {
	'Tool results': 'Resultados da ferramenta',
	'AEP results': 'Resultados AEP',
	'Individual evaluations': 'Avaliações individuais',
	'Attach B: Questions by category': 'Anexo B: Perguntas por categoria',
	'Final result HSE-IT': 'Resultado final HSE-IT',
	'Risk matrix HSE-IT': 'Matriz de risco HSE-IT',
	'Keep filters': 'Manter filtros',
	'AEP Results': 'Resultados AEP',
	'AEP': 'AEP',
	'Not assessed': 'Não avaliado',
	'Notifications failed': 'Notificações com falha',
	'Survey created. Email notification failed; retry notification.': 'Levantamento criado. O envio dos e-mails falhou; tente notificar novamente.',
	'Some participants could not be notified; retry notification.': 'Alguns participantes não puderam ser notificados; tente notificar novamente.',
	'Assessment developed using the Kinebot platform. The collected data is entirely the responsibility of the client. Kinebot is not responsible for any actions taken based on this communication or for any consequences resulting from its use.': 'Avaliação desenvolvida usando a plataforma Kinebot. Os dados recolhidos são de inteira responsabilidade do cliente. A Kinebot não se responsabiliza por quaisquer ações tomadas com base nesta comunicação ou por quaisquer consequências resultantes de seu uso.'
});
Object.assign(dictionary, {
	'Learn more': 'Saiba mais',
	'Value': 'Valor',
	'Category average': 'Média da categoria',
	'Risk classification': 'Classificação do risco',
	'The risk priority number (RPN) is the product of consequence, exposure and probability, each scored from 1 to 6.': 'O número de prioridade de risco (RPN) é o produto de consequência, exposição e probabilidade, cada um pontuado de 1 a 6.',
	'The probability is suggested from the HSE-IT category average and can be adjusted.': 'A probabilidade é sugerida a partir da média da categoria no HSE-IT e pode ser ajustada.',
	'Delete this action plan?': 'Excluir este plano de ação?',
	'After saving, add priority, tasks and attachments to the action plan.': 'Após salvar, adicione prioridade, tarefas e anexos ao plano de ação.',
	'Unanswered surveys': 'Avaliações não respondidas',
	'Results, risk matrix and action plans will be available once the survey is completed.': 'Resultados, matriz de risco e planos de ação estarão disponíveis quando o levantamento for finalizado.',
	"Completion date (earliest)": "Data de conclusão (mais próxima)",
	"Completion date (latest)": "Data de conclusão (mais distante)",
	"Do you want to complete the survey": "Deseja concluir o levantamento",
	"Do you want to delete the survey": "Deseja excluir o levantamento",
	"Complete": "Concluir",
	"Are you sure you want to delete the participation": "Pretende mesmo excluir a avaliação",
	"Delete participation": "Excluir avaliação",
	"QR Code copied to clipboard": "QR Code copiado para a área de transferência",
	"Failed to copy QR Code": "Falha ao copiar o QR Code",
	"Copy": "Copiar",
	"Failed to generate QR Code": "Falha ao gerar o QR Code",
	"Download QR Code": "Baixar QR Code",
	"Survey created. Responses will be accepted until": "Levantamento criado. As respostas serão aceitas até dia",
	"Please fill in the required fields": "Preencha os campos obrigatórios",
	"To ensure anonymity, the sample must have at least 5 employees. Currently, the selection does not meet this requirement. By continuing, the confidentiality of the respondents will be compromised.": "Para garantir o anonimato, a amostra deve ter pelo menos 5 funcionários. Atualmente, a seleção não atende a esse requisito. Ao continuar, a confidencialidade dos respondentes será comprometida.",
});
Object.assign(dictionary, {
	"Your access PIN has been sent by email. It is valid for 10 minutes.": "Seu PIN de acesso foi enviado por e-mail. Ele é válido por 10 minutos.",
	"Too many attempts. Please try again in 5 minutes.": "Muitas tentativas. Tente novamente em 5 minutos.",
	"Too many attempts. Please try again in a few minutes.": "Muitas tentativas. Tente novamente em alguns minutos.",
	"Your session has expired. Please access the evaluation again.": "Sua sessão expirou. Acesse a avaliação novamente.",
	"Available until": "Disponível até",
	"Please fill this field": "Preencha este campo",
	"PIN digit": "Dígito do PIN",
	"This psychosocial evaluation is no longer available": "Esta avaliação psicossocial não está mais disponível",
	"The evaluation was closed or its deadline has passed.": "A avaliação foi encerrada ou o prazo terminou.",
	"Invalid evaluation link": "Link de avaliação inválido",
	"Check the link you received or ask the person responsible for the evaluation for a new one.": "Verifique o link recebido ou solicite um novo ao responsável pela avaliação.",
	"You have already answered this evaluation": "Você já respondeu esta avaliação",
	"Thank you for your participation.": "Obrigado pela sua participação.",
	"This evaluation has already received all expected responses": "Esta avaliação já recebeu todas as respostas esperadas",
	"Contact the person responsible for the evaluation if you have not answered it yet.": "Entre em contato com o responsável pela avaliação se você ainda não respondeu.",
	"Your evaluation has been completed! Notify the evaluator": "Sua avaliação foi concluída! Avise o avaliador",
	"Open surveys": "Levantamentos abertos",
	"Completed surveys": "Levantamentos concluídos",
	"You have no open surveys": "Você não possui levantamentos abertos",
	"You have not completed any survey yet": "Você ainda não concluiu nenhum levantamento",
	"Open": "Aberta",
	"Closed": "Encerrada",
	"Completed on": "Concluída em",
	"Answer": "Responder",
	"Start individual collection": "Iniciar coleta individual",
	"No email is registered for this employee. Contact the person responsible for the survey.": "Não há e-mail cadastrado para este colaborador. Entre em contato com o responsável pelo levantamento."
});
Object.assign(dictionary, {
	"This employee is already in the list": "Este colaborador já está na lista",
	"Employees created successfully!": "Colaboradores criados com sucesso!",
	"Employee updated successfully!": "Colaborador atualizado com sucesso!",
	"Employee created successfully!": "Colaborador criado com sucesso!",
	"Leave blank to generate a code automatically": "Deixe em branco para gerar um código automaticamente",
	"Add employee to list": "Adicionar colaborador à lista",
	"Spreadsheet line": "Linha da planilha",
	"Created employees": "Colaboradores criados",
	"Updated employees": "Colaboradores atualizados",
	"Name and line are required. Employees whose code already exists are updated, and a blank code is generated automatically.": "Nome e linha são obrigatórios. Colaboradores cujo código já existe são atualizados, e um código em branco é gerado automaticamente.",
	"Download errors": "Baixar erros",
	"Export file": "Exportar arquivo",
	"No data to export": "Não há dados para exportar",
	"Employee deleted successfully!": "Colaborador excluído com sucesso!",
	"Less than a month": "Menos de um mês",
	"year(s)": "ano(s)",
	"month(s)": "mês(es)"
});
Object.assign(dictionary, {
	ControlV2: 'Controle',
	ChangeV2: 'Mudança'
});
Object.assign(dictionary, {
	'Survey management': 'Gestão de levantamentos',
	'View employee list': 'Visualizar lista de participantes',
	'Survey information': 'Informações do levantamento',
	'Do you want': 'Deseja',
	'to delete': 'excluir',
	'the survey': 'o levantamento',
	'to complete': 'encerrar',
	'View survey': 'Ver levantamento',
	'Risk matrix updated successfully!': 'Matriz de risco atualizada com sucesso!',
	'Employee education created successfully!': 'Educação do funcionário criada com sucesso!',
	'Employee work shift created successfully!': 'Turno de trabalho do funcionário criado com sucesso!',
	'Unable to export employees': 'Não foi possível exportar os funcionários',
	'Export request already in progress': 'Já existe uma exportação em andamento'
});
Object.assign(dictionary, {
	'Incomplete elementary school education': 'Ensino fundamental incompleto',
	'Complete elementary school education': 'Ensino fundamental completo',
	'Incomplete high school education': 'Ensino médio incompleto',
	'Complete high school education': 'Ensino médio completo',
	'Incomplete university education': 'Ensino superior incompleto',
	'Post-graduation': 'Pós-graduação',
	'Evening': 'Vespertino',
	'Night': 'Noturno',
	'To do': 'A fazer',
	'Do you want to delete the action plan': 'Deseja excluir o plano de ação',
	'Answer the survey': 'Responder o levantamento',
	'If the button does not work, copy and paste this link into your browser:': 'Se o botão não funcionar, copie e cole este link no seu navegador:'
});
export default dictionary;
